/* eslint-disable react/jsx-pascal-case */
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
    toNumber,
    get,
    getItemFromArray,
    BaseURL,
    replaceVariables,
    ConvertCutoutNameForDecks,
    GetHTMLColour,
    getPointForRef,
    midPointRef,
    convertRoleCodeToName,
} from "../../components/Common";
import { API_BASE } from "../../AppConfig";
import AreaSelectField from "../../components/AreaSelectField";
import SpecModifyAttachmentDialog from "../context_options/SpecModifyAttachmentDialog";
import SpecModifyBeamDialog from "../context_options/SpecModifyBeamDialog";
import SpecModifyPostDialog from "../context_options/SpecModifyPostDialog";
import SpecNotesDialog from "../context_options/SpecNotesDialog";
import SpecModifyDownpipeDialog from "../context_options/SpecModifyDownpipeDialog";
import SegmentedButtonGroup from "../../components/SegmentedButtonGroup";
import _debounce from "lodash/debounce";
import BabylonSceneCanvas from "./design_cloud_3d_model/BabylonSceneCanvas";
import paper from "paper";
import PropTypes from "prop-types";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import * as Paper from "./PaperFunctions";
import Popover from "@material-ui/core/Popover";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import MenuItem from "@material-ui/core/MenuItem";
import Divider from "@material-ui/core/Divider";
import InputAdornment from "@material-ui/core/InputAdornment";
import ListSubheader from "@material-ui/core/ListSubheader";
import ZoomOutMapIcon from "@material-ui/icons/ZoomOutMap";
import ZoomInIcon from "@material-ui/icons/ZoomIn";
import ZoomOutIcon from "@material-ui/icons/ZoomOut";
import TuneIcon from "@material-ui/icons/Tune";
import Icon from "@material-ui/core/Icon";
import Crosshairs from "../../components/Crosshairs";
import * as COMMON from "../../components/Common";
import PhotoCameraIcon from "@material-ui/icons/PhotoCamera";
import { SHOW_DESIGNER_MESSAGE } from "../../redux_store/jobState";

// Redux Actions
import { connect } from "react-redux";
import * as APP from "../../redux_store/appState";
import * as CONFIG from "../../redux_store/configState";
import {
    updateAreaSpecification,
    updateAreaSpecificationManual,
    uploadDocument,
    updateAreaSpecificationJob,
    updateAreaSpecificationModificationArray,
    deleteFromAreaSpecificationModificationArray,
} from "../../redux_store/jobState";
import { BASIC_SPECS_SECTIONS } from "../../redux_store/jobState_Schemas";
import SpecModifyBeamPostsDialog from "../context_options/SpecModifyBeamPostsDialog";
import Message from "../../components/Message";
import BSL_TextInput from "../../components/BSL_TextInput";
import SpecExtraBeamDialog from "../context_options/SpecExtraBeamDialog";
import SpecSlatsTool from "../context_options/SpecSlatsTool";

import {
    THREED_MODE,
    THREED_MINI_MODE,
    SHOW_DISPLAY_OPTIONS,
    DRAWER_TOOLSET_EXPANDED,
    SHOW_MESSAGE,
    toggleDesigner,
    update2DDesigner,
    showDesignerMessage,
    showDialog,
} from "../../redux_store/appState";
import { updateLayout2D, updateLayout3D, setToolSetArea, setToolSetAreaOnly } from "../../redux_store/appStateHelper";
import SpecModifyAttachmentDialog2 from "../context_options/SpecModifyAttachmentDialog2";
import { GetColourUpdateString, GetShapeUpdateString } from "./PaperFunctionHelper";
import HorizontalSplitIcon from "@material-ui/icons/HorizontalSplit";
import BSL_Button from "../../components/BSL_Button";
import BSL_Select from "../../components/BSL_Select";
import { useScene } from "./design_cloud_3d_model/BabylonSceneProvider";

// Required for jest tests
import * as PaperDesigner from "./PaperDesigner";
import SpecExtendBeams from "../context_options/SpecExtendBeams";
import SpecMoveDownlight from "../context_options/SpecMoveDownlight";
import SpecMoveFan from "../context_options/SpecMoveFan";
import SpecMoveSplice from "../context_options/SpecMoveSplice";

const importedActions = {
    updateAreaSpecification,
    updateAreaSpecificationManual,
    updateAreaSpecificationJob,
    updateAreaSpecificationModificationArray,
    deleteFromAreaSpecificationModificationArray,
    showDialog,
    setToolSetArea,
    setToolSetAreaOnly,
    toggleDesigner,
    updateLayout2D,
    update2DDesigner,
    showDesignerMessage,
    uploadDocument,
};
const mapStateToProps = (state) => ({
    app: state.app,
    job: state.job,
    config: state.config,
});

const chip_width = "1rem";

const styles = (theme) => ({
    qq2dCanvasContainer: {
        zIndex: 0,
        display: "block",
        position: "absolute",
        top: "0px",
        right: "0px",
        backgroundColor: "rgba(255, 255, 255, 255)",
        width: "100%",
        height: "100%",
        color: "#000",
        transition: "visibility 0.3s, opacity 0.3s linear",
        textAlign: "left",
    },

    qq2dCanvas: {
        width: "100vw",
        height: "100vh",
    },
    snackbar: {
        zIndex: "1300",
    },
    typography: {
        padding: "20px",
    },
    menu_item: {
        fontFamily: theme.typography.fontFamily,
        "&:hover": {
            background: "#b9c9e6",
        },
    },
    popover: {
        paddingTop: "10px",
        fontFamily: theme.typography.fontFamily,
    },
    pop_header: {
        padding: "0 16px",
        background: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        fontFamily: theme.typography.fontFamilySecondary,
    },
    pop_specs_header: {
        margin: "10px 0px",
        padding: "0px 10px",
        background: "#e8e8e8",
    },
    pop_specs: {
        padding: "0px 10px",
        color: "dark grey",
        fontFamily: theme.typography.fontFamily,
    },
    pop_specs_small_text: {
        width: "100%",
        justifyContent: "flex-end",
        fontSize: "10px",
        top: "-5px",
        paddingRight: "18px",
        height: "16px",
        "&:hover": {
            color: "#bb6a00",
        },
    },
    super_text: {
        fontSize: "9px",
        paddingLeft: "4px",
        marginTop: "-4px",
        color: "chocolate",
        textTransform: "uppercase",
    },
    divider: {
        height: "3px",
        margin: "7px",
        background: "orange",
    },
    calculating: {
        color: "#ffffff",
        position: "fixed",
        zIndex: "10000",
        fontSize: "7pt",
        paddingLeft: "66px",
    },
    roofsheet_chip: {
        borderRadius: chip_width,
        border: "1px solid grey",
        paddingLeft: "0.5rem",
        paddingRight: "0.5rem",
        marginRight: "0.5rem",
        minWidth: chip_width,
        minHeight: chip_width,
        background: "#ffffff",
        display: "inline",
    },
    mini_button: {
        position: "absolute",
        right: "10px",
        lineHeight: 1.25,
        paddingTop: "5px",
    },
});

var _this = {};

const hitOptions = {
    // Trigger hit only on 'fill' part of the path with 0 tolerance
    segments: false,
    stroke: false,
    fill: true,
    tolerance: 6,
    match: (res) => {
        return res?.item?.ref;
    },
};

export function wipe_start_end_marks() {
    if (paper.project.activeLayer.start_mark) {
        paper.project.activeLayer.start_mark.visible = false;
        paper.project.activeLayer.start_mark.remove();
        paper.project.activeLayer.start_mark = null;
    }
    if (paper.project.activeLayer.end_mark) {
        paper.project.activeLayer.end_mark.visible = false;
        paper.project.activeLayer.end_mark.remove();
        paper.project.activeLayer.end_mark = null;
    }
}

function GetRefs(pop_item, area_design_specs) {
    const DesignType = area_design_specs?.SHAPE?.DesignType;

    let is_portal = DesignType === CONFIG.DESIGN_TYPES.GABLE_PORTAL;

    let IS_CUTOUT =
        pop_item.ref.startsWith("BackLeft") ||
        pop_item.ref.startsWith("BackRight") ||
        pop_item.ref.startsWith("BackMid") ||
        pop_item.ref.startsWith("FrontLeft") ||
        pop_item.ref.startsWith("FrontRight") ||
        pop_item.is_cutout;

    let AttachmentRef = "";
    let GutterRef = "";
    let CutoutPrefix = "";
    let CutoutSide = "";

    let ref = pop_item.ref;
    if (!ref || ref === true || ref === "unknown") ref = "";
    let ref2 = pop_item.ref2;
    if (!ref2 || ref2 === true || ref2 === "unknown") ref2 = "";

    if (IS_CUTOUT) {
        if (ref) {
            if (ref.startsWith("CFL") || ref.startsWith("FrontLeft")) CutoutPrefix = "FrontLeft";
            else if (ref.startsWith("CFR") || ref.startsWith("FrontRight")) CutoutPrefix = "FrontRight";
            else if (ref.startsWith("CBL") || ref.startsWith("BackLeft")) CutoutPrefix = "BackLeft";
            else if (ref.startsWith("CBM") || ref.startsWith("BackMid")) CutoutPrefix = "BackMid";
            else if (ref.startsWith("CBR") || ref.startsWith("BackRight")) CutoutPrefix = "BackRight";

            if (ref.includes("-Attachment")) AttachmentRef = ref;
            if (ref.includes("-HasGutter")) GutterRef = ref;
        }
        if (ref2) {
            if (!CutoutPrefix) {
                if (ref2.startsWith("CFL") || ref2.startsWith("FrontLeft")) CutoutPrefix = "FrontLeft";
                else if (ref2.startsWith("CFR") || ref2.startsWith("FrontRight")) CutoutPrefix = "FrontRight";
                else if (ref2.startsWith("CBL") || ref2.startsWith("BackLeft")) CutoutPrefix = "BackLeft";
                else if (ref2.startsWith("CBM") || ref2.startsWith("BackMid")) CutoutPrefix = "BackMid";
                else if (ref2.startsWith("CBR") || ref2.startsWith("BackRight")) CutoutPrefix = "BackRight";
            }

            if (ref2.includes(" C")) CutoutSide = "C";
            else if (ref2.includes(" A2")) CutoutSide = "A2";
            else if (ref2.includes(" A")) CutoutSide = "A";
            else if (ref2.includes(" Y2")) CutoutSide = "Y2";
            else if (ref2.includes(" Y")) CutoutSide = "Y";
            else if (ref2.includes(" X")) CutoutSide = "X";
        }

        if (CutoutPrefix) {
            if (AttachmentRef == "") {
                AttachmentRef = CutoutPrefix + "-Attachment";
            }
            if (!AttachmentRef.endsWith(CutoutSide)) {
                if (CutoutSide === "A2" || CutoutSide === "A" || CutoutSide === "Y2" || CutoutSide === "Y") {
                    AttachmentRef += CutoutSide;
                }
            }

            if (CutoutSide != "" && CutoutSide !== "C" && CutoutSide !== "X" && !AttachmentRef.endsWith(CutoutSide)) {
                AttachmentRef += CutoutSide;
            }
            if (CutoutSide === "A") {
                if (CutoutPrefix !== "BackMid" && AttachmentRef.endsWith("A")) {
                    AttachmentRef = CutoutPrefix + "-Attachment";
                }
            }

            if (GutterRef == "") {
                if (CutoutSide === "C") {
                    let index = toNumber(ref2.split("/")[1]);
                    GutterRef = CutoutPrefix + "-" + index + "-CustomHasGutter";
                } else {
                    GutterRef = CutoutPrefix + "-HasGutter";

                    if (CutoutSide != "" && CutoutSide === "A" && !GutterRef.endsWith("X")) {
                        GutterRef += "X";
                    } else if (CutoutSide != "" && !GutterRef.endsWith(CutoutSide)) {
                        GutterRef += CutoutSide;
                    }
                }
            }

            if (CutoutSide === "C" && !AttachmentRef.includes("CustomHasAttachment")) {
                AttachmentRef = GutterRef.replace("CustomHasGutter", "CustomHasAttachment");
            }
        }
    } else {
        // not cutout
        if (ref) {
            if (ref.includes("Gutter")) GutterRef = ref;
            if (ref.includes("Attachment")) AttachmentRef = ref;
        }
        if (ref2) {
            if (ref2.includes("Gutter")) GutterRef = ref;
            if (ref2.includes("Attachment")) AttachmentRef = ref;
        }

        if (AttachmentRef === "") {
            // need to infer from side text
            if (ref.includes("Left") || ref2.includes("Left")) AttachmentRef = "AttachmentLeft";
            else if (ref.includes("Right") || ref2.includes("Right")) AttachmentRef = "AttachmentRight";
            else if (ref.includes("Back") || ref2.includes("Back") || ref.includes("Top") || ref2.includes("Top"))
                AttachmentRef = "AttachmentTop";
            else if (
                ref.includes("Front") ||
                ref2.includes("Front") ||
                ref.includes("Bottom") ||
                ref2.includes("Bottom")
            )
                AttachmentRef = "AttachmentBottom";

            if (AttachmentRef === "") {
                // still not found, try other ways
                if (pop_item.is_beam) {
                    if (pop_item.typeQQ === "beam3") {
                        //need to find which side its on

                        if (is_portal) {
                            if (pop_item.typeQQ === "beam3") {
                                //need to find which side its on
                                if (pop_item.ref4) {
                                    let ref4 = pop_item.ref4.split("/");
                                    if (toNumber(ref4[1]) < 1000) {
                                        AttachmentRef = "AttachmentBottom";
                                    } else {
                                        AttachmentRef = "AttachmentTop";
                                    }
                                }
                            } else if (pop_item.infill_1_beam !== undefined) {
                                AttachmentRef = "AttachmentLeft";
                            } else if (pop_item.infill_2_beam !== undefined) {
                                AttachmentRef = "AttachmentRight";
                            }
                        } else {
                            if (pop_item.ref4) {
                                let ref4 = pop_item.ref4.split("/");
                                if (toNumber(ref4[0]) < 1000) {
                                    AttachmentRef = "AttachmentLeft";
                                } else {
                                    AttachmentRef = "AttachmentRight";
                                }
                            }
                        }
                    }
                } else if (pop_item.is_infill && is_portal) {
                    if (pop_item.sel_type === "infill_1") {
                        AttachmentRef = "AttachmentLeft";
                    } else {
                        AttachmentRef = "AttachmentRight";
                    }
                }
            }
        }

        if ((AttachmentRef === "" || AttachmentRef.includes("Gutter")) && GutterRef != "") {
            if (GutterRef.includes("GutterL")) AttachmentRef = "AttachmentLeft";
            else if (GutterRef.includes("GutterR")) AttachmentRef = "AttachmentRight";
            else if (GutterRef.includes("GutterB")) AttachmentRef = "AttachmentTop";
            else if (GutterRef.includes("GutterF")) AttachmentRef = "AttachmentBottom";
        }

        if (pop_item.at_attachment && AttachmentRef != "" && !GutterRef.startsWith("Gutter")) {
            GutterRef = "";
        }

        if (GutterRef === "" && AttachmentRef != "") {
            if (AttachmentRef.includes("Left")) GutterRef = "GutterL";
            else if (AttachmentRef.includes("Right")) GutterRef = "GutterR";
            else if (AttachmentRef.includes("Back") || AttachmentRef.includes("Top")) GutterRef = "GutterB";
            else if (AttachmentRef.includes("Front") || AttachmentRef.includes("Bottom")) GutterRef = "GutterF";
        }

        GutterRef = GutterRef.replace("AttachmentGutter", "Gutter");
    }

    return {
        GutterRef: GutterRef,
        AttachmentRef: AttachmentRef,
        CutoutPrefix: CutoutPrefix,
        IsCutout: IS_CUTOUT,
    };
}

export function UpdateComponent(props) {
    const dispatch = useDispatch();
    window.dispatch = dispatch;
    const threeDMode = useSelector((state) => state.app.designer[APP.THREED_MODE]);
    const threeDMiniMode = useSelector((state) => state.app.designer[APP.THREED_MINI_MODE]);
    const AREA_INDEX = useSelector((state) => state.app.designer.designer2D?.[APP.AREA_INDEX]);
    const toolopen = useSelector((state) => state.app.designer.designer3D?.[APP.DRAWER_TOOLSET_EXPANDED]);
    const [last_areaIndex, setlast_areaIndex] = React.useState(-1);
    const [last_loaded_svg_hash, setlast_loaded_svg_hash] = React.useState(null);
    const [debounce2dtimeout, setdebounce2dtimeout] = React.useState(100);

    const job = useSelector((state) => state.job);
    let colour_change = GetColourUpdateString(false, job);
    const svg = useSelector((state) => state.job.App.current_SVG);

    const LoadSVG = (quote_number, svg_filename, zoom_all = false, clear_all = false, load_if_in_error = false) => {
        let this_svg_load_path = quote_number + "/" + svg_filename;
        if (window.last_svg_load_attempt === this_svg_load_path) return; //already try/loaded
        window.svg = null;

        let last_was_layout = window.last_svg_load_attempt.includes("layout.svg");
        if (last_was_layout) zoom_all = true;

        window.last_svg_load_attempt = quote_number + "/" + svg_filename;
        let url_base = API_BASE() + "svg/" + this_svg_load_path;

        if (window.svg_data) {
            url_base = URL.createObjectURL(new Blob([window.svg_data], { type: "image/svg+xml" }));
        }

        paper.project.importSVG(url_base, {
            onLoad: (new_item, svg_raw) => {
                if (!new_item) return;
                new_item.svg_filename = this_svg_load_path;
                new_item.scale(1);
                if (clear_all && paper.project.activeLayer.children.length > 1) {
                    paper.project.activeLayer.removeChildren(0, paper.project.activeLayer.children.length - 1);
                }

                window.svg = new_item;
                Paper.FormatSVGToJob();
                Paper.UpdateAllSVGMaterials();
                Paper.GetMetaData();
                if (zoom_all) Paper.zoomAll();
                window.load_2d_errors = 0;
            },
            onError: (message, status) => {
                if (!window.load_2d_errors) window.load_2d_errors = 1;
                else window.load_2d_errors++;
                if (load_if_in_error && window.load_2d_error < 3) dispatch(updateLayout2D());
                else if (clear_all) Paper.ClearAll();
            },
        });
    };

    const UpdateSVGsIfRequired = (svg_filename) => {
        if (!svg_filename) return;

        if (window.svg === null || !window.svg) {
            LoadSVG("local", svg_filename, true, true, true);
        } else if (window.svg.svg_filename === "local/" + svg_filename) {
            Paper.UpdateAllSVGMaterials();
            return; //same file name; ignore
        } else {
            LoadSVG("local", svg_filename, false, true, true);
        }
    };

    useEffect(() => {
        if (window.svg) {
            if (!window.job && job) window.job = { ...job };
            Paper.UpdateAllSVGMaterials();
        }
    }, [colour_change]);

    useEffect(() => {
        if (!window.job && job) window.job = { ...job };
        if (!svg) {
            window.last_svg_load_attempt = Date.now().toString();
            LoadSVG(job.id, "layout.svg", true, true, true);
        } else if (window.svg_data) {
        } else {
            UpdateSVGsIfRequired(svg);
        }
        Paper.ForceUpdate();
    }, [svg]);

    let shape_update = GetShapeUpdateString(threeDMode);

    useEffect(() => {
        if (threeDMode && !threeDMiniMode && toolopen !== APP.BEAMS_AND_POSTS_TOOL) {
        } else if (window.svg && !job?.App?.Locked) {
            setlast_loaded_svg_hash(shape_update);
            update2D();
        }
        window.shape_update_last = shape_update;
    }, [shape_update]);

    useEffect(() => {
        if (window.svg && (!threeDMode || (threeDMode && threeDMiniMode))) {
            if (last_areaIndex !== AREA_INDEX && AREA_INDEX > -1) {
                dispatch(APP.setDesignerLoadingBackdrop("Loading Area " + (AREA_INDEX + 1) + " Layout..."));
                setlast_areaIndex(AREA_INDEX);
            }
            dispatch(updateLayout2D()).then((result) => {
                setTimeout(
                    function () {
                        Paper.zoomAll(AREA_INDEX > -1 ? 0 : 300);
                    },
                    AREA_INDEX > -1 ? 700 : 1200
                );
                dispatch(APP.updateDesigner(APP.SHOW_LOADING_BACKDROP, false));
            });
        }
    }, [AREA_INDEX]);

    const update2D = React.useCallback(
        _debounce((name) => {
            dispatch(updateLayout2D());
            setdebounce2dtimeout(1000);
            setTimeout(function () {
                setdebounce2dtimeout(100);
            }, 1000);
        }, debounce2dtimeout),
        []
    );

    const update2DZoom = React.useCallback(
        _debounce((area_index) => {
            dispatch(updateLayout2D()).then((result) => {
                setTimeout(function () {
                    Paper.zoomAll(area_index > -1 ? 0 : 300);
                }, 500);
                dispatch(APP.updateDesigner(APP.SHOW_LOADING_BACKDROP, false));
            });
            setdebounce2dtimeout(1000);
            setTimeout(function () {
                setdebounce2dtimeout(100);
            }, 1000);
        }, debounce2dtimeout),
        []
    );

    useEffect(() => {
        if (!threeDMode || (threeDMode && threeDMiniMode)) {
            Paper.UpdateSkylights2D();
        }
        if ((!threeDMode || (threeDMode && threeDMiniMode)) && last_loaded_svg_hash !== shape_update) {
            setlast_loaded_svg_hash(shape_update);
            dispatch(updateLayout2D());
        } else {
        }
    }, [threeDMode, threeDMiniMode]); // eslint-disable-next-line react-hooks/exhaustive-deps

    return <></>;
}

const designerStyles = makeStyles({
    iconRoot: {
        textAlign: "center",
        display: "flex",
        alignItems: "center",
    },
    paper: {
        padding: "125px 20px 20px 20px",
        minWidth: "500px",
        maxWidth: "25%",
        backgroundColor: "#EDF0F3",
    },
});

export function DesignerTools(props) {
    const classes = designerStyles();

    const dispatch = useDispatch();
    const threeDMode = useSelector((state) => state.app.designer[THREED_MODE]);
    const threeDMiniMode = useSelector((state) => state.app.designer[THREED_MINI_MODE]);
    const obj_area_all = useSelector((state) => state.app.designer?.designer3D?.objs?.area_all);
    const freestanding = useSelector((state) => state?.job?.QuoteParameters?.FreeStanding);
    const showDisplayOptions = useSelector((state) => state.app.designer[SHOW_DISPLAY_OPTIONS]);
    const SELECT_POINT = useSelector((state) => state.app.designer.designer2D?.[APP.SELECT_POINT]);
    const job = useSelector((state) => state?.job);
    const carportMode = job?.DesignParameters?.CarportMode === 1;

    return (
        <div
            style={{
                position: "fixed",
                bottom: "28px",
                left: "98px",
                zIndex: "9",
                display: "flex",
                flexDirection: "row",
                pointerEvents: "none",
            }}
        >
            {!carportMode && (
                <SegmentedButtonGroup
                    value={threeDMode ? (threeDMiniMode ? "Split" : "Model") : "Plan"}
                    disabled={SELECT_POINT}
                    style={{
                        marginRight: "5px",
                        pointerEvents: "all",
                    }}
                    items={[
                        {
                            Key: "Plan",
                            Display: (
                                <>
                                    <Icon className={classes.iconRoot}>
                                        <img
                                            src={BaseURL(
                                                "/images/" + (!threeDMode ? "plan-view-active.svg" : "plan-view.svg")
                                            )}
                                        />
                                    </Icon>
                                    Plan View
                                </>
                            ),
                        },
                        {
                            Key: "Split",
                            Display: (
                                <>
                                    <Icon className={classes.iconRoot}>
                                        <HorizontalSplitIcon />
                                    </Icon>
                                    Split
                                </>
                            ),
                        },
                        {
                            Key: "Model",
                            Display: (
                                <>
                                    <Icon className={classes.iconRoot}>
                                        <img
                                            src={BaseURL(
                                                "/images/" +
                                                    (threeDMode && !threeDMiniMode ? "3d-active.svg" : "3d.svg")
                                            )}
                                        />
                                    </Icon>
                                    Model View
                                </>
                            ),
                        },
                    ]}
                    onChange={(e, val) => {
                        if (val == "Split") {
                            dispatch(APP.updateDesigner(THREED_MODE, true));
                            if (threeDMiniMode === true) dispatch(APP.updateDesigner(THREED_MINI_MODE, "rotated"));
                            else dispatch(APP.updateDesigner(THREED_MINI_MODE, true));
                            if (obj_area_all === null) dispatch(updateLayout2D());
                        } else if (val == "Model") {
                            dispatch(APP.updateDesigner(THREED_MODE, true));
                            dispatch(APP.updateDesigner(THREED_MINI_MODE, false));
                            if (obj_area_all === null) dispatch(updateLayout3D());
                        } else {
                            dispatch(APP.updateDesigner(THREED_MODE, false));
                            dispatch(APP.updateDesigner(THREED_MINI_MODE, false));
                        }
                    }}
                    onClick={(e, val) => {
                        if (val == "Split") {
                            if (threeDMiniMode === true) dispatch(APP.updateDesigner(THREED_MINI_MODE, "rotated"));
                            else dispatch(APP.updateDesigner(THREED_MINI_MODE, true));
                        }
                    }}
                />
            )}
            <SegmentedButtonGroup
                value={showDisplayOptions}
                style={{
                    marginRight: "0px",
                    pointerEvents: "all",
                }}
                items={[
                    {
                        Key: true,
                        Display: (
                            <>
                                <TuneIcon style={{ marginRight: "2px" }} /> Display Options
                            </>
                        ),
                    },
                ]}
                onChange={(e, val) => {
                    dispatch(toggleDesigner(SHOW_DISPLAY_OPTIONS));
                }}
            />
            {!freestanding && (
                <div
                    style={{
                        paddingTop: "14px",
                        paddingLeft: "10px",
                        width: "400px",
                        textAlign: "left",
                        fontStyle: "italic",
                        color: threeDMode ? "#cdd3e0" : "#37455f",
                        pointerEvents: "none",
                    }}
                >
                    *Attachment brackets shown are indicative only.
                    <br />
                    Actual location and number to be determined on site by builder.
                </div>
            )}
        </div>
    );
}

export function ThreeDScreenshot() {
    const dispatch = useDispatch();

    const jobId = useSelector((state) => state?.job?.id);
    const threeDMode = useSelector((state) => state?.app?.designer[THREED_MODE]);
    const redux3DScreenshot = useSelector((state) => state?.job?.QuoteParameters?.DOCUMENTS?.["3DScreenShots"]?.[0]);

    const [showImage, setShowImage] = useState(false);
    const [local3DScreenshot, setLocal3DScreenshot] = useState(null);
    const [isFadingOut, setIsFadingOut] = useState(false);
    const [isButtonDisabled, setIsButtonDisabled] = useState(false);

    const imageUrl = redux3DScreenshot ? `${API_BASE()}document/${jobId}/${redux3DScreenshot}` : null;

    const sceneMgr = useScene();

    const takeScreenshot = async () => {
        setIsButtonDisabled(true);

        const filename = `${Date.now()}.png`;
        const data = await sceneMgr.takeScreenshot();

        dispatch(uploadDocument("3DScreenShots", filename, data));
        setLocal3DScreenshot(filename);
    };

    useEffect(() => {
        if (local3DScreenshot && redux3DScreenshot?.includes(local3DScreenshot)) {
            if (!imageUrl) {
                setIsButtonDisabled(false);
                return;
            }

            let attemptsLeft = 10;

            const loadImage = () => {
                const img = new Image();
                img.src = imageUrl;

                img.onload = () => {
                    dispatch({
                        type: SHOW_DESIGNER_MESSAGE,
                        message: {
                            message: "Screenshot saved to Display Options",
                            type: "success",
                        },
                    });
                    setShowImage(true);
                };

                img.onerror = () => {
                    if (attemptsLeft > 0) {
                        attemptsLeft -= 1;
                        setTimeout(loadImage, 500);
                    } else {
                        dispatch({
                            type: SHOW_DESIGNER_MESSAGE,
                            message: {
                                message: "Screenshot failed to save. Please try again",
                                type: "error",
                            },
                        });
                        setShowImage(false);
                        setIsButtonDisabled(false);
                    }
                };
            };

            loadImage();
        }
    }, [redux3DScreenshot, imageUrl, local3DScreenshot, dispatch]);

    useEffect(() => {
        if (!showImage) return;

        const displayDuration = 2000;
        const fadeOutDuration = 2000;

        const fadeOutTimer = setTimeout(() => {
            setIsFadingOut(true);
        }, displayDuration);

        const hideImageTimer = setTimeout(() => {
            setShowImage(false);
            setIsFadingOut(false);
            setIsButtonDisabled(false);
        }, displayDuration + fadeOutDuration);

        return () => {
            clearTimeout(fadeOutTimer);
            clearTimeout(hideImageTimer);
        };
    }, [showImage]);

    return (
        <div>
            {threeDMode && (
                <>
                    <BSL_Button
                        onClick={takeScreenshot}
                        disabled={isButtonDisabled}
                        style={{
                            position: "fixed",
                            top: "93px",
                            left: "98px",
                            zIndex: 56,
                            backgroundColor: "transparent",
                            border: "none",
                            cursor: isButtonDisabled ? "not-allowed" : "pointer",
                            padding: 0,
                            display: "flex",
                            alignItems: "center",
                        }}
                    >
                        <PhotoCameraIcon
                            style={{
                                color: isButtonDisabled ? "gray" : "black",
                                fontSize: "24px",
                                marginRight: "2px",
                            }}
                        />
                    </BSL_Button>
                    {showImage && (
                        <img
                            src={imageUrl}
                            alt="3D Screenshot"
                            width="300px"
                            style={{
                                opacity: isFadingOut ? 0 : 1,
                                transition: "opacity 2s ease-in-out",
                                position: "fixed",
                                top: "158px",
                                left: "259px",
                                zIndex: 9,
                                transform: "translateX(-50%)",
                            }}
                        />
                    )}
                </>
            )}
        </div>
    );
}

export function ViewTools() {
    const threeDMode = useSelector((state) => state.app.designer[THREED_MODE]);
    const threeDMiniMode = useSelector((state) => state.app.designer[APP.THREED_MINI_MODE]);
    const sceneMgr = useScene();

    return (
        <div
            style={{
                position: "fixed",
                bottom: "80px",
                left: "98px",
                zIndex: "9",
            }}
        >
            <SegmentedButtonGroup
                vertical
                value={""}
                items={[
                    { Key: "Fit", Display: <ZoomOutMapIcon /> },
                    { Key: "ZommIn", Display: <ZoomInIcon /> },
                    { Key: "ZoomOut", Display: <ZoomOutIcon /> },
                ]}
                onChange={(e, val) => {
                    if (threeDMode) {
                        if (val === "ZommIn") sceneMgr.zoomIn();
                        if (val === "ZoomOut") sceneMgr.zoomOut();
                        if (val === "Fit") sceneMgr.centreModel(true);
                        if (threeDMiniMode) {
                            if (val === "Fit") Paper.zoomAll();
                            if (val === "ZommIn") Paper.zoomIn();
                            if (val === "ZoomOut") Paper.zoomOut();
                        }
                    } else {
                        if (val === "Fit") Paper.zoomAll();
                        if (val === "ZommIn") Paper.zoomIn();
                        if (val === "ZoomOut") Paper.zoomOut();
                    }
                }}
            />
        </div>
    );
}

class QQ2DCanvas extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            snack_open: false,
            message: "",
            show_pop: false,
            pop_location: { x: 200, y: 400 },
            pop_item: null,
            pop_textfield_text: null,
            OH_Front_text: null,
            OH_Back_text: null,
            mod_attachment_dialog: false,
            mod_attachment2_dialog: false,
            mod_attachment2_saveAction: null,
            mod_attachment_item: null,
            mod_beam_dialog: false,
            mod_beam_item: null,
            mod_beam_posts_dialog: false,
            mod_beam_posts_item: null,
            mod_post_dialog: false,
            mod_post_item: null,
            mod_downpipe_dialog: false,
            mod_downpipe_item: null,
            mod_extend_beam: false,
            mod_item: null,
            edit_extra_beam_dialog: false,
            mod_downpipe_item: null,
            beam_adjustment_display_value: null,
            gutter_dialog: false,
        };
    }

    attachSide =
        (areaIndex, attachment_tag, gutter_tag, unattach = false, job, pop_item) =>
        (event) => {
            this.setState({
                pop_item: null,
                show_pop: false,
            });

            let cutout = attachment_tag.startsWith("Back") || attachment_tag.startsWith("Front");
            let attachment_section = cutout ? BASIC_SPECS_SECTIONS.SHAPE : BASIC_SPECS_SECTIONS.ATTACHMENTS;
            let gutter_section = cutout ? BASIC_SPECS_SECTIONS.SHAPE : BASIC_SPECS_SECTIONS.GUTTERS_AND_DOWNPIPES;

            if (gutter_tag)
                this.props.updateAreaSpecificationJob(
                    areaIndex,
                    gutter_section,
                    cutout ? "CUTOUTS" : null,
                    gutter_tag,
                    unattach ? 1 : 0
                );
            if (attachment_tag) {
                this.props.updateAreaSpecificationJob(
                    areaIndex,
                    attachment_section,
                    cutout ? "CUTOUTS" : null,
                    attachment_tag + "Manual",
                    unattach ? 1 : 0
                );
                this.props
                    .updateAreaSpecificationJob(
                        areaIndex,
                        attachment_section,
                        cutout ? "CUTOUTS" : null,
                        attachment_tag,
                        unattach ? 0 : 1
                    )
                    .then(() => {
                        if (unattach) {
                            this.props
                                .deleteFromAreaSpecificationModificationArray(
                                    areaIndex,
                                    "ATTACHMENTS.AttachmentModifications",
                                    pop_item?.ref2,
                                    true
                                )
                                .then(() => {
                                    this.props.deleteFromAreaSpecificationModificationArray(
                                        areaIndex,
                                        "ATTACHMENTS.PARTIAL_ATTACHMENTS",
                                        pop_item?.ref2,
                                        false
                                    );
                                });
                        }
                    });
            }
        };

    toggleGutter =
        (areaIndex, gutter_tag, unattach = false) =>
        (event) => {
            this.setState({
                show_pop: false,
            });

            let cutout = gutter_tag.startsWith("Back") || gutter_tag.startsWith("Front");
            let gutter_section = cutout ? BASIC_SPECS_SECTIONS.SHAPE : BASIC_SPECS_SECTIONS.GUTTERS_AND_DOWNPIPES;

            this.props.updateAreaSpecificationJob(
                areaIndex,
                gutter_section,
                cutout ? "CUTOUTS" : null,
                gutter_tag,
                unattach ? 1 : 0
            );
        };

    updateGutter = (areaIndex, gutter_tag, value) => {
        this.setState({
            show_pop: false,
        });

        if (value == 0 || value == 2)
            if (
                (gutter_tag.toUpperCase() === "GUTTERB" &&
                    this.props.job.AreaSpecifications[areaIndex].ATTACHMENTS.AttachmentTop == 1) ||
                (gutter_tag.toUpperCase() === "GUTTERF" &&
                    this.props.job.AreaSpecifications[areaIndex].ATTACHMENTS.AttachmentBottom == 1) ||
                (gutter_tag.toUpperCase() === "GUTTERR" &&
                    this.props.job.AreaSpecifications[areaIndex].ATTACHMENTS.AttachmentRight == 1) ||
                (gutter_tag.toUpperCase() === "GUTTERL" &&
                    this.props.job.AreaSpecifications[areaIndex].ATTACHMENTS.AttachmentLeft == 1)
            ) {
                this.setState({ gutter_dialog: true });
                this.props.updateAreaSpecification(
                    areaIndex,
                    "Acknowledgements",
                    "BoxHouseGutterAcknowledgement",
                    false
                );
            }

        let cutout = gutter_tag.startsWith("Back") || gutter_tag.startsWith("Front");
        let gutter_section = cutout ? BASIC_SPECS_SECTIONS.SHAPE : BASIC_SPECS_SECTIONS.GUTTERS_AND_DOWNPIPES;

        //

        this.props.updateAreaSpecificationJob(areaIndex, gutter_section, cutout ? "CUTOUTS" : null, gutter_tag, value);

        return Promise.resolve("OK");
    };

    updateBeamMod =
        (areaIndex, ref, parameter, refresh_svg = true) =>
        (event) => {
            this.updateBeamModValue(areaIndex, ref, parameter, refresh_svg, event.target.value);
        };
    updateBeamModValue = (areaIndex, ref, parameter, refresh_svg = true, value = null) => {
        let beam_modifications = get(this.props.job, "AreaSpecifications." + areaIndex + ".BEAMMODIFICATIONS");

        let thisModification = null;
        let lastModification = {};

        if (ref) {
            for (var mod of beam_modifications) {
                if (mod.Ref === ref) thisModification = mod;
                if (mod.Ref === ref) lastModification = { ...mod };
            }
        }

        let newValue = value === "Default" ? "" : value;

        if (newValue === "" && thisModification === null) return; // no change, no mods
        else if (thisModification === null) {
            //new mod needed
            thisModification = {};
            thisModification.Ref = ref;

            let ref_split = ref.split(";");

            if (ref_split.length > 1) {
                thisModification.P1 = ref_split[0].replaceAll("/", ",");
                thisModification.P2 = ref_split[1].replaceAll("/", ",");
            }

            if (parameter === "Length" && newValue !== "") thisModification.Length = Number(newValue);
            else thisModification[parameter] = newValue;
            beam_modifications.push(thisModification);
        } else {
            if (parameter === "Length" && newValue !== "") thisModification.Length = Number(newValue);
            else thisModification[parameter] = newValue;
        }

        if (JSON.stringify(lastModification) !== JSON.stringify(thisModification)) {
            this.props.updateAreaSpecification(areaIndex, "BEAMMODIFICATIONS", null, beam_modifications);
        }
    };

    updateCustomCutoutValue = (areaIndex, in_ref, value, content_value) => {
        const cutouts = this.props.job?.AreaSpecifications?.[areaIndex]?.SHAPE?.CUTOUTS;

        let this_ref = in_ref.replace("-X", "").replace("-Y", "");
        let cutout_section = in_ref.split("-")[0];
        let num_point = toNumber(in_ref.split("-")[1]);

        let diff = null;

        if (num_point === toNumber(cutouts[cutout_section + "-CustomNumSegments"])) {
            // this is the end point, and hende needs to move the previous point
            diff = content_value - value;
            this_ref = cutout_section + "-" + (num_point - 1) + "-CustomPoint";
        }

        let xy = cutouts[this_ref];
        const orig_y = toNumber(xy.split(",")[1]);
        const orig_x = toNumber(xy.split(",")[0]);

        let x = orig_x;
        let y = orig_y;
        if (in_ref.includes("-X")) {
            if (diff !== null) {
                if (orig_x < 0) x += diff;
                else x += diff;
            } else {
                x = value;
                if (orig_x < 0) x = -x;
            }
        } else if (in_ref.includes("-Y")) {
            if (diff !== null) {
                if (orig_y < 0) y -= diff;
                else y += diff;
            } else {
                y = value;
                if (orig_y < 0) y = -y;
            }
        }

        this.props.updateAreaSpecification(areaIndex, "SHAPE.CUTOUTS", this_ref, "(" + x + "," + y + ")");
    };

    updatePAATParameter = (areaIndex, ref, param, value) => {
        let paats = this.props.job?.AreaSpecifications?.[areaIndex]?.ATTACHMENTS?.PARTIAL_ATTACHMENTS;

        let thisModification = null;
        if (ref && paats) {
            for (var mod of paats) {
                if (mod.Ref === ref) {
                    thisModification = { ...mod };
                }
            }
        }
        if (thisModification) {
            this.setState({
                show_pop: false,
            });

            thisModification[param] = value;
            this.props.updateAreaSpecificationModificationArray(
                areaIndex,
                "ATTACHMENTS.PARTIAL_ATTACHMENTS",
                thisModification.Ref,
                null,
                thisModification
            );
        }
        return Promise.resolve("OK");
    };
    updatePAATValue = (areaIndex, item, value, base_value) => {
        let paats = this.props.job?.AreaSpecifications?.[areaIndex]?.ATTACHMENTS?.PARTIAL_ATTACHMENTS;
        let name = item.ref.split("/")[0];
        let dim_index = Number(item.ref.split("/")[1]);

        let thisModification = null;
        let lastModification = {};
        if (item.ref && paats) {
            for (var mod of paats) {
                if (mod.Name === name) {
                    thisModification = mod;
                    lastModification = { ...mod };
                }
            }
        }
        if (thisModification) {
            let length = thisModification.Length;
            let offset = thisModification.Offset;
            if (thisModification.Kind === "NAN") {
                if (dim_index === 1) {
                    offset = value;
                    length = thisModification.Length - (value - base_value);
                }
                if (dim_index === 2) {
                    length = value;
                }
                if (dim_index === 3) {
                    length = thisModification.Length - (value - base_value);
                }
            } else if (thisModification.Kind === "AN") {
                if (dim_index === 1) {
                    length = value;
                }
                if (dim_index === 2) {
                    length = thisModification.Length - (value - base_value);
                }
            } else if (thisModification.Kind === "NA") {
                if (dim_index === 1) {
                    offset = value;
                    length = thisModification.Length - (value - base_value);
                }
                if (dim_index === 2) {
                    offset = thisModification.OffSet - (value - base_value);
                    length = value;
                }
            }
            if (length < 100) length = 100;
            if (offset < 0) offset = 0;
            thisModification.Length = length;
            thisModification.Offset = offset;
        }

        if (JSON.stringify(lastModification) !== JSON.stringify(thisModification)) {
            this.props.updateAreaSpecificationModificationArray(
                areaIndex,
                "ATTACHMENTS.PARTIAL_ATTACHMENTS",
                thisModification.Ref,
                null,
                thisModification
            );
        }
    };

    updateBeamAdjustment =
        (areaIndex, ref, parameter, refresh_svg = true) =>
        (event) => {
            this.updateBeamAdjustmentValue(areaIndex, ref, parameter, refresh_svg, event.target.value);
        };
    updateBeamAdjustmentValue = (areaIndex, ref, parameter, refresh_svg = true, value = null) => {
        let beam_adjustments = get(this.props.job, "AreaSpecifications." + areaIndex + ".BEAMADJUSTMENTS");

        let thisModification = null;
        let lastModification = {};

        if (ref) {
            for (var mod of beam_adjustments) {
                if (mod.Ref === ref) thisModification = mod;
                if (mod.Ref === ref) lastModification = { ...mod };
            }
        }

        let newValue = value === "Default" ? "" : value;
        if (newValue === "" && thisModification === null) return; // no change, no mods
        else if (thisModification === null) {
            //new mod needed
            thisModification = {};
            thisModification.Ref = ref;

            let ref_split = ref.split("/");

            if (ref_split.length > 1) {
                thisModification.Section = ref_split[0];
                thisModification.Num = Number(ref_split[1]);
            }
            if (parameter === "Adjustment" && newValue !== "") thisModification.Adjustment = Number(newValue);
            else thisModification[parameter] = newValue;
            beam_adjustments.push(thisModification);
        } else {
            thisModification[parameter] = newValue;
        }

        if (JSON.stringify(lastModification) !== JSON.stringify(thisModification)) {
            this.props.updateAreaSpecification(areaIndex, "BEAMADJUSTMENTS", null, beam_adjustments);
        }
    };

    updateExtraDeckPostDimension = (areaIndex, pop_item, adjustment_value, new_value) => {
        let ref_split = pop_item.ref.split("/");
        let ref = ref_split[1].replaceAll("|", ",");
        let original_pos = toNumber(ref_split[2]);
        let edit_post = getItemFromArray(
            this.props.job.AreaSpecifications[areaIndex]?.DECK_PARAMETERS?.DeckPosts,
            "ref_point",
            ref
        );
        if (edit_post) {
            let new_post = { ...edit_post };
            new_post.location = original_pos + adjustment_value;

            this.props.updateAreaSpecificationModificationArray(
                areaIndex,
                "DECK_PARAMETERS.DeckPosts",
                new_post.ref_point,
                null,
                new_post,
                true,
                null,
                "ref_point"
            );
        }
    };

    updateExtraBeamDimension = (areaIndex, pop_item, adjustment_value, new_value) => {
        let edit_beam = null;
        if (pop_item?.ref) {
            if (areaIndex > -1 && this.props.job.AreaSpecifications[areaIndex]?.NewBeams) {
                edit_beam = getItemFromArray(
                    this.props.job.AreaSpecifications[areaIndex]?.NewBeams,
                    "Ref",
                    pop_item.ref
                );
            } else {
                for (var this_areaIndex in this.props.job.AreaSpecifications) {
                    areaIndex = Number(this_areaIndex);
                    edit_beam = getItemFromArray(
                        this.props.job.AreaSpecifications[areaIndex].NewBeams,
                        "Ref",
                        pop_item.ref
                    );
                    if (edit_beam) break;
                }
            }

            if (edit_beam) {
                let end = 1;
                if (pop_item.offset2 !== undefined) end = 2;

                let new_beam = { ...edit_beam };

                if (end === 1) {
                    if (new_beam.Offset1 < 0) {
                        new_beam.Offset1 = new_value;
                    } else {
                        new_beam.Offset1 += adjustment_value;
                    }
                    new_beam.From1Side1 = Number(pop_item.side1);
                } else {
                    if (new_beam.Offset2 < 0) {
                        new_beam.Offset2 = new_value;
                    } else {
                        new_beam.Offset2 += adjustment_value;
                    }
                    new_beam.From1Side2 = Number(pop_item.side2);
                }
                this.props.updateAreaSpecificationModificationArray(
                    areaIndex,
                    "NewBeams",
                    new_beam.Ref,
                    null,
                    new_beam,
                    true
                );
            }
        }
    };

    handleAddDownpipe = (areaIndex, location) => {
        let x = location.x;
        let y = location.y;
        if (window.paper_origin) {
            x = x - window.paper_origin.x;
            y = -(y - window.paper_origin.y);
        }

        let position_text = "(" + x.toFixed(0) + "," + y.toFixed(0) + ",0)";
        let downpipe = {
            Ref: position_text,
            Position: position_text,
            Kind: "Ground - Connection by Owner",
        };
        this.props.updateAreaSpecificationModificationArray(
            areaIndex,
            BASIC_SPECS_SECTIONS.GUTTERS_AND_DOWNPIPES + ".Downpipes",
            position_text,
            null,
            downpipe
        );
    };

    handleRemovePortalColumn = (areaIndex, item) => {
        let ref = item.is_beam ? item.ref2 : item.ref4;
        let item_exists = false;
        const area_design_specs = this.props.job.AreaSpecifications?.[areaIndex];
        if (area_design_specs?.PORTALPOSTS) {
            for (let item of area_design_specs?.PORTALPOSTS) {
                if (item.Ref === ref) item_exists = true;
            }
        }

        if (item_exists) {
            //remove
            this.props.deleteFromAreaSpecificationModificationArray(areaIndex, "PORTALPOSTS", ref);
        } else {
            let ref_split = ref.split("/");
            let portalPost = {
                Ref: ref,
                Section: ref_split[0],
                Num: ref_split[1],
            };
            this.props.updateAreaSpecificationModificationArray(areaIndex, "PORTALPOSTS", ref, null, portalPost);
        }

        this.setState({
            show_pop: false,
        });
    };

    toggleDeleteBeam = (pop_item, areaIndex, deleteBeam) => {
        const area_design_specs = this.props.job.AreaSpecifications?.[areaIndex];
        const deleteBeams = { ...area_design_specs?.DeleteBeams };
        if (!deleteBeam) {
            //undelete
            if (deleteBeams[pop_item.ref2]) {
                delete deleteBeams[pop_item.ref2];
            }
        } else {
            deleteBeams[pop_item.ref2] = deleteBeam;
        }
        this.props.updateAreaSpecification(areaIndex, "DeleteBeams", null, deleteBeams);

        this.setState({
            show_pop: false,
        });
    };

    toggleDeletePost = (pop_item, areaIndex, deletePost) => {
        const area_design_specs = this.props.job.AreaSpecifications?.[areaIndex];
        const deletePosts = { ...area_design_specs?.DeletePosts };
        if (!deletePost) {
            //undelete
            if (deletePosts[pop_item.ref2]) {
                delete deletePosts[pop_item.ref2];
            }
        } else {
            deletePosts[pop_item.ref2] = deletePost;
        }
        this.props.updateAreaSpecification(areaIndex, "DeletePosts", null, deletePosts);

        this.setState({
            show_pop: false,
        });
    };

    handleSwapPostAlignment = (areaIndex, item) => {
        const area_design_specs = this.props.job.AreaSpecifications?.[areaIndex];
        let mod = null;
        if (area_design_specs?.POSTMODIFICATIONS) {
            for (let this_mod of area_design_specs?.POSTMODIFICATIONS) {
                if (this_mod.Ref === item.ref || this_mod.Ref2 === item.ref2) mod = this_mod;
            }
        }

        if (mod) {
            //update
            mod.SwapAlignment = !mod?.SwapAlignment;
            if (
                !mod.SwapAlignment &&
                !mod.Section &&
                !mod.Colour &&
                !mod.Length &&
                !(mod.TopConnection == undefined || mod.TopConnection === "")
            ) {
                this.props.deleteFromAreaSpecificationModificationArray(areaIndex, "POSTMODIFICATIONS", item.ref, 50);
            } else {
                this.props.updateAreaSpecificationModificationArray(
                    areaIndex,
                    "POSTMODIFICATIONS",
                    item.ref,
                    null,
                    mod
                );
            }
        } else {
            // new mod
            let post_mod = {
                Ref: item.ref,
                Ref2: item.ref2,
                Position: item.ref.replaceAll("/", ","),
                Section: "",
                Colour: "",
                Length: "",
                SwapAlignment: "true",
                TopConnection: "",
            };
            this.props.updateAreaSpecificationModificationArray(
                areaIndex,
                "POSTMODIFICATIONS",
                item.ref,
                null,
                post_mod
            );
        }

        this.setState({
            show_pop: false,
        });
    };

    handleRemoveDownpipe = (areaIndex, location_ref) => {
        this.props.deleteFromAreaSpecificationModificationArray(
            areaIndex,
            BASIC_SPECS_SECTIONS.GUTTERS_AND_DOWNPIPES + ".Downpipes",
            location_ref,
            "closest"
        );
    };

    handleDisableAutoDownpipes = (areaIndex) => {
        this.props.updateAreaSpecification(
            areaIndex,
            BASIC_SPECS_SECTIONS.GUTTERS_AND_DOWNPIPES,
            "AddAutomaticDownpipes",
            false
        );
    };

    handleFootingUpdate = (event, defaultFooting, item, footing_mod) => {
        const area_design_specs = this.props.job.AreaSpecifications[item?.areaIndex];
        let region = this.props.job?.SiteParameters?.WindData?.WindZoneAS1170?.region;
        let error = false;
        let ref = item.is_footing ? item.ref2 : item?.ref5 ? item?.ref5 : item.ref;
        if (footing_mod?.Ref) ref = footing_mod.Ref;

        let new_value = event.target.value; //;

        if (
            !window.bolt_to_deck_in_high_wind_speed_warning_seen &&
            new_value === "Bolt to Deck" &&
            (region == "N4" ||
                region == "N5" ||
                region == "N6" ||
                region == "C2" ||
                region == "C3" ||
                region == "C4" ||
                region == "D")
        ) {
            error = {
                error: true,
                title: `Bolt to Deck in High WindSpeed`,
                message: [
                    <>
                        NOTE: Bolt to Deck must be to Bearer in windspeeds equal to or exceeding the equivalent of N4,
                        C2 or D.
                    </>,
                ],
            };
            this.props.showDialog(error?.title ? error?.title : "", error.message ? error?.message : "");
            window.bolt_to_deck_in_high_wind_speed_warning_seen = true;
        }

        if (new_value === defaultFooting) {
            //delete any modifications
            this.props.deleteFromAreaSpecificationModificationArray(
                item.areaIndex,
                "Footings",
                ref,
                30,
                undefined,
                undefined,
                "Ref2",
                item.ref2
            );
        } else {
            // Special case - Merbau Post
            if (new_value === "Bolt to Slab (External Connector)") {
                if (area_design_specs[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS].PostCol === "Merbau") {
                    error = {
                        error: true,
                        title: "Merbau is not available in Flanged.",
                        message: [
                            <>
                                Merbau is not available in Flanged, please select another post colour to change footing
                                type.
                            </>,
                        ],
                    };
                    this.props.showDialog(error?.title ? error?.title : "", error.message ? error?.message : "");
                    return;
                }
                if (
                    window.LYSAGHT &&
                    this.props.config.post_types[area_design_specs[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS].PostType]
                        .allow_flanged === false
                ) {
                    error = {
                        error: true,
                        title: `'${
                            area_design_specs[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS].PostType
                        }' is not available in Flanged.`,
                        message: [
                            <>
                                Post Type is not available in Flanged, please select another post colour to change
                                footing type.
                            </>,
                        ],
                    };
                    this.props.showDialog(error?.title ? error?.title : "", error.message ? error?.message : "");
                    return;
                }
            }

            let this_footing_text = new_value;
            let this_footing_mod = {
                Ref: ref,
                Ref2: item.ref2,
                Position: ref.replaceAll("/", ","),
                Kind: this_footing_text.includes("Concrete")
                    ? "Concrete In"
                    : new_value === "Bolt to Deck"
                    ? "Bolt to Deck"
                    : "Bolt to Slab",
                Connector: this_footing_text.includes("External") ? 2 : this_footing_text.includes("Internal") ? 1 : 0,
            };
            this.props.updateAreaSpecificationModificationArray(
                item.areaIndex,
                "Footings",
                this_footing_mod.Ref,
                null,
                this_footing_mod
            );
        }
    };

    matchAllFootingInThisArea = (footingType, areaIndex) => {
        let new_footingTypeSetting = "Concrete In";
        let new_PostExternalConnectors = 0;
        if (footingType.includes("Slab")) {
            new_footingTypeSetting = "Bolt to Slab";
            if (footingType.includes("External")) new_PostExternalConnectors = 1;
        } else if (footingType.includes("Deck")) {
            new_footingTypeSetting = "Bolt to Deck";
            new_PostExternalConnectors = 0;
        }

        let new_area = COMMON.deepCopy(this.props.job?.AreaSpecifications?.[areaIndex]);
        new_area[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS].FootingType = new_footingTypeSetting;
        new_area[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS].PostExternalConnectors = new_PostExternalConnectors;
        new_area.Footings = [];

        this.props.updateAreaSpecificationManual(areaIndex, new_area);
        this.togglePop(false);
    };

    updateData =
        (areaIndex, section, parameter, refresh_svg = true) =>
        (event) => {
            this.setState({
                show_pop: false,
            });

            this.props.updateAreaSpecification(areaIndex, section, parameter, event.target.value);
        };

    updateAreaSpecification =
        (areaIndex, section, parameter, value, refresh_svg = true, turn_off_pop = true) =>
        (event) => {
            this.updateAreaSpecificationValue(areaIndex, section, parameter, value, refresh_svg, turn_off_pop);
        };

    updateAreaSpecificationValue = (areaIndex, section, parameter, value, refresh_svg = true, turn_off_pop = true) => {
        if (turn_off_pop)
            this.setState({
                show_pop: false,
            });

        this.props.updateAreaSpecification(areaIndex, section, parameter, value);
    };

    handle_add_deck_brace = (pop_item, areaIndex, brace_type) => {
        const area_design_specs = this.props.job.AreaSpecifications?.[areaIndex];
        let new_bracing_array = [];
        if (area_design_specs?.DECK_PARAMETERS?.DeckBracing)
            new_bracing_array = [...area_design_specs.DECK_PARAMETERS.DeckBracing];
        let new_brace = {};

        let position_text = "(0,0,0)";
        if (pop_item.click_point) {
            let x = pop_item.click_point.x;
            let y = pop_item.click_point.y;
            if (window.paper_origin) {
                x = x - window.paper_origin.x;
                y = -(y - window.paper_origin.y);
            }

            position_text = "(" + -y.toFixed(0) + "," + x.toFixed(0) + ",0)"; // x and y changed to suit rotated nature of decks
        } else if (pop_item?.ref4) {
            let midpoint = midPointRef(pop_item?.ref4);
            position_text = "(" + -midpoint.y.toFixed(0) + "," + midpoint.x.toFixed(0) + ",0)"; // x and y changed to suit rotated nature of decks
        }

        if (position_text === "(0,0,0)") return;

        new_brace.ref_point = position_text;
        new_brace.type = brace_type;
        new_brace.beam_ref = pop_item?.ref2;
        new_bracing_array.push(new_brace);

        this.props.updateAreaSpecification(areaIndex, "DECK_PARAMETERS", "DeckBracing", new_bracing_array);
    };

    handle_toggle_fan = (pop_item, areaIndex, fan_type) => {
        const area_design_specs = this.props.job.AreaSpecifications?.[areaIndex];
        let new_fan_object = { ...area_design_specs?.Fans };
        if (fan_type !== "") {
            let new_fan = { Type: fan_type };
            new_fan_object[pop_item.ref2] = new_fan;
        } else if (pop_item.is_fan && new_fan_object[pop_item.ref] !== null) {
            delete new_fan_object[pop_item.ref];
        } else if (new_fan_object[pop_item.ref2] !== null) {
            delete new_fan_object[pop_item.ref2];
        }

        this.props.updateAreaSpecification(areaIndex, "Fans", null, new_fan_object);
    };

    removeFanAdjustment = (pop_item, areaIndex) => {
        const area_design_specs = this.props.job.AreaSpecifications?.[areaIndex];
        let new_fan_object = { ...area_design_specs?.Fans };
        let new_fan = new_fan_object[pop_item.ref];
        if (new_fan) {
            delete new_fan["Adjustment_1"];
            new_fan_object[pop_item.ref] = new_fan;
            this.props.updateAreaSpecification(areaIndex, "Fans", null, new_fan_object);
        }
    };

    handle_add_downlights = (pop_item, areaIndex, downlight_option) => {
        const area_design_specs = this.props.job.AreaSpecifications?.[areaIndex];
        let new_downlight_object = { ...area_design_specs?.Downlights };
        let new_downlight = { Type: downlight_option };
        new_downlight_object[pop_item.ref2] = new_downlight;

        this.props.updateAreaSpecification(areaIndex, "Downlights", null, new_downlight_object);
    };
    removeDownlightAdjustment = (pop_item, areaIndex) => {
        const area_design_specs = this.props.job.AreaSpecifications?.[areaIndex];
        let new_downlight_object = { ...area_design_specs?.Downlights };
        let new_downlight = new_downlight_object[pop_item.ref];
        if (new_downlight) {
            delete new_downlight["Adjustment_" + pop_item.dl_index];
            new_downlight_object[pop_item.ref] = new_downlight;
            this.props.updateAreaSpecification(areaIndex, "Downlights", null, new_downlight_object);
        }
    };

    toggleRemoveDownlight = (pop_item, areaIndex) => {
        const area_design_specs = this.props.job.AreaSpecifications?.[areaIndex];
        let new_downlight_object = { ...area_design_specs?.Downlights };

        let downlight_option = new_downlight_object[pop_item.ref]?.Type;
        if (downlight_option) {
            let num_dls = toNumber(downlight_option[0]);
            num_dls--;
            if (!pop_item.ref.includes("downlight_flashing") && num_dls === 0) {
                delete new_downlight_object[pop_item.ref];
            } else {
                downlight_option = num_dls + downlight_option.slice(1);
                new_downlight_object[pop_item.ref].Type = downlight_option;
            }
        } else if (!downlight_option && pop_item?.num_flashing_dls) {
            let num_dls = toNumber(pop_item?.num_flashing_dls);
            num_dls--;
            let new_downlight = {
                Type: num_dls + "WW",
            };
            new_downlight_object[pop_item.ref] = new_downlight;
        }

        this.togglePop(false);
        this.props.updateAreaSpecification(areaIndex, "Downlights", null, new_downlight_object);
    };

    deHover = () => {
        if (_this.last_hover) {
            _this.last_hover.shadowColor = null;
            _this.last_hover.shadowBlur = 0;
            if (_this.last_hover.fillColor)
                _this.last_hover.fillColor.alpha = _this.last_hover.fillColorAlpha_o
                    ? _this.last_hover.fillColorAlpha_o
                    : 1;
            if (_this.last_hover.strokeColor && _this.last_hover.strokeColor_hold) {
                _this.last_hover.strokeColor.red = _this.last_hover.strokeColor_hold.red;
                _this.last_hover.strokeColor.green = _this.last_hover.strokeColor_hold.green;
                _this.last_hover.strokeColor.blue = _this.last_hover.strokeColor_hold.blue;
            }
            _this.last_hover = null;
            if (_this.last_hover_matches) {
                _this.last_hover_matches.forEach(function (item_match) {
                    item_match.shadowColor = null;
                    item_match.shadowBlur = 0;
                    if (item_match.fillColor)
                        item_match.fillColor.alpha = item_match.fillColorAlpha_o ? item_match.fillColorAlpha_o : 1;
                    if (item_match.strokeColor && item_match.strokeColor_hold) {
                        item_match.strokeColor.red = item_match.strokeColor_hold.red;
                        item_match.strokeColor.green = item_match.strokeColor_hold.green;
                        item_match.strokeColor.blue = item_match.strokeColor_hold.blue;
                    }
                });
            }
        }
    };

    toggleMod_attachment_dialog = (open, item) => {
        if (!open) this.togglePop(false);
        this.setState({
            show_pop: false,
            mod_attachment_dialog: open,
            mod_attachment_item: item,
        });
    };

    toggleMod_attachment2_dialog = (open, item, saveAction = null) => {
        if (!open) this.togglePop(false);
        this.setState({
            show_pop: false,
            mod_attachment2_dialog: open,
            mod_attachment_item: item,
            mod_attachment2_saveAction: saveAction,
        });
    };

    toggleMod_beam_dialog = (open, item) => {
        if (!open) this.togglePop(false);
        this.setState({
            show_pop: false,
            mod_beam_dialog: open,
            mod_beam_item: item,
        });
    };

    toggleEdit_extra_beam_dialog = (open) => {
        if (!open) this.togglePop(false);
        this.setState({
            show_pop: false,
            edit_extra_beam_dialog: open,
        });
    };

    toggleMod_beam_posts_dialog = (open, item) => {
        if (!open) this.togglePop(false);
        this.setState({
            show_pop: false,
            mod_beam_posts_dialog: open,
            mod_beam_posts_item: item,
        });
    };
    toggleExtendBeam = (item) => {
        this.setState({
            show_pop: false,
            mod_extend_beam: item ? true : false,
            mod_item: item,
        });
    };

    toggleMoveDownlight = (item) => {
        this.setState({
            show_pop: false,
            mod_move_downlight: item ? true : false,
            mod_item: item,
        });
    };

    toggleMoveFan = (item) => {
        this.setState({
            show_pop: false,
            mod_move_fan: item ? true : false,
            mod_item: item,
        });
    };

    toggleMoveSplice = (item) => {
        this.setState({
            show_pop: false,
            mod_move_splice: item ? true : false,
            mod_item: item,
        });
    };

    removeSpliceAdjustment = (item, areaIndex) => {
        const area_design_specs = this.props.job.AreaSpecifications?.[areaIndex];
        let new_object = { ...area_design_specs?.SpliceAdjustments };
        if (new_object[item.ref]) {
            delete new_object[item.ref];
            this.props.updateAreaSpecification(item.areaIndex, "SpliceAdjustments", null, new_object);
        }
    };

    removeExtendBeam = (item) => {
        this.setState({
            show_pop: false,
        });

        const area_design_specs = this.props.job.AreaSpecifications;
        const areaDataBeamSpecMods = area_design_specs[0].BEAMSPECMODIFICATIONS;

        const filtered_areaDataBeamSpecMods = areaDataBeamSpecMods.filter((mod) => {
            return mod.Area === undefined || mod.Area === item.areaIndex;
        });
        const ref = item ? item.ref : null;
        const ref2 = item ? item.ref2 : null;

        let existing_beam_spec_mods = getItemFromArray(
            filtered_areaDataBeamSpecMods,
            "Ref",
            ref,
            "Ref2",
            ref2,
            30,
            90,
            true
        );

        let beam_spec_mods = {};
        if (existing_beam_spec_mods) {
            beam_spec_mods = existing_beam_spec_mods ? { ...existing_beam_spec_mods } : {};
        }
        beam_spec_mods.P1 = ref.split(";")[0].replaceAll("/", ",");
        beam_spec_mods.P2 = ref.split(";")[1].replaceAll("/", ",");
        beam_spec_mods.Ref = ref;
        beam_spec_mods.Ref2 = ref2 ? ref2 : "";
        beam_spec_mods.Area = item.areaIndex;
        beam_spec_mods.ExtendToBeam = "";

        this.props.updateAreaSpecificationModificationArray(
            item.areaIndex,
            "BEAMSPECMODIFICATIONS",
            ref,
            null,
            beam_spec_mods,
            true,
            ref2
        );
    };

    toggleMod_post_dialog = (open, item) => {
        if (!open) this.togglePop(false);
        this.setState({
            show_pop: false,
            mod_post_dialog: open,
            mod_post_item: item,
        });
    };

    toggleMod_downpipe_dialog = (open, item) => {
        if (!open) this.togglePop(false);
        this.setState({
            show_pop: false,
            mod_downpipe_dialog: open,
            mod_downpipe_item: item,
        });
    };

    togglePop = (show, x, y, pop_item) => {
        //
        if (!show && _this.selected_item) {
            paper.project.deselectAll();
            _this.selected_item = null;

            wipe_start_end_marks();
            this.deHover();
        }
        this.setState({
            show_pop: show,
            pop_location: {
                x: x,
                y: y,
            },
            pop_item: pop_item,
            pop_textfield_text: null,
            OH_Front_text: null,
            OH_Back_text: null,
            beam_adjustment_display_value: null,
        });
    };

    setMessage = (open, message) => {
        this.setState({
            open: open,
            message: message,
        });
    };

    handleClose = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }

        this.props.toggleDesigner(SHOW_MESSAGE);
        // this.setMessage(false, "");
    };

    handleClick = () => {
        this.setMessage(true, "");
    };

    componentDidMount() {
        this.InitialisePaper("qqCanvas");

        if (this.props.visible) {
            let svg = get(this.props.app, "designer.designer2D.svgs.area_all");
            if (!window.job && this.props.job) window.job = { ...this.props.job };
            if (this.props?.job?.id) {
                this.LoadSVG(this.props.job.id, "layout.svg", true, true);
            } else {
                this.UpdateSVGsIfRequired(svg);
            }
            Paper.ForceUpdate();
        }
    }

    syncAccordionWithPopMenu() {
        const { setToolSetAreaOnly, app } = this.props;
        const popItem = this.state.pop_item;
        const show_pop = this.state.show_pop;

        if (!popItem || !show_pop) return;

        const { areaIndex } = popItem;
        const { designer } = app || {};
        const { toolDrawerArea, designer3D } = designer || {};
        const drawerToolSet = designer3D?.drawerToolSetExpanded;
        const areaMismatch = toolDrawerArea !== areaIndex;

        const newToolSet = Paper.getToolSetForPopItem(popItem);

        if (!newToolSet) return;

        if (areaMismatch || newToolSet !== drawerToolSet) {
            setToolSetAreaOnly(areaIndex, newToolSet);
        }
    }

    componentDidUpdate() {
        this.syncAccordionWithPopMenu();
    }

    isPostRHS(popItem, areaIndex) {
        const areaSpecs = this.props?.job?.AreaSpecifications?.[areaIndex];
        const designType = areaSpecs?.SHAPE?.DesignType;

        let isRHS = false;
        let ref;
        let postType;

        // Get popItem reference. Which property we choose depends on whether the user clicked a post or footing
        if (popItem?.is_footing) {
            ref = popItem?.ref2;
        } else if (popItem?.ref5) {
            ref = popItem?.ref5;
        } else {
            ref = popItem?.ref;
        }

        // Get post type. Must account for possible post modifications
        if (areaSpecs?.POSTMODIFICATIONS) {
            const modifiedPost = areaSpecs?.POSTMODIFICATIONS.find((item) => item.Ref === ref);
            postType = modifiedPost ? modifiedPost?.Section : areaSpecs?.BEAMS_AND_POSTS?.PostType;
        } else {
            postType = areaSpecs?.BEAMS_AND_POSTS?.PostType;
        }

        // Check if post is RHS
        if (postType) {
            const designOptions = this.props?.config?.design_options?.[designType];
            const optionsRHS = designOptions?.post?.options["Box with RHS Insert"];
            isRHS = optionsRHS?.includes(postType);
        }

        return isRHS;
    }

    getDownlightOptions(areaIndex) {
        const area_design_specs = this.props?.job?.AreaSpecifications?.[areaIndex];
        const roofsheetgroup =
            this.props.config.roofsheet_types?.[area_design_specs[BASIC_SPECS_SECTIONS.ROOF_SHEETING].RoofGroupType];
        let DOWNLIGHT_OPTIONS = [];
        if (roofsheetgroup?.downlight_colours?.includes) {
            if (roofsheetgroup.downlight_colours.includes("Cool White")) {
                DOWNLIGHT_OPTIONS.push({ Key: "1CW", Display: "1 x 9w Cool White" });
                DOWNLIGHT_OPTIONS.push({ Key: "2CW", Display: "2 x 9w Cool White" });
                DOWNLIGHT_OPTIONS.push({ Key: "3CW", Display: "3 x 9w Cool White" });
                DOWNLIGHT_OPTIONS.push({ Key: "4CW", Display: "4 x 9w Cool White" });
            }
            if (roofsheetgroup.downlight_colours.includes("Warm White")) {
                DOWNLIGHT_OPTIONS.push({ Key: "1WW", Display: "1 x 9w Warm White" });
                DOWNLIGHT_OPTIONS.push({ Key: "2WW", Display: "2 x 9w Warm White" });
                DOWNLIGHT_OPTIONS.push({ Key: "3WW", Display: "3 x 9w Warm White" });
                DOWNLIGHT_OPTIONS.push({ Key: "4WW", Display: "4 x 9w Warm White" });
            }
            if (roofsheetgroup.downlight_colours.includes("Tri-Colour")) {
                DOWNLIGHT_OPTIONS.push({ Key: "1WWTRI", Display: "1 x Tri-Colour w Dimmer" });
                DOWNLIGHT_OPTIONS.push({ Key: "2WWTRI", Display: "2 x Tri-Colour w Dimmer" });
                DOWNLIGHT_OPTIONS.push({ Key: "3WWTRI", Display: "3 x Tri-Colour w Dimmer" });
                DOWNLIGHT_OPTIONS.push({ Key: "4WWTRI", Display: "4 x Tri-Colour w Dimmer" });
            }
        }
        return DOWNLIGHT_OPTIONS;
    }
    
    render() {
        const {
            open,
            message,
            show_pop,
            pop_location,
            pop_item,
            pop_textfield_text,
            OH_Front_text,
            OH_Back_text,
            beam_adjustment_display_value,
        } = this.state;
        const { classes, config, app, job } = this.props;
        const carportMode = job?.DesignParameters?.CarportMode === 1;
        const THREED_MODE = app?.designer?.[APP.THREED_MODE];
        const THREED_MINI_MODE = app?.designer?.[APP.THREED_MINI_MODE];
        const TOOL_DRAWER_WIDTH = app?.designer?.[APP.TOOL_DRAWER_WIDTH];
        const modelFileName = app?.designer?.designer3D?.objs?.area_all;
        const BACKGROUND_MODE = app?.designer?.designer3D?.[APP.BACKGROUND_MODE];
        const SHOW_GRAPH_BG = app?.designer?.designer2D?.[APP.SHOW_GRAPH_BG];
        const SELECT_POINT = app?.designer?.designer2D?.[APP.SELECT_POINT];
        const UNLOCKED = app?.designer?.[APP.UNLOCKED];
        const customListIsOpen = app?.designer?.[APP.CUSTOM_COMPONENT_LIST_IS_OPEN] ?? false;
        const acceptedWarnings = job?.AcceptedWarnings || [];
        const userAcknowledgedCustomList = acceptedWarnings.includes("JobHasCustomList") ?? false;
        const hasCustomBOM = (job?.QuoteParameters?.BOM?.OrderList?.items?.length ?? 0) > 0 || customListIsOpen;
        const orderStatus = (job?.OrderStatus || "").toUpperCase();

        const locked =
            ((orderStatus === "PENDING" ||
                orderStatus === "ACCEPTED" ||
                this.props?.job?.App?.Locked ||
                (hasCustomBOM && !userAcknowledgedCustomList)) &&
                !UNLOCKED) ||
            carportMode;

        window.job = { ...job };
        window.app = { ...app };
        window.THREED_MODE = THREED_MODE;
        window.THREED_MINI_MODE = THREED_MINI_MODE;

        let edit_item = null;
        let areaIndex = pop_item?.areaIndex !== undefined ? Number(pop_item?.areaIndex) : 0;

        let pop_menu_items = [];
        let pop_menu_items_details = [];
        let pop_alignment = "left";
        if (pop_location.x < window.innerWidth * 0.3) pop_alignment = "left";
        if (pop_location.x > window.innerWidth * 0.6) pop_alignment = "right";

        let is_cyclonic = false;
        let region = job?.SiteParameters?.WindData?.WindZoneAS1170?.region;
        if (region === "C" || region === "D") {
            is_cyclonic = true;
        }

        if (pop_item && pop_item.ref && locked) {
            if (pop_item.is_point) {
            } else {
            }
        } else if (pop_item?.allHitItems && pop_item?.allHitItems.length > 0) {
            pop_menu_items.push(
                <Typography classes={{ root: classes.pop_header }} variant="overline" display="block" gutterBottom>
                    Multiple Items: Choose an item to Edit
                </Typography>
            );
            pop_item.allHitItems.forEach((hit_item) => {
                let type = hit_item.item.typeQQ;
                if (type.includes("beam")) type = "Beam";
                let name = hit_item.item.beamName;
                pop_menu_items.push(
                    <MenuItem
                        classes={{ root: classes.menu_item }}
                        onClick={() => {
                            this.setState({
                                pop_item: hit_item.item,
                            });
                        }}
                    >
                        {type}: {name}
                    </MenuItem>
                );
            });
        } else if (pop_item && pop_item.ref && !locked) {
            if (areaIndex < 0) areaIndex = 0;
            const area_design_specs = job.AreaSpecifications?.[areaIndex];
            const DesignType = area_design_specs?.SHAPE?.DesignType;

            let is_portal = DesignType === CONFIG.DESIGN_TYPES.GABLE_PORTAL;
            let is_flat = DesignType === CONFIG.DESIGN_TYPES.FLAT;
            let is_louvre = DesignType === CONFIG.DESIGN_TYPES.LOUVRE;

            let show_front_back_overhangs = false;

            PaperDesigner.wipe_start_end_marks();

            if (is_louvre && !pop_item.is_dimension) {
            } else if (pop_item.is_point && DesignType !== CONFIG.DESIGN_TYPES.DECK) {
                pop_menu_items.push(
                    <MenuItem
                        key="add-downpipe"
                        classes={{ root: classes.menu_item }}
                        onClick={() => {
                            this.toggleMod_downpipe_dialog(true, pop_item);
                        }}
                    >
                        Add Downpipe...
                    </MenuItem>
                );
            } else if (pop_item.is_note) {
                if (areaIndex > -1 && job.AreaSpecifications[areaIndex]?.DrawingNotes) {
                    edit_item = getItemFromArray(job.AreaSpecifications[areaIndex]?.DrawingNotes, "Ref", pop_item.ref);
                } else {
                    for (var this_areaIndex in job.AreaSpecifications) {
                        areaIndex = Number(this_areaIndex);
                        edit_item = getItemFromArray(
                            job.AreaSpecifications[areaIndex].DrawingNotes,
                            "Ref",
                            pop_item.ref
                        );
                        if (edit_item) break;
                    }
                }
            } else if (pop_item.is_splice) {
                if (!THREED_MODE || (THREED_MODE && THREED_MINI_MODE)) {
                    let has_adjustment = area_design_specs?.SpliceAdjustments?.[pop_item.ref];
                    pop_menu_items.push(
                        <MenuItem
                            key="move_splice"
                            classes={{ root: classes.menu_item }}
                            onClick={() => this.toggleMoveSplice(pop_item)}
                            style={{ minWidth: has_adjustment ? "220px" : "180px" }}
                        >
                            Move Beam Splice...{" "}
                            {has_adjustment && (
                                <BSL_Button
                                    tight
                                    className={classes.mini_button}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        this.togglePop(false);
                                        this.removeSpliceAdjustment(pop_item, areaIndex);
                                    }}
                                >
                                    Reset
                                </BSL_Button>
                            )}
                        </MenuItem>
                    );
                }
            } else if (pop_item.is_slat || pop_item.sel_type === "slat_label") {
                if (areaIndex > -1 && job.AreaSpecifications[areaIndex]?.SlatPanels) {
                    edit_item = getItemFromArray(job.AreaSpecifications[areaIndex]?.SlatPanels, "Ref", pop_item.ref);
                    if (!edit_item)
                        getItemFromArray(job.AreaSpecifications[areaIndex]?.SlatPanels, "Ref", pop_item.ref);
                } else {
                    for (var this_areaIndex in job.AreaSpecifications) {
                        areaIndex = Number(this_areaIndex);
                        edit_item = getItemFromArray(job.AreaSpecifications[areaIndex].SlatPanels, "Ref", pop_item.ref);
                        if (edit_item) break;
                    }
                    if (!edit_item)
                        for (var this_areaIndex in job.AreaSpecifications) {
                            areaIndex = Number(this_areaIndex);
                            edit_item = getItemFromArray(
                                job.AreaSpecifications[areaIndex].SlatPanels,
                                "Ref",
                                pop_item.ref
                            );
                            if (edit_item) break;
                        }
                }
            } else if (pop_item.is_downpipe) {
                if (pop_item.ref === "Auto")
                    pop_menu_items.push(
                        <MenuItem
                            key="remove-auto-added-downpipes"
                            classes={{ root: classes.menu_item }}
                            onClick={() => {
                                this.togglePop(false);
                                this.handleDisableAutoDownpipes(areaIndex);
                            }}
                        >
                            Remove All Auto Added Downpipes
                        </MenuItem>
                    );
                else if (pop_item.ref)
                    pop_menu_items.push(
                        <MenuItem
                            key="remove-downpipe"
                            classes={{ root: classes.menu_item }}
                            onClick={() => {
                                this.togglePop(false);
                                this.handleRemoveDownpipe(areaIndex, pop_item.ref);
                            }}
                        >
                            Remove Downpipe
                        </MenuItem>
                    );
            } else if (pop_item.ref && pop_item.is_dimension) {
                let section = this.props.job.AreaSpecifications[areaIndex].SHAPE;
                let this_ref = pop_item.ref;
                if (this_ref === "Length OD" || this_ref === "Length OG") this_ref = "Length";
                if (this_ref === "Depth OD" || this_ref === "Depth OG") this_ref = "Depth";
                if (this_ref === "Flyover Length") this_ref = "Length";

                let attribute = this_ref;
                let subSection = null;

                if (["JoinAngle", "JoinOffset"].includes(pop_item.ref)) {
                    section = section.AREAJOIN;
                    subSection = "AREAJOIN";
                }
                if (attribute.includes("-") && (attribute.startsWith("Back") || attribute.startsWith("Front"))) {
                    section = section.CUTOUTS;
                    subSection = "CUTOUTS";
                }

                let is_beam_adjustment = false;
                let is_extra_beam = false;
                let is_paat = false;
                let is_cutout_custom = false;
                let is_extra_post = false;
                if (pop_item.typeQQ.includes("/paat")) is_paat = true;
                else if (pop_item.typeQQ.includes("/extrabeam")) is_extra_beam = true;
                else if (pop_item.typeQQ.includes("/post_new")) is_extra_post = true;
                else if (pop_item.typeQQ.includes("/cutout") && pop_item.ref.includes("CustomPoint"))
                    is_cutout_custom = true;
                else if (pop_item.ref.includes("/")) is_beam_adjustment = true;

                let base_value = toNumber(section[this_ref] ? section[this_ref] : pop_textfield_text);
                let display_value = pop_textfield_text === null ? section[pop_item.ref] : pop_textfield_text;
                if (display_value === "-" && is_beam_adjustment) {
                } else if (display_value !== "")
                    display_value = toNumber(display_value, is_beam_adjustment ? true : false);
                let adjustment_value = 0;
                let content_value = display_value;
                if (pop_item.content) {
                    content_value = toNumber(pop_item.content, is_beam_adjustment ? true : false);
                }
                if (pop_textfield_text === null && content_value) {
                    display_value = toNumber(content_value, is_beam_adjustment ? true : false);
                }

                let extra_beam_offset = -1;
                if (is_extra_beam) {
                    if (pop_item.offset1 !== undefined) extra_beam_offset = Number(pop_item.offset1);
                    if (pop_item.offset2 !== undefined) extra_beam_offset = Number(pop_item.offset2);
                    base_value = Number(extra_beam_offset);
                }

                if (content_value !== base_value) adjustment_value = content_value - base_value;

                if (is_beam_adjustment) {
                    adjustment_value = 0;
                    if (pop_textfield_text === null) {
                        let beam_adjustments = get(
                            this.props.job,
                            "AreaSpecifications." + areaIndex + ".BEAMADJUSTMENTS"
                        );
                        let thisModification = null;
                        for (var mod of beam_adjustments) {
                            if (mod.Ref === pop_item.ref && mod.Adjustment) {
                                display_value = mod.Adjustment;
                            }
                        }
                    }
                }

                let design_option = config.design_options[DesignType];

                let max_side_overhang =
                    area_design_specs?.[BASIC_SPECS_SECTIONS.ROOF_SHEETING]?.RoofSheetData?.max_side_overhang;
                let min_side_overhang =
                    area_design_specs?.[BASIC_SPECS_SECTIONS.ROOF_SHEETING]?.RoofSheetData?.min_side_overhang;
                let max_overhang = area_design_specs?.[BASIC_SPECS_SECTIONS.ROOF_SHEETING]?.RoofSheetData?.max_overhang;

                let name = is_extra_beam ? "Extra Beam Offset" : pop_item.ref;

                if (is_extra_post) {
                    name = "Extra Post Position";
                }
                if (is_paat) name = "Partial Attachment - " + name;

                let range = {
                    min: 0,
                    max: 20000,
                    default: 0,
                };

                const rotated = area_design_specs.META.LengthDepthRotated;

                if ((!rotated && this_ref === "Length") || (rotated && this_ref === "Depth")) {
                    range.min = 200;
                    range.max = 30000;
                    if (design_option?.length_range) range = { ...range, ...design_option.length_range };
                }
                if ((!rotated && this_ref === "Depth") || (rotated && this_ref === "Length")) {
                    range.min = 300;
                    range.max = 12000;
                    if (design_option?.depth_range) range = { ...range, ...design_option.depth_range };
                }
                if (this_ref === "Depth" && area_design_specs.SHAPE.DesignType === CONFIG.DESIGN_TYPES.GABLE_PORTAL) {
                    name = "Frame Span";
                }

                if (this_ref === "Height") {
                    range.min = 2100;
                    range.max = 4000;
                    if (design_option?.height_range) range = { ...range, ...design_option.height_range };
                }
                if (this_ref === "OH_Left" || this_ref === "Frame_OH_Left") {
                    name = "Left Overhang";
                    range.min = 0;
                    range.max = 1000;
                    if (design_option?.overhang_left_range) range = { ...range, ...design_option.overhang_left_range };

                    if (min_side_overhang) range.min = min_side_overhang;
                    if (max_side_overhang) range.max = max_side_overhang;

                    if (is_portal && this_ref === "Frame_OH_Left") {
                        name = "Left Frame Overhang";
                        range.max = design_option?.max_frame_overhang ? design_option?.max_frame_overhang : 1200;
                    }
                }
                if (this_ref === "OH_Right" || this_ref === "Frame_OH_Right") {
                    name = "Right Overhang";
                    range.min = 0;
                    range.max = 1000;
                    if (design_option?.overhang_right_range)
                        range = { ...range, ...design_option.overhang_right_range };

                    let min_side_overhang =
                        this.props.job.AreaSpecifications[areaIndex]?.[BASIC_SPECS_SECTIONS.ROOF_SHEETING]
                            ?.RoofSheetData?.min_side_overhang;
                    if (min_side_overhang) range.min = min_side_overhang;
                    if (max_side_overhang) range.max = max_side_overhang;

                    if (is_portal && this_ref === "Frame_OH_Right") {
                        name = "Right Frame Overhang";
                        range.max = design_option?.max_frame_overhang ? design_option?.max_frame_overhang : 1200;
                    }
                }

                if (max_overhang && (this_ref.endsWith("Right-Overhang") || this_ref.endsWith("Left-Overhang"))) {
                    let cutout_name = "";
                    if (this_ref.startsWith("FrontLeft")) {
                        cutout_name = "CFL";
                    }
                    if (this_ref.startsWith("FrontRight")) {
                        cutout_name = "CFR";
                    }
                    if (this_ref.startsWith("BackLeft")) {
                        cutout_name = "CBL";
                    }
                    if (this_ref.startsWith("BackRight")) {
                        cutout_name = "CBR";
                    }
                    if (cutout_name !== "") {
                        let min_side_overhang = toNumber(area_design_specs?.META?.MaxCutoutOverhangs?.[cutout_name]);
                        if (min_side_overhang > 100 && min_side_overhang < max_overhang) {
                            max_overhang = min_side_overhang;
                        }
                    }
                    range.max = max_overhang;
                }

                let max_frontback_end_span =
                    this.props.job.AreaSpecifications[areaIndex]?.[BASIC_SPECS_SECTIONS.ROOF_SHEETING]?.RoofSheetData
                        ?.max_frontback_end_span;

                if (pop_item.ref === "OH_Back") {
                    let min_front_overhang =
                        this.props.job.AreaSpecifications[areaIndex]?.[BASIC_SPECS_SECTIONS.ROOF_SHEETING]
                            ?.RoofSheetData?.min_front_overhang;

                    name = "Back Overhang";
                    range.min = 0;
                    range.max = max_frontback_end_span !== undefined ? max_frontback_end_span : 200;
                    if (design_option?.overhang_back_range) range = { ...range, ...design_option.overhang_back_range };
                    if (min_front_overhang)
                        range.min =
                            max_frontback_end_span < min_front_overhang ? max_frontback_end_span : min_front_overhang;
                    if (max_frontback_end_span) range.max = max_frontback_end_span;
                }
                if (pop_item.ref === "OH_Front") {
                    let min_front_overhang =
                        this.props.job.AreaSpecifications[areaIndex]?.[BASIC_SPECS_SECTIONS.ROOF_SHEETING]
                            ?.RoofSheetData?.min_front_overhang;

                    name = "Front Overhang";
                    range.min =
                        min_front_overhang !== undefined
                            ? max_frontback_end_span < min_front_overhang
                                ? max_frontback_end_span
                                : min_front_overhang
                            : 0;
                    range.max = max_frontback_end_span !== undefined ? max_frontback_end_span : 200;
                    if (design_option?.overhang_front_range)
                        range = { ...range, ...design_option.overhang_front_range };

                    if (min_front_overhang)
                        range.min =
                            max_frontback_end_span < min_front_overhang ? max_frontback_end_span : min_front_overhang;
                    if (max_frontback_end_span) range.max = max_frontback_end_span;
                }

                let ref = this_ref;
                if (DesignType === CONFIG.DESIGN_TYPES.DECK) {
                    if (this_ref === "Length") name = "Depth";
                    else name = "Length";
                    ref = ConvertCutoutNameForDecks(ref);
                    if (ref.includes("-WidthX")) ref = ref.replace("-WidthX", "-WidthY");
                    else if (ref.includes("-WidthY")) ref = ref.replace("-WidthY", "-WidthX");
                }

                if (ref.includes("-Offset")) {
                    name = ref.replace("-Offset", " Offset");
                    range.min = 500;
                    range.max = 20000;
                    if (design_option?.length_range) range = { ...range, ...design_option.length_range };
                }
                if (ref.includes("WidthX")) {
                    name = ref.replace("-WidthX", " Cutout Length");
                    range.min = 500;
                    range.max = 20000;
                    if (design_option?.length_range) range = { ...range, ...design_option.length_range };
                }
                if (ref.includes("WidthY")) {
                    name = ref.replace("-WidthY", " Cutout Width");
                    range.min = 300;
                    range.max = 12000;
                    if (design_option?.depth_range) range = { ...range, ...design_option.depth_range };
                }

                range = replaceVariables(area_design_specs, range);

                if (is_extra_beam) {
                    range.min = 0;
                    range.max = 20000;
                }

                if (is_cutout_custom) {
                    const cutouts = this.props.job?.AreaSpecifications?.[areaIndex]?.SHAPE?.CUTOUTS;
                    let cutout_side = ref.split("-")[0];
                    range.max = toNumber(cutouts[cutout_side + "-Width" + (ref.includes("-X") ? "X" : "Y")]);
                    range.min = -range.max;
                }

                if (subSection === "AREAJOIN") {
                    // Modify max range for join areas
                    range.min = 0;
                    range.max = toNumber(this.props.job?.AreaSpecifications?.[areaIndex]?.SHAPE?.Depth);
                    if (this.props.job?.AreaSpecifications.length > 1) {
                        if (this.props.job?.AreaSpecifications.length > 0) {
                            if (base_value > 0) {
                                range.max = toNumber(this.props.job?.AreaSpecifications?.[areaIndex + 1]?.SHAPE?.Depth);
                            }
                        }
                    }
                }

                pop_menu_items.push(
                    <Typography
                        key="modify"
                        classes={{ root: classes.pop_header }}
                        variant="overline"
                        display="block"
                        gutterBottom
                    >
                        Modify {name}
                    </Typography>
                );

                pop_menu_items.push(
                    <BSL_TextInput
                        key="cutout-mod"
                        value={display_value}
                        style={{ color: "black", width: "100%", padding: "5px 10px 5px 10px" }}
                        autoFocus={true}
                        selectAll={true}
                        endAdornment="mm"
                        min={range.min}
                        max={range.max}
                        tooltipDelay={500}
                        onFocus={(event) => {
                            event.target.select();
                        }}
                        onBlur={(val) => {
                            if (is_cutout_custom) {
                                let base_val = content_value;
                                this.updateCustomCutoutValue(areaIndex, pop_item.ref, Number(val), base_val);
                            } else if (is_paat) {
                                this.updatePAATValue(areaIndex, pop_item, Number(val), content_value);
                            } else if (is_beam_adjustment) {
                                this.updateBeamAdjustmentValue(
                                    areaIndex,
                                    pop_item.ref,
                                    "Adjustment",
                                    true,
                                    Number(val)
                                );
                            } else if (is_extra_beam) {
                                let base_val = content_value;
                                if (Number(val) - adjustment_value === base_value) return;
                                this.updateExtraBeamDimension(areaIndex, pop_item, Number(val) - base_val, Number(val));
                            } else if (is_extra_post) {
                                let base_val = content_value;
                                if (Number(val) - adjustment_value === base_value) return;
                                this.updateExtraDeckPostDimension(
                                    areaIndex,
                                    pop_item,
                                    Number(val) - base_val,
                                    Number(val)
                                );
                            } else {
                                if (Number(val) - adjustment_value === base_value) return;

                                let value = Number(val) - adjustment_value;

                                if (subSection && subSection === "AREAJOIN" && base_value < 0) {
                                    value = -Number(val); // Negative base value, return negative change
                                }

                                this.props.updateAreaSpecificationJob(
                                    areaIndex,
                                    BASIC_SPECS_SECTIONS.SHAPE,
                                    subSection,
                                    attribute,
                                    value
                                );
                            }
                        }}
                        onKeyPress={(e) => {
                            if (e.key === "Enter") {
                                this.togglePop(false);
                                e.target.blur();
                                //DES-808 - Added funcitonality to change cutout value from pop-up
                                this.props.updateAreaSpecification(
                                    areaIndex,
                                    BASIC_SPECS_SECTIONS.SHAPE,
                                    "CUTOUTS." + pop_item.ref,
                                    e.target.value
                                );
                            }
                        }}
                        onChange={(val) => {
                            this.setState({ pop_textfield_text: val });
                        }}
                    />
                );
            } else if (DesignType === CONFIG.DESIGN_TYPES.DECK) {
                if (
                    (pop_item.is_attachment ||
                        pop_item.is_attachment_ghost ||
                        pop_item.is_gutter ||
                        pop_item.is_attachment_roof ||
                        pop_item.is_barge ||
                        pop_item.is_cutout) &&
                    pop_item.ref
                ) {
                    const area_design_specs = get(job, "AreaSpecifications." + areaIndex);
                    let ref_data = GetRefs(pop_item, area_design_specs);
                    let cutout = ref_data.IsCutout;
                    let attach_tag = ref_data.AttachmentRef;

                    let side_is_attached;
                    if (cutout)
                        side_is_attached = get(
                            area_design_specs,
                            BASIC_SPECS_SECTIONS.SHAPE + ".CUTOUTS." + attach_tag
                        );
                    else side_is_attached = get(area_design_specs, BASIC_SPECS_SECTIONS.ATTACHMENTS + "." + attach_tag);

                    pop_menu_items.push(
                        <Typography
                            key="mod-deck-attach"
                            classes={{ root: classes.pop_header }}
                            variant="overline"
                            display="block"
                            gutterBottom
                        >
                            Modify Deck Attachments
                        </Typography>
                    );
                    if (cutout) {
                        let cutoutType = "";
                        if (pop_item.ref) {
                            cutoutType = area_design_specs.SHAPE.CUTOUTS[pop_item.ref.split("-")[0] + "-CutoutType"];
                        }

                        pop_menu_items.push(
                            <MenuItem
                                key="add-remove-cutout-step"
                                classes={{ root: classes.menu_item }}
                                onClick={(e) => {
                                    this.togglePop(false);
                                    this.props.updateAreaSpecification(
                                        areaIndex,
                                        BASIC_SPECS_SECTIONS.SHAPE + ".CUTOUTS",
                                        pop_item.ref.split("-")[0] + "-CutoutType",
                                        cutoutType === "Step" ? "None" : "Step"
                                    );
                                }}
                            >
                                {cutoutType === "Step" ? "Remove Step Cutout" : "Add Step Cutout"}
                            </MenuItem>
                        );
                    }
                    let attach_item = pop_item;

                    //fix up item if attachment one in paper
                    let search = Paper.GetItems({ ref: attach_tag, ref2: pop_item?.ref2, areaIndex: areaIndex });
                    if (search.length == 0 && pop_item?.ref2?.startsWith("C")) {
                        // for cutouts
                        search = Paper.GetItems({ ref: pop_item.ref, ref2: pop_item?.ref2, areaIndex: areaIndex });
                    }
                    if (search.length == 0) search = Paper.GetItems({ ref: attach_tag, areaIndex: areaIndex });
                    if (search && search.length > 0) {
                        attach_item = { ...search[0] };
                    }

                    if (side_is_attached) {
                        pop_menu_items.push(
                            <MenuItem
                                key="modify-attachment"
                                classes={{ root: classes.menu_item }}
                                onClick={(e) =>
                                    this.toggleMod_attachment2_dialog(true, attach_item, () => {
                                        this.attachSide(areaIndex, attach_tag, "", false, job, attach_item)(e);
                                    })
                                }
                                style={{ minWidth: "270px" }}
                            >
                                Modify Attachment...{" "}
                                <BSL_Button
                                    tight
                                    className={classes.mini_button}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        this.attachSide(areaIndex, attach_tag, "", true, job, attach_item)(e);
                                    }}
                                >
                                    Unattach
                                </BSL_Button>
                            </MenuItem>
                        );
                    } else {
                        pop_menu_items.push(
                            <MenuItem
                                key="attach-this-side"
                                classes={{ root: classes.menu_item }}
                                onClick={(e) => {
                                    let attach_item = pop_item;
                                    //fix up item if attachment one in paper
                                    let search = Paper.GetItems({ ref: attach_tag, areaIndex: areaIndex });
                                    if (search && search.length > 0) {
                                        attach_item = search[0];
                                    }
                                    this.toggleMod_attachment2_dialog(true, attach_item, () => {
                                        this.attachSide(areaIndex, attach_tag, "", false, job, attach_item)(e);
                                    });
                                }}
                            >
                                Attach this side...
                            </MenuItem>
                        );
                    }
                }
                if (pop_item.is_post && pop_item.add_post_index !== undefined) {
                    pop_menu_items.push(
                        <Typography
                            key="posts-heading"
                            classes={{ root: classes.pop_header }}
                            variant="overline"
                            display="block"
                            gutterBottom
                        >
                            Posts
                        </Typography>
                    );
                    pop_menu_items.push(
                        <MenuItem
                            key="delete-post"
                            classes={{ root: classes.menu_item }}
                            onClick={(e) => {
                                this.togglePop(false);
                                let new_post_array = area_design_specs?.DECK_PARAMETERS?.DeckPosts.filter(
                                    (item, index) => {
                                        return index !== toNumber(pop_item.add_post_index);
                                    }
                                );
                                this.props.updateAreaSpecification(
                                    areaIndex,
                                    "DECK_PARAMETERS",
                                    "DeckPosts",
                                    new_post_array
                                );
                            }}
                        >
                            Delete Post
                        </MenuItem>
                    );
                }
                if (pop_item.is_beam && (pop_item.is_perimeter || pop_item.beamName === "Bearer")) {
                    pop_menu_items.push(
                        <Typography
                            key="post-heading-2"
                            classes={{ root: classes.pop_header }}
                            variant="overline"
                            display="block"
                            gutterBottom
                        >
                            Posts
                        </Typography>
                    );
                    pop_menu_items.push(
                        <MenuItem
                            key="add-post-in-this-location"
                            classes={{ root: classes.menu_item }}
                            onClick={(e) => {
                                this.togglePop(false);
                                let new_post_array = [];
                                if (area_design_specs?.DECK_PARAMETERS?.DeckPosts)
                                    new_post_array = [...area_design_specs.DECK_PARAMETERS.DeckPosts];
                                let new_post = {};

                                let position_text = "(0,0,0)";
                                if (pop_item.click_point) {
                                    let x = pop_item.click_point.x;
                                    let y = pop_item.click_point.y;
                                    if (window.paper_origin) {
                                        x = x - window.paper_origin.x;
                                        y = -(y - window.paper_origin.y);
                                    }

                                    position_text = "(" + -y.toFixed(0) + "," + x.toFixed(0) + ",0)"; // x and y changed to suit rotated nature of decks
                                } else if (pop_item?.ref4) {
                                    let midpoint = midPointRef(pop_item?.ref4);
                                    position_text = "(" + -midpoint.y.toFixed(0) + "," + midpoint.x.toFixed(0) + ",0)"; // x and y changed to suit rotated nature of decks
                                }

                                if (position_text === "(0,0,0)") return;

                                new_post.ref_point = position_text;
                                new_post.location = -1;
                                new_post.beam_ref = pop_item?.ref2;
                                new_post_array.push(new_post);

                                this.props.updateAreaSpecification(
                                    areaIndex,
                                    "DECK_PARAMETERS",
                                    "DeckPosts",
                                    new_post_array
                                );
                            }}
                        >
                            Add Post (in this location)
                        </MenuItem>
                    );
                }
                if (
                    (pop_item.is_beam && (pop_item.is_perimeter || pop_item.beamName.includes("Bearer"))) ||
                    pop_item.is_brace
                ) {
                    pop_menu_items.push(
                        <Typography
                            key="bracing-heading"
                            classes={{ root: classes.pop_header }}
                            variant="overline"
                            display="block"
                            gutterBottom
                        >
                            Bracing
                        </Typography>
                    );
                }
                if (pop_item.is_beam && (pop_item.is_perimeter || pop_item.beamName.includes("Bearer"))) {
                    let show_add_brace = true;
                    if (pop_item?.deck_bracing) {
                        let braces = pop_item?.deck_bracing.split("/");
                        let post_behind = area_design_specs?.BEAMS_AND_POSTS?.CornerPostsFullHeight === 3;
                        if (!post_behind) show_add_brace = false;
                        pop_menu_items.push(
                            <MenuItem
                                key="delete-brace"
                                classes={{ root: classes.menu_item }}
                                onClick={(e) => {
                                    let indexes_int = [];
                                    for (let index of braces) {
                                        indexes_int.push(toNumber(index));
                                    }
                                    this.togglePop(false);
                                    let new_bracing_array = [];
                                    if (area_design_specs?.DECK_PARAMETERS?.DeckBracing) {
                                        new_bracing_array = area_design_specs?.DECK_PARAMETERS?.DeckBracing.filter(
                                            (item, index) => {
                                                if (indexes_int.includes(index)) {
                                                    //don't add
                                                    return false;
                                                }
                                                return true;
                                            }
                                        );
                                    }

                                    this.props.updateAreaSpecification(
                                        areaIndex,
                                        "DECK_PARAMETERS",
                                        "DeckBracing",
                                        new_bracing_array
                                    );
                                }}
                            >
                                Delete Brace{braces.length > 1 ? "s" : ""}
                            </MenuItem>
                        );
                    }
                    if (show_add_brace) {
                        let post_type =
                            this.props.config?.post_types?.[
                                area_design_specs[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS].PostType
                            ];

                        let bracing_options = [
                            { Key: "", Display: "Select Brace Type..." },
                            { Key: "30x1.0 Strap - 2 Teks", Display: "30x1.0 Strap (2 Tek - 4.7kN)" },
                            {
                                Key: "30x1.0 Strap - 3 Teks",
                                Display: "30x1.0 Strap (3 Tek - 7.05kN)",
                                disabled: post_type.depth < 80,
                                disabledTooltip: "Not available to post less than 90mm wide.",
                            },
                        ];
                        if (area_design_specs[BASIC_SPECS_SECTIONS.DECK_PARAMETERS].WireBraceCode) {
                            bracing_options.push({
                                Key: "6mm Wire Rope - 4 Teks",
                                Display: "6mm Wire Rope (4 Teks - 13kN)",
                            });
                        }
                        if (area_design_specs[BASIC_SPECS_SECTIONS.DECK_PARAMETERS].RodBraceCode) {
                            bracing_options.push({ Key: "M12 Rod - 6 Teks", Display: "M12 Rod (6 Teks - 20kN)" });
                        }

                        pop_menu_items.push(
                            <MenuItem key="add-brace" classes={{ root: classes.menu_item }}>
                                Add Brace{" "}
                                <BSL_Select
                                    tight={true}
                                    value={""}
                                    onChange={(e) => {
                                        this.togglePop(false);
                                        this.handle_add_deck_brace(pop_item, areaIndex, e.target.value);
                                    }}
                                    items={bracing_options}
                                ></BSL_Select>
                            </MenuItem>
                        );
                    }
                }
                if (pop_item.is_brace) {
                    pop_menu_items.push(
                        <MenuItem
                            key="delete-brace-2"
                            classes={{ root: classes.menu_item }}
                            onClick={(e) => {
                                this.togglePop(false);
                                let new_bracing_array = area_design_specs?.DECK_PARAMETERS?.DeckBracing.filter(
                                    (item) => {
                                        return item.ref_point != pop_item.ref.replaceAll("/", ",");
                                    }
                                );
                                this.props.updateAreaSpecification(
                                    areaIndex,
                                    "DECK_PARAMETERS",
                                    "DeckBracing",
                                    new_bracing_array
                                );
                            }}
                        >
                            Delete Brace
                        </MenuItem>
                    );
                }
            } else if (pop_item.is_skylight) {
                pop_menu_items.push(
                    <Typography
                        key="mod-skylight"
                        classes={{ root: classes.pop_header }}
                        variant="overline"
                        display="block"
                        gutterBottom
                    >
                        Modify Skylight
                    </Typography>
                );
                pop_menu_items.push(
                    <MenuItem
                        key="remove-skylight"
                        classes={{ root: classes.menu_item }}
                        onClick={() => {
                            this.togglePop(false);
                            pop_item.is_skylight = false;
                            this.UpdateSkylights(pop_item);
                        }}
                    >
                        Remove Skylight
                    </MenuItem>
                );
            } else if (pop_item.is_ceiling_fan_point) {
                let design_option = config.design_options[DesignType];

                if (design_option.gable_apex_fan_code) {
                    const has_fan = area_design_specs?.Fans?.[pop_item.ref2]?.Type;
                    pop_menu_items.push(
                        <MenuItem
                            key="add-fan"
                            classes={{ root: classes.menu_item }}
                            onClick={() => {
                                this.togglePop(false);
                                this.handle_toggle_fan(pop_item, areaIndex, has_fan ? "" : "Standard");
                            }}
                        >
                            {has_fan ? "Remove" : "Add"} Fan
                        </MenuItem>
                    );
                }
            } else if (pop_item.is_roofsheet) {
                let skylight = area_design_specs[BASIC_SPECS_SECTIONS.ROOF_SHEETING].SkylightSubType;

                const roofsheetgroup =
                    config.roofsheet_types?.[area_design_specs[BASIC_SPECS_SECTIONS.ROOF_SHEETING].RoofGroupType];

                let skylight_not_allowed_cyclonic = false;
                if (is_cyclonic && roofsheetgroup && roofsheetgroup?.allow_skylight_cyclonic === false) {
                    skylight_not_allowed_cyclonic = true;
                }

                pop_menu_items.push(
                    <Typography
                        key="mod-roofsheet"
                        classes={{ root: classes.pop_header }}
                        variant="overline"
                        display="block"
                        gutterBottom
                    >
                        Modify Roof Sheet
                    </Typography>
                );
                pop_menu_items.push(
                    <MenuItem
                        key="add-skylight"
                        disabled={
                            pop_item.sky_light_disabled ||
                            !skylight ||
                            skylight_not_allowed_cyclonic ||
                            pop_item.sky_light_disabled_message != null
                        }
                        classes={{ root: classes.menu_item }}
                        onClick={() => {
                            this.togglePop(false);
                            pop_item.is_skylight = true;
                            this.UpdateSkylights(pop_item);
                        }}
                    >
                        Add Skylight
                        {pop_item.sky_light_disabled_message
                            ? ` (${pop_item.sky_light_disabled_message})`
                            : skylight_not_allowed_cyclonic
                            ? " (Cannot add in Cyclonic)"
                            : ""}
                    </MenuItem>
                );
                if (area_design_specs.ROOF_SHEETING?.RoofSheetData?.roofsheet_fan_bracket) {
                    const has_fan = area_design_specs?.Fans?.[pop_item.ref2]?.Type;
                    pop_menu_items.push(
                        <MenuItem
                            key="add-fan"
                            classes={{ root: classes.menu_item }}
                            onClick={() => {
                                this.togglePop(false);
                                this.handle_toggle_fan(pop_item, areaIndex, has_fan ? "" : "Standard");
                            }}
                        >
                            {has_fan ? "Remove" : "Add"} Fan
                        </MenuItem>
                    );
                } else {
                    pop_menu_items.push(
                        <MenuItem key="add-downlights" classes={{ root: classes.menu_item }} disabled>
                            Add Fan (N/A on {area_design_specs[BASIC_SPECS_SECTIONS.ROOF_SHEETING].RoofGroupType})
                        </MenuItem>
                    );
                }

                if (area_design_specs.ROOF_SHEETING?.RoofSheetData?.downlight_code) {
                    pop_menu_items.push(
                        <MenuItem key="add-downlights" classes={{ root: classes.menu_item }}>
                            Downlights{" "}
                            <BSL_Select
                                tight={true}
                                value={
                                    area_design_specs?.Downlights?.[pop_item.ref2]?.Type
                                        ? area_design_specs?.Downlights?.[pop_item.ref2]?.Type
                                        : ""
                                }
                                onChange={(e) => {
                                    this.togglePop(false);
                                    this.handle_add_downlights(pop_item, areaIndex, e.target.value);
                                }}
                                items={[{ Key: "", Display: "None" }, ...this.getDownlightOptions(areaIndex)]}
                            ></BSL_Select>
                        </MenuItem>
                    );
                } else {
                    pop_menu_items.push(
                        <MenuItem key="add-downlights" classes={{ root: classes.menu_item }} disabled>
                            Downlights (N/A on {area_design_specs[BASIC_SPECS_SECTIONS.ROOF_SHEETING].RoofGroupType})
                        </MenuItem>
                    );
                }
            } else if (pop_item.is_post && pop_item.deleted) {
                pop_menu_items.push(
                    <Typography
                        key="mod-shift"
                        classes={{ root: classes.pop_header }}
                        variant="overline"
                        display="block"
                        gutterBottom
                    >
                        Deleted Post
                    </Typography>
                );
                let delete_post_role_access = config?.role_access?.designer?.delete_post ?? 91;
                if (this?.props?.app?.user?.Role && this.props.app.user.Role >= delete_post_role_access)
                    pop_menu_items.push(
                        <MenuItem
                            key="modify-undelete-post"
                            classes={{ root: classes.menu_item }}
                            onClick={() => this.toggleDeletePost(pop_item, areaIndex, false)}
                            style={{ minWidth: "270px" }}
                        >
                            Un-delete Post{" "}
                            <span className={classes.super_text}>{convertRoleCodeToName(delete_post_role_access)}</span>
                        </MenuItem>
                    );
            } else if (pop_item.is_post || pop_item.is_footing) {
                let col_headers = null;
                let col_headers_split = null;
                let columns_section = false;
                let coltype_index = null;
                let embedment_index = null;
                let embed = null;
                let compression_index = null;
                let compression = null;
                let deflection = null;

                const areaPostType = area_design_specs?.BEAMS_AND_POSTS?.PostType;
                const areaPostMods = area_design_specs?.POSTMODIFICATIONS;
                const postRef = pop_item?.ref5 ?? pop_item?.ref ?? null;
                const postRef2 = pop_item?.ref2 ?? pop_item?.ref4 ?? null;
                const postName =
                    getItemFromArray(areaPostMods, "Ref", postRef, "Ref2", postRef2)?.Section || areaPostType;
                const postObject = this.props.config?.post_types?.[postName];

                let loads = this.props.job.QuoteParameters?.ENGINEERING?.EngineeringLoads;
                if (loads !== undefined) {
                    var splitted = loads.split(/\r?\n/);

                    for (let split of splitted) {
                        if (split.includes("***COLUMNS***")) columns_section = true;
                        if (columns_section) {
                            if (split.startsWith("NAME|")) {
                                col_headers = split;
                                col_headers_split = col_headers.split("|");
                                coltype_index = col_headers_split.indexOf("COLUMN_TYPE");
                                embedment_index = col_headers_split.indexOf("EMBEDMENT");
                                compression_index = col_headers_split.indexOf("total_compression_kn");
                            } else if (col_headers_split) {
                                let col_split = split.split("|");
                                embed = Number(col_split[embedment_index]);
                                compression = col_split[compression_index];
                            }
                        }
                    }
                }

                let col_results =
                    this.props.job.QuoteParameters?.ENGINEERING?.EngineeringResults?.ColumnResultsDetailed;
                if (col_results && pop_item.nameQQ) {
                    if (col_results[pop_item.nameQQ]) {
                        embed = col_results[pop_item.nameQQ].embedment;
                        compression = col_results[pop_item.nameQQ].total_compression_kn;
                        deflection = col_results[pop_item.nameQQ].max_deflection_mm;
                    }
                }

                if (!deflection && pop_item.deflection) {
                    deflection = pop_item.deflection;
                }

                let default_FootingType = area_design_specs?.[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS].FootingType;
                let default_PostExternalConnectors =
                    area_design_specs?.[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS].PostExternalConnectors;

                if (default_FootingType === "Bolt to Slab") {
                    if (default_PostExternalConnectors === 1 || default_PostExternalConnectors === 2)
                        default_FootingType += " (External Connector)";
                    else default_FootingType += " (Internal Connector)";
                }

                let footingType = default_FootingType;

                const areaFootingMods = area_design_specs?.Footings;

                let ref = pop_item.is_footing ? pop_item.ref2 : pop_item?.ref5 ? pop_item?.ref5 : pop_item.ref;
                let footing_mod = areaFootingMods
                    ? getItemFromArray(areaFootingMods, "Ref", pop_item.ref, "Ref2", pop_item.ref2, 100)
                    : null;
                if (!footing_mod) {
                    footing_mod = areaFootingMods
                        ? getItemFromArray(areaFootingMods, "Ref", pop_item.ref, "Ref2", pop_item.ref2, 150)
                        : null;
                }

                if (footing_mod) {
                    let connector_text = "";
                    if (footing_mod.Kind.includes("Bolt") && footing_mod.Connector === 1)
                        connector_text = " (Internal Connector)";
                    if (footing_mod.Kind.includes("Bolt") && footing_mod.Connector === 2)
                        connector_text = " (External Connector)";
                    footingType = footing_mod.Kind + connector_text;
                }

                let footing_options = [];
                const concreteInGround = { Key: "Concrete In", Display: "Concrete in Ground" };
                const boltToSlabInternal = {
                    Key: "Bolt to Slab (Internal Connector)",
                    Display: "Bolt to Slab (Internal Connector)",
                    disabled: false,
                };
                const boltToSlabExternal = {
                    Key: "Bolt to Slab (External Connector)",
                    Display: "Bolt to Slab (External Connector)",
                    disabled: false,
                };
                const boltToDeck = {
                    Key: "Bolt to Deck",
                    Display: "Bolt to Deck",
                    disabled: false,
                };

                let internalSlabConnKey = "";
                if (postObject)
                    internalSlabConnKey = Object.keys(postObject).find(
                        (key) => key.includes("Base_Plate_Code") && key.includes("Internal")
                    );

                if (!internalSlabConnKey || postObject[internalSlabConnKey].trim() === "") {
                    boltToSlabInternal.disabled = true;
                    boltToSlabInternal.disabledTooltip = "Post does not have an internal slab connector";
                    boltToDeck.disabled = true;
                    boltToDeck.disabledTooltip = "Post does not have an internal slab connector";
                }

                if (window.LYSAGHT) {
                    boltToSlabExternal.Display = "Bolt to Slab Flange Post";

                    if (postObject?.allow_flanged === false) {
                        boltToSlabExternal.disabled = true;
                        boltToSlabExternal.disabledTooltip = "Flanged is not available in this post type";
                    }

                    if (job?.DesignParameters?.Freestanding) {
                        boltToSlabInternal.disabled = true;
                        boltToSlabInternal.disabledTooltip = "Bolt to Slab is not available in Freestanding structures";
                    }

                    if (job?.DesignParameters?.Freestanding) {
                        boltToDeck.disabled = true;
                        boltToDeck.disabledTooltip = "Bolt to Deck is not available in Freestanding structures";
                    }

                    if (is_cyclonic) {
                        boltToSlabInternal.disabled = true;
                        boltToSlabInternal.disabledTooltip = "Bolt to Slab is not available in Cyclonic regions";
                    }

                    footing_options = [concreteInGround, boltToSlabInternal, boltToSlabExternal, boltToDeck];
                } else {
                    let externalSlabConnKey = "";
                    if (postObject)
                        externalSlabConnKey = Object.keys(postObject).find(
                            (key) => key.includes("Base_Plate_Code") && key.includes("External")
                        );

                    if (!externalSlabConnKey || postObject[externalSlabConnKey].trim() === "") {
                        boltToSlabExternal.disabled = true;
                        boltToSlabExternal.disabledTooltip = "Post does not have an external slab connector";
                    }

                    if (job?.DesignParameters?.Freestanding || this.isPostRHS(pop_item, areaIndex)) {
                        boltToSlabExternal.disabled = true;
                        boltToSlabExternal.disabledTooltip =
                            "External Connector is not available in Freestanding structures";
                        boltToSlabInternal.disabled = true;
                        boltToSlabInternal.disabledTooltip = "Bolt to Slab is not available in Freestanding structures";
                    }
                    footing_options = [concreteInGround, boltToSlabInternal, boltToSlabExternal];
                }

                pop_menu_items.push(
                    <Typography
                        key="modify-post-footing"
                        classes={{ root: classes.pop_header }}
                        variant="overline"
                        display="block"
                        gutterBottom
                    >
                        Modify Post & Footing
                    </Typography>
                );
                pop_menu_items.push(
                    <MenuItem
                        key="modify-post"
                        classes={{ root: classes.menu_item }}
                        onClick={() => this.toggleMod_post_dialog(true, pop_item)}
                    >
                        Modify Post...
                    </MenuItem>
                );
                // if (
                //     !window.LYSAGHT &&
                //     area_design_specs.SHAPE.DesignType === CONFIG.DESIGN_TYPES.GABLE_PORTAL &&
                //     (pop_item.ref4 || pop_item?.post_data?.ref4)
                // ) {
                //     pop_menu_items.push(
                //         <MenuItem
                //             key="remove-portal-column"
                //             classes={{ root: classes.menu_item }}
                //             onClick={() =>
                //                 this.handleRemovePortalColumn(
                //                     areaIndex,
                //                     pop_item?.post_data ? pop_item?.post_data : pop_item
                //                 )
                //             }
                //         >
                //             Remove Portal Column
                //         </MenuItem>
                //     );
                // }
                pop_menu_items.push(
                    <MenuItem
                        key="add-downpipe"
                        classes={{ root: classes.menu_item }}
                        onClick={() => {
                            this.toggleMod_downpipe_dialog(true, pop_item);
                        }}
                    >
                        Add Downpipe...
                    </MenuItem>
                );

                if (pop_item?.align_swappable) {
                    pop_menu_items.push(
                        <MenuItem
                            key="swap-corner-post-beam-alignment"
                            classes={{ root: classes.menu_item }}
                            onClick={() =>
                                this.handleSwapPostAlignment(
                                    areaIndex,
                                    pop_item?.post_data ? pop_item?.post_data : pop_item
                                )
                            }
                        >
                            Swap Corner Post Beam Alignment
                        </MenuItem>
                    );
                }
                let delete_post_role_access = config?.role_access?.designer?.delete_post ?? 91;
                if (this?.props?.app?.user?.Role && this.props.app.user.Role >= delete_post_role_access)
                    pop_menu_items.push(
                        <MenuItem
                            key="modify-delete-post"
                            classes={{ root: classes.menu_item }}
                            onClick={() => this.toggleDeletePost(pop_item, areaIndex, true)}
                            style={{ minWidth: "270px" }}
                        >
                            Delete Post{" "}
                            <span className={classes.super_text}>{convertRoleCodeToName(delete_post_role_access)}</span>
                        </MenuItem>
                    );
                pop_menu_items.push(<Divider key="divider-1" classes={{ root: classes.divider }} />);
                pop_menu_items.push(
                    <Typography
                        key="footing-heading"
                        classes={{ root: classes.pop_specs_header }}
                        variant="overline"
                        display="block"
                        gutterBottom
                    >
                        FOOTING
                    </Typography>
                );
                pop_menu_items.push(
                    <MenuItem key="footing-type" classes={{ root: classes.menu_item }}>
                        Footing Type :&nbsp;
                        <BSL_Select
                            tight={true}
                            value={footingType}
                            onChange={(e) => this.handleFootingUpdate(e, default_FootingType, pop_item, footing_mod)}
                            items={footing_options}
                        ></BSL_Select>
                    </MenuItem>
                );

                (!job?.DesignParameters?.Freestanding || footingType === "Concrete In") &&
                    pop_menu_items.push(
                        <Button
                            key="apply-to-all-areas"
                            onClick={() => this.matchAllFootingInThisArea(footingType, areaIndex)}
                            classes={{ root: classes.pop_specs_small_text }}
                            color="secondary"
                        >
                            APPLY TO ALL FOOTINGS IN AREA {pop_item.areaNumber}
                        </Button>
                    );

                if (pop_item?.lengthQQ) {
                    pop_menu_items_details.push(
                        <Typography
                            key="post-length"
                            classes={{ root: classes.pop_specs }}
                            variant="caption"
                            display="block"
                        >
                            <span style={{ fontWeight: 600 }}>Post Length:</span> {pop_item?.lengthQQ.toFixed(0)} mm
                        </Typography>
                    );
                }

                {
                    embed &&
                        pop_menu_items_details.push(
                            <Typography
                                key="embedment"
                                classes={{ root: classes.pop_specs }}
                                variant="caption"
                                display="block"
                            >
                                <span style={{ fontWeight: 600 }}>Embedment:</span> {embed} mm
                            </Typography>
                        );
                }

                {
                    compression !== undefined &&
                        pop_menu_items_details.push(
                            <Typography
                                key="tot-compression-load"
                                classes={{ root: classes.pop_specs }}
                                variant="caption"
                                display="block"
                            >
                                <span style={{ fontWeight: 600 }}>Total Compression Load:</span>{" "}
                                {Number(compression).toFixed(2)} kN
                            </Typography>
                        );
                }

                {
                    deflection !== undefined &&
                        pop_menu_items_details.push(
                            <Typography
                                key="max-deflection"
                                classes={{ root: classes.pop_specs }}
                                variant="caption"
                                display="block"
                            >
                                <span style={{ fontWeight: 600 }}>Max Deflection:</span> {Number(deflection).toFixed(1)}{" "}
                                mm
                            </Typography>
                        );
                }
            } else if (pop_item.is_beam && pop_item.deleted) {
                pop_menu_items.push(
                    <Typography
                        key="mod-shift"
                        classes={{ root: classes.pop_header }}
                        variant="overline"
                        display="block"
                        gutterBottom
                    >
                        Deleted Beam
                    </Typography>
                );
                let delete_beam_role_access = config?.role_access?.designer?.delete_beam ?? 91;
                if (this?.props?.app?.user?.Role && this.props.app.user.Role >= delete_beam_role_access)
                    pop_menu_items.push(
                        <MenuItem
                            key="modify-extend-beam"
                            classes={{ root: classes.menu_item }}
                            onClick={() => this.toggleDeleteBeam(pop_item, areaIndex, false)}
                            style={{ minWidth: "270px" }}
                        >
                            Un-delete beam{" "}
                            <span className={classes.super_text}>{convertRoleCodeToName(delete_beam_role_access)}</span>
                        </MenuItem>
                    );
            } else if (pop_item.is_beam) {
                // DRAW DIRECTION ARROWS
                if (pop_item?.segments) {
                    let start_pnt = pop_item.segments[0].point;
                    let end_pnt = pop_item.segments[1].point;

                    if (pop_item?.ref && window?.origin_convert_reverse) {
                        let ref4_split = pop_item?.ref.split(";");
                        start_pnt = getPointForRef(ref4_split[0]);
                        start_pnt = window.origin_convert_reverse(start_pnt);

                        start_pnt = new paper.Point(start_pnt.x, start_pnt.y);

                        end_pnt = getPointForRef(ref4_split[1]);
                        end_pnt = window.origin_convert_reverse(end_pnt);

                        end_pnt = new paper.Point(end_pnt.x, end_pnt.y);
                    }

                    paper.project.activeLayer.start_mark = new paper.Path.Circle({
                        center: start_pnt,
                        radius: 300,
                        fillColor: null,
                        strokeColor: "darkgreen",
                        strokeWidth: 30,
                        dashArray: [30, 20],
                    });
                    paper.project.activeLayer.end_mark = new paper.Path.Circle({
                        center: end_pnt,
                        radius: 300,
                        fillColor: null,
                        strokeColor: "darkred",
                        strokeWidth: 30,
                        dashArray: [30, 20],
                    });
                }

                let NumExtraPostsFront1 = get(
                    job,
                    "AreaSpecifications." + areaIndex + ".BEAMS_AND_POSTS.NumExtraPostsFront1"
                );
                let NumInternalRafters = get(
                    job,
                    "AreaSpecifications." + areaIndex + ".BEAMS_AND_POSTS.NumInternalRafters"
                );
                let NumExtraPurlins = get(job, "AreaSpecifications." + areaIndex + ".BEAMS_AND_POSTS.NumExtraPurlins");

                let isExtraBeam = pop_item?.Extra;

                let first_rafter_omitted = get(
                    job,
                    "AreaSpecifications." + areaIndex + ".BEAMS_AND_POSTS.OmitLeftBeam"
                );
                let last_rafter_omitted = get(
                    job,
                    "AreaSpecifications." + areaIndex + ".BEAMS_AND_POSTS.OmitRightBeam"
                );

                let beamType = pop_item.typeQQ ? pop_item.typeQQ : "";
                if (pop_item.typeQQ && pop_item.typeQQ === "beam" && pop_item.nameQQ) {
                    if (pop_item.nameQQ.startsWith("FB")) beamType = "beam1";
                    if (pop_item.nameQQ.startsWith("CB")) beamType = "beam1";
                    if (pop_item.nameQQ.startsWith("P")) beamType = "beam2";
                    if (pop_item.nameQQ.startsWith("R")) beamType = "beam3";
                    if (pop_item.nameQQ.startsWith("SF")) beamType = "beam3";
                }

                let beamTypeAreaColour = pop_item.colour;
                let beamTypeAreaSection = get(job, "AreaSpecifications." + areaIndex + ".BEAMS_AND_POSTS.BeamType1");
                let beamConfigType = config.design_options[DesignType].beam_1;
                if (beamType === "beam1") {
                    beamTypeAreaColour = get(job, "AreaSpecifications." + areaIndex + ".BEAMS_AND_POSTS.BeamCol1");
                    beamTypeAreaSection = get(job, "AreaSpecifications." + areaIndex + ".BEAMS_AND_POSTS.BeamType1");
                }
                if (beamType === "beam2") {
                    beamTypeAreaColour = get(job, "AreaSpecifications." + areaIndex + ".BEAMS_AND_POSTS.BeamCol2");
                    beamTypeAreaSection = get(job, "AreaSpecifications." + areaIndex + ".BEAMS_AND_POSTS.BeamType2");
                    beamConfigType = config.design_options[DesignType].beam_2;
                }
                if (beamType === "beam3") {
                    beamTypeAreaColour = get(job, "AreaSpecifications." + areaIndex + ".BEAMS_AND_POSTS.BeamCol3");
                    beamTypeAreaSection = get(job, "AreaSpecifications." + areaIndex + ".BEAMS_AND_POSTS.BeamType3");
                    beamConfigType = config.design_options[DesignType].beam_3;
                }
                if (beamType === "beam4") {
                    beamTypeAreaColour = get(job, "AreaSpecifications." + areaIndex + ".BEAMS_AND_POSTS.BeamCol4");
                    beamTypeAreaSection = get(job, "AreaSpecifications." + areaIndex + ".BEAMS_AND_POSTS.BeamType4");
                    beamConfigType = config.design_options[DesignType].beam_4;
                }

                let beam_menu_items = [];
                let default_beam_item = (
                    <MenuItem key={"Default"} value={"Default"}>
                        {"Default (" + beamTypeAreaSection + ")"}
                    </MenuItem>
                );

                for (let key in beamConfigType.options) {
                    beam_menu_items.push(<ListSubheader>{key}</ListSubheader>);
                    for (let key2 in beamConfigType.options[key]) {
                        let beam = beamConfigType.options[key][key2];
                        let id = beam.id ? beam.id : key2;
                        let name = beam.name ? beam.name : key2;
                        if (key2 === beamTypeAreaSection) {
                            default_beam_item = (
                                <MenuItem key={"Default"} value={"Default"}>
                                    {beam.thumbnail && (
                                        <div className={classes.roofsheet_chip}>
                                            <img alt="sheet thumb" src={beam.thumbnail} style={{ height: "32px" }} />
                                        </div>
                                    )}
                                    Default ({name})
                                </MenuItem>
                            );
                        } else {
                            beam_menu_items.push(
                                <MenuItem key={id} value={key2}>
                                    {beam.thumbnail && (
                                        <div className={classes.roofsheet_chip}>
                                            <img alt="sheet thumb" src={beam.thumbnail} style={{ height: "32px" }} />
                                        </div>
                                    )}
                                    {name}
                                </MenuItem>
                            );
                        }
                    }
                }

                beam_menu_items.splice(0, 0, default_beam_item);

                let PostCol = get(job, "AreaSpecifications." + areaIndex + ".BEAMS_AND_POSTS.PostCol");

                let colourMatch = {
                    Default: beamTypeAreaColour,
                    "Match Post": PostCol,
                };

                let beam_modifications = get(job, "AreaSpecifications." + areaIndex + ".BEAMMODIFICATIONS");

                let thisModification = null;

                if (pop_item.ref) {
                    for (var mod of beam_modifications) {
                        if (mod.Ref === pop_item.ref) thisModification = mod;
                    }
                }

                let beam_adjustments = get(job, "AreaSpecifications." + areaIndex + ".BEAMADJUSTMENTS");
                let thisAdjustment = null;

                if (pop_item.ref) {
                    for (var mod of beam_adjustments) {
                        if (mod.Ref === pop_item.ref2) thisAdjustment = mod;
                    }
                }

                let display_value =
                    pop_textfield_text === null
                        ? thisModification && thisModification.Length !== ""
                            ? thisModification.Length
                            : ""
                        : pop_textfield_text;
                if (display_value !== "") display_value = toNumber(display_value, false);

                let beam_adjustment_display =
                    beam_adjustment_display_value === null
                        ? thisAdjustment
                            ? thisAdjustment.Adjustment
                            : 0
                        : beam_adjustment_display_value;
                if (beam_adjustment_display !== "" && beam_adjustment_display !== "-")
                    beam_adjustment_display = toNumber(beam_adjustment_display, true);

                let beam_name = "Beam";
                if (isExtraBeam) beam_name = "Extra Beam";
                else if (beamType !== "beam" && beamConfigType.Name) beam_name = beamConfigType.Name;

                if (pop_item.beamName) beam_name += " (" + pop_item.beamName + ")";

                let is_cutout_beam = false;
                let cutoutType = "";
                let cutoutOverhang = 0;
                let cutoutBeamY = 1;
                let cutoutOverhangRef = "";
                if (pop_item.ref2) {
                    is_cutout_beam =
                        ((pop_item.ref2.startsWith("Back") || pop_item.ref2.startsWith("Front")) &&
                            pop_item.ref2.includes("-")) ||
                        pop_item.is_cutout;
                    if (is_cutout_beam) {
                        beam_name = "Cutout Beam";
                        cutoutType = area_design_specs.SHAPE.CUTOUTS[pop_item.ref2.split("-")[0] + "-CutoutType"];

                        cutoutOverhangRef =
                            pop_item.ref2.split("-")[0] + "-Overhang" + (pop_item.ref2.endsWith("Y") ? "Y" : "");
                        if (pop_item.ref2.includes("Custom")) {
                            cutoutOverhangRef =
                                pop_item.ref2.split("-")[0] +
                                "-" +
                                (toNumber(pop_item.ref2.split("/")[1]) + 1) +
                                "-CustomOverhang";
                        }

                        cutoutOverhang = area_design_specs.SHAPE.CUTOUTS[cutoutOverhangRef];
                        if (!cutoutOverhang) cutoutOverhang = 0;
                        cutoutBeamY = area_design_specs.SHAPE.CUTOUTS[pop_item.ref2.split("-")[0] + "-HasBeamY"];
                        display_value = pop_textfield_text === null ? cutoutOverhang : pop_textfield_text;
                    }
                }

                pop_menu_items.push(
                    <Typography
                        key="mod-shift"
                        classes={{ root: classes.pop_header }}
                        variant="overline"
                        display="block"
                        gutterBottom
                    >
                        Modify/Shift {beam_name}
                    </Typography>
                );

                if (beamType === "beam3" && is_flat && !is_cutout_beam)
                    pop_menu_items.push(
                        <MenuItem key="first-return-beam" classes={{ root: classes.menu_item }}>
                            First (Left) Return Beam :&nbsp;
                            <AreaSelectField
                                style={{ marginTop: "0px" }}
                                selectStyle={{ color: "black", marginTop: "0px" }}
                                value={toNumber(first_rafter_omitted)}
                                items={[
                                    { Key: 0, Display: "On" },
                                    { Key: 1, Display: "Off" },
                                    { Key: 2, Display: "If Required (eg; supports a purlin)" },
                                ]}
                                areaIndex={areaIndex}
                                section={BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS}
                                dataField="OmitLeftBeam"
                                clip_overflow
                                refresh_svg
                                onChange={(e) => {
                                    this.props.updateAreaSpecification(
                                        areaIndex,
                                        BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS,
                                        "OmitLeftBeam",
                                        e.target.value
                                    );
                                }}
                            />
                        </MenuItem>
                    );
                if (beamType === "beam3" && is_flat && !is_cutout_beam)
                    pop_menu_items.push(
                        <MenuItem key="last-return-beam" classes={{ root: classes.menu_item }}>
                            Last (Right) Return Beam :&nbsp;
                            <AreaSelectField
                                style={{ marginTop: "0px" }}
                                selectStyle={{ color: "black", marginTop: "0px" }}
                                value={toNumber(last_rafter_omitted)}
                                items={[
                                    { Key: 0, Display: "On" },
                                    { Key: 1, Display: "Off" },
                                    { Key: 2, Display: "If Required (eg; supports a purlin)" },
                                ]}
                                areaIndex={areaIndex}
                                section={BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS}
                                dataField="OmitRightBeam"
                                clip_overflow
                                refresh_svg
                                onChange={(e) => {
                                    this.props.updateAreaSpecification(
                                        areaIndex,
                                        BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS,
                                        "OmitRightBeam",
                                        e.target.value
                                    );
                                }}
                            />
                        </MenuItem>
                    );
                if (beamType === "beam1" && !is_cutout_beam) {
                    show_front_back_overhangs = true;
                }

                if (beamType === "beam3" || beamType === "beam2")
                    pop_menu_items.push(
                        <MenuItem key="num-extra-purlin-rows" classes={{ root: classes.menu_item }}>
                            Num Extra Purlin Rows :&nbsp;
                            <AreaSelectField
                                style={{ marginTop: "0px" }}
                                selectStyle={{ color: "black", marginTop: "0px" }}
                                value={toNumber(NumExtraPurlins)}
                                items={[...Array(13).keys()]}
                                areaIndex={areaIndex}
                                section={BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS}
                                dataField="NumExtraPurlins"
                                clip_overflow
                                refresh_svg
                                onChange={this.updateData(
                                    areaIndex,
                                    BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS,
                                    "NumExtraPurlins",
                                    true
                                )}
                            />
                        </MenuItem>
                    );
                if (!isExtraBeam)
                    pop_menu_items.push(
                        <MenuItem
                            key="mod-beam-specs"
                            classes={{ root: classes.menu_item }}
                            onClick={() => this.toggleMod_beam_dialog(true, pop_item)}
                        >
                            Modify Beam Specifications...
                        </MenuItem>
                    );
                pop_menu_items.push(
                    <MenuItem
                        key="mod-add-posts"
                        classes={{ root: classes.menu_item }}
                        onClick={() => this.toggleMod_beam_posts_dialog(true, pop_item)}
                    >
                        Modify/Add Posts & Splices...
                    </MenuItem>
                );

                let extend_role_access = config?.role_access?.designer?.extend_beam ?? 99;
                if (this?.props?.app?.user?.Role && this.props.app.user.Role >= extend_role_access)
                    pop_menu_items.push(
                        <MenuItem
                            key="modify-extend-beam"
                            classes={{ root: classes.menu_item }}
                            onClick={() => this.toggleExtendBeam(pop_item)}
                            style={{ minWidth: "270px" }}
                        >
                            Extend Beam...
                            <span className={classes.super_text}>{convertRoleCodeToName(extend_role_access)}</span>
                            <BSL_Button
                                tight
                                className={classes.mini_button}
                                onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    this.removeExtendBeam(pop_item);
                                }}
                            >
                                Reset
                            </BSL_Button>
                        </MenuItem>
                    );

                let delete_beam_role_access = config?.role_access?.designer?.delete_beam ?? 91;
                if (this?.props?.app?.user?.Role && this.props.app.user.Role >= delete_beam_role_access && !isExtraBeam)
                    pop_menu_items.push(
                        <MenuItem
                            key="modify-extend-beam"
                            classes={{ root: classes.menu_item }}
                            onClick={() => this.toggleDeleteBeam(pop_item, areaIndex, true)}
                            style={{ minWidth: "270px" }}
                        >
                            Delete Beam{" "}
                            <span className={classes.super_text}>{convertRoleCodeToName(delete_beam_role_access)}</span>
                        </MenuItem>
                    );

                if (
                    !window.LYSAGHT &&
                    area_design_specs.SHAPE.DesignType === CONFIG.DESIGN_TYPES.GABLE_PORTAL &&
                    pop_item.ref2
                ) {
                    let ref = pop_item.ref2;
                    let add_post = false;
                    if (area_design_specs?.PORTALPOSTS) {
                        for (let item of area_design_specs?.PORTALPOSTS) {
                            if (item.Ref === ref) add_post = true;
                        }
                    }

                    if (pop_item?.beamName) {
                        if (pop_item.beamName.includes("No Post")) add_post = true;
                        if (pop_item.beamName.includes("Portal Rafter (Standard)")) add_post = false;
                    }
                    if (ref.includes("Jack")) add_post = !add_post;

                    let item_exists = false;
                    if (area_design_specs?.PORTALPOSTS) {
                        for (let item of area_design_specs?.PORTALPOSTS) {
                            if (item.Ref === ref) item_exists = true;
                        }
                    }

                    if (item_exists) {
                        pop_menu_items.push(
                            <MenuItem
                                key="add-remove-portal-column"
                                classes={{ root: classes.menu_item }}
                                onClick={() => this.handleRemovePortalColumn(areaIndex, pop_item)}
                            >
                                {add_post ? "Add" : "Remove"} Portal Column
                            </MenuItem>
                        );
                    }
                }
                if (isExtraBeam) {
                    pop_menu_items.push(
                        <MenuItem
                            key="edit-extra-beam"
                            classes={{ root: classes.menu_item }}
                            onClick={() => this.toggleEdit_extra_beam_dialog(true)}
                        >
                            Edit Extra Beam Details...
                        </MenuItem>
                    );
                    pop_menu_items.push(
                        <MenuItem
                            key="del-extra-beam"
                            classes={{ root: classes.menu_item }}
                            onClick={() => {
                                this.togglePop(false);
                                this.props.deleteFromAreaSpecificationModificationArray(
                                    areaIndex,
                                    "NewBeams",
                                    pop_item.ref5
                                );
                            }}
                        >
                            Delete Extra Beam
                        </MenuItem>
                    );
                }
                if (is_cutout_beam) {
                    let max_overhang_xy =
                        area_design_specs?.[BASIC_SPECS_SECTIONS.ROOF_SHEETING]?.RoofSheetData?.max_overhang_xy;
                    if (pop_item.ref2.endsWith(" Y") || pop_item.ref2.endsWith(" Y2")) {
                        max_overhang_xy =
                            area_design_specs?.[BASIC_SPECS_SECTIONS.ROOF_SHEETING]?.RoofSheetData?.max_side_overhang;
                    }

                    pop_menu_items.push(
                        <Typography
                            key="cutout-settings"
                            classes={{ root: classes.pop_header }}
                            variant="overline"
                            display="block"
                            gutterBottom
                        >
                            Cutout Settings
                        </Typography>
                    );

                    pop_menu_items.push(
                        <MenuItem key="cutout-type-2" classes={{ root: classes.menu_item }}>
                            Cutout Type :&nbsp;
                            <AreaSelectField
                                value={cutoutType}
                                dark
                                items={
                                    pop_item?.ref2?.startsWith("BackMid")
                                        ? ["None", "Box", "Bay"]
                                        : ["None", "Angle", "Step", "Custom"]
                                }
                                clip_overflow
                                onChange={(e) => {
                                    this.togglePop(false);
                                    this.props.updateAreaSpecification(
                                        areaIndex,
                                        BASIC_SPECS_SECTIONS.SHAPE + ".CUTOUTS",
                                        pop_item.ref2.split("-")[0] + "-CutoutType",
                                        e.target.value
                                    );
                                }}
                            />
                        </MenuItem>
                    );
                    //toggle cutout "Y" beams
                    if (cutoutType !== "None") {
                        let label = "Cutout Side Beams";
                        let cutout_beam_ref = pop_item.ref2.split("-")[0] + "-HasBeamY";
                        if (cutoutType === "Custom") {
                            let split = pop_item.ref2.split("/");
                            let split2 = split[0].split("-");
                            let side = split2[0];
                            let cutout_index = toNumber(split[1]) + 1; // because beam refs are indexed from 0, and cutouts are from 1
                            cutout_beam_ref = side + "-" + cutout_index + "-CustomHasBeam";

                            cutoutBeamY = area_design_specs.SHAPE.CUTOUTS[cutout_beam_ref];
                            label = "Cutout Side Beam";
                        }
                        console.log("pop_item", pop_item, cutout_beam_ref, label, cutoutBeamY);

                        pop_menu_items.push(
                            <MenuItem key="cutout-side-beams-2" classes={{ root: classes.menu_item }}>
                                {label} :&nbsp;
                                <AreaSelectField
                                    style={{ marginTop: "0px" }}
                                    selectStyle={{ color: "black", marginTop: "0px" }}
                                    value={toNumber(cutoutBeamY)}
                                    items={[
                                        { Key: 0, Display: "Off" },
                                        { Key: 1, Display: "On" },
                                    ]}
                                    clip_overflow
                                    onChange={(e) => {
                                        this.togglePop(false);
                                        this.props.updateAreaSpecification(
                                            areaIndex,
                                            BASIC_SPECS_SECTIONS.SHAPE + ".CUTOUTS",
                                            cutout_beam_ref,
                                            e.target.value
                                        );
                                    }}
                                />
                            </MenuItem>
                        );
                    }
                    pop_menu_items.push(
                        <MenuItem key="cutout-overhang-2" classes={{ root: classes.menu_item }}>
                            Cutout Overhang :&nbsp;{" "}
                            <BSL_TextInput
                                value={display_value}
                                style={{ color: "black", width: "100px", margin: "0px" }}
                                tight
                                endAdornment="mm"
                                min={0}
                                max={max_overhang_xy}
                                tooltipDelay={500}
                                onFocus={(event) => {
                                    event.target.select();
                                }}
                                onBlur={(val) => {
                                    this.props.updateAreaSpecification(
                                        areaIndex,
                                        BASIC_SPECS_SECTIONS.SHAPE + ".CUTOUTS",
                                        cutoutOverhangRef,
                                        val
                                    );
                                    this.setState({ pop_textfield_text: null });
                                }}
                                onKeyPress={(e) => {
                                    if (e.key === "Enter") {
                                        this.togglePop(false);
                                        e.target.blur();
                                    }
                                }}
                                onChange={(val) => {
                                    this.setState({ pop_textfield_text: val });
                                }}
                                disabled={max_overhang_xy === 0}
                            />
                        </MenuItem>
                    );
                    if (cutoutType === "Custom") {
                        pop_menu_items.push(
                            <MenuItem key="num-cust-segs-2" classes={{ root: classes.menu_item }}>
                                Num Custom Segments :&nbsp;
                                <AreaSelectField
                                    style={{ marginTop: "0px" }}
                                    selectStyle={{ color: "black", marginTop: "0px" }}
                                    value={
                                        area_design_specs.SHAPE.CUTOUTS[
                                            pop_item.ref2.split("-")[0] + "-CustomNumSegments"
                                        ]
                                    }
                                    items={[2, 3, 4, 5, 6]}
                                    areaIndex={areaIndex}
                                    section={BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS}
                                    clip_overflow
                                    refresh_svg
                                    onChange={this.updateData(
                                        areaIndex,
                                        BASIC_SPECS_SECTIONS.SHAPE + ".CUTOUTS",
                                        pop_item.ref2.split("-")[0] + "-CustomNumSegments",
                                        true
                                    )}
                                />
                            </MenuItem>
                        );
                    }
                }

                //DES-179 - Need to be able to see elevation dimensions easily
                Object.byString = function (o, s) {
                    s = s.replace(/\[(\w+)\]/g, ".$1"); // convert indexes to properties
                    s = s.replace(/^\./, ""); // strip a leading dot
                    var a = s.split(".");

                    for (var i = 0, n = a.length; i < n; ++i) {
                        var k = a[i];
                        if (k in o) {
                            o = o[k];
                        } else {
                            return;
                        }
                    }
                    return o;
                };

                let popBeam = null;
                if (pop_item?.typeQQ) popBeam = pop_item?.typeQQ.toString();
                //changes beam1/2/3 to beam_1/2/3
                let position = null;
                if (popBeam) position = popBeam.search(/\d/);
                if (position) {
                    popBeam = [popBeam.slice(0, position), "_", popBeam.slice(position)].join("");

                    let beamTypeSection = beamTypeAreaSection;
                    if (thisModification && thisModification?.Section) beamTypeSection = thisModification?.Section;
                    let beamTypeDepth = Object.byString(config.beam_types, beamTypeSection)?.depth.toString();

                    let beamHeight = pop_item.ref.split(/[;/())]+/);

                    let zHeight = Math.min(beamHeight[3], beamHeight[6]);

                    if (pop_item?.lengthQQ) {
                        pop_menu_items_details.push(
                            <Typography
                                key="beam-length"
                                classes={{ root: classes.pop_specs }}
                                variant="caption"
                                display="block"
                                gutterBottom
                            >
                                <span style={{ fontWeight: "bold" }}>Beam Length:</span> {pop_item?.lengthQQ.toFixed(0)}{" "}
                                mm
                            </Typography>
                        );
                    }
                    pop_menu_items_details.push(
                        <Typography
                            key="clear-head-height"
                            classes={{ root: classes.pop_specs }}
                            variant="caption"
                            display="block"
                            gutterBottom
                        >
                            <span style={{ fontWeight: "bold" }}>Clear Head Height:</span>{" "}
                            {(zHeight - Number(beamTypeDepth)).toFixed(0)} mm (underside of beam)
                        </Typography>
                    );

                    pop_menu_items_details.push(
                        <Typography
                            key="beam-deflection"
                            classes={{ root: classes.pop_specs }}
                            style={{ display: "flex" }}
                            variant="caption"
                            display="block"
                            gutterBottom
                        >
                            <span style={{ fontWeight: "bold" }}>Max Deflection:</span>{" "}
                            <div style={{ paddingLeft: "5px" }}>
                                {pop_item?.deflection !== undefined
                                    ? pop_item?.deflection.split(";").map((line, idx) => (
                                          <React.Fragment key={idx}>
                                              {line}
                                              {idx < pop_item.deflection.split(";").length - 1 && <br />}
                                          </React.Fragment>
                                      ))
                                    : "N/A"}
                            </div>
                        </Typography>
                    );
                }
            }

            let show_attachment_and_gutter_options = false;
            if (pop_item.is_beam && is_portal) {
                if (pop_item.typeQQ === "beam3") show_attachment_and_gutter_options = true;
                if (pop_item.infill_1_beam !== undefined) show_attachment_and_gutter_options = true;
                if (pop_item.infill_2_beam !== undefined) show_attachment_and_gutter_options = true;
            }
            if (
                pop_item.is_beam &&
                pop_item.ref2 &&
                (pop_item.ref2.includes("Back/") || pop_item.ref2.includes("Front/") || pop_item.ref2.includes("Beam/"))
            ) {
                show_attachment_and_gutter_options = true;
            }

            if (is_louvre) {
                show_attachment_and_gutter_options = false;
            }

            if (
                (pop_item.is_attachment || pop_item.is_attachment_ghost || pop_item.is_attachment_roof) &&
                pop_item?.segments
            ) {
                // DRAW DIRECTION ARROWS
                paper.project.activeLayer.start_mark = new paper.Path.Circle({
                    center: pop_item.segments[pop_item.is_attachment_ghost ? 1 : 0].point,
                    radius: 300,
                    fillColor: null,
                    strokeColor: "darkgreen",
                    strokeWidth: 30,
                    dashArray: [30, 20],
                });
                paper.project.activeLayer.end_mark = new paper.Path.Circle({
                    center: pop_item.segments[pop_item.is_attachment_ghost ? 0 : 1].point,
                    radius: 300,
                    fillColor: null,
                    strokeColor: "darkred",
                    strokeWidth: 30,
                    dashArray: [30, 20],
                });
            }

            if (
                (pop_item.is_attachment ||
                    pop_item.is_attachment_ghost ||
                    pop_item.is_gutter ||
                    pop_item.is_attachment_roof ||
                    pop_item.is_barge ||
                    pop_item.is_cutout ||
                    pop_item.is_infill ||
                    show_attachment_and_gutter_options) &&
                pop_item.ref &&
                !pop_item.is_post &&
                DesignType !== CONFIG.DESIGN_TYPES.DECK
            ) {
                const area_design_specs = get(job, "AreaSpecifications." + areaIndex);
                let ref_data = GetRefs(pop_item, area_design_specs);

                let ref = pop_item.ref;
                let cutout = ref_data.IsCutout;
                let gutter_tag = ref_data.GutterRef;
                let attach_tag = ref_data.AttachmentRef;

                let cutout_prefix = ref_data.CutoutPrefix;

                let cutoutType = "";
                let cutoutOverhangRef = "";
                let cutoutOverhang = 0;

                if (cutout) {
                    cutoutType = area_design_specs?.SHAPE?.CUTOUTS?.[cutout_prefix + "-CutoutType"];
                    cutoutOverhangRef = cutout_prefix + "-Overhang";
                    if (attach_tag) cutoutOverhangRef = attach_tag.replace("Attachment", "Overhang");
                    if (gutter_tag.includes("-CustomHasGutter")) {
                        cutoutOverhangRef = gutter_tag.replace("HasGutter", "Overhang");
                    }
                    if ((gutter_tag.endsWith("Y") || attach_tag.endsWith("Y")) && !cutoutOverhangRef.endsWith("Y"))
                        cutoutOverhangRef += "Y";
                    cutoutOverhang = area_design_specs?.SHAPE?.CUTOUTS?.[cutoutOverhangRef];
                    if (!cutoutOverhang) cutoutOverhang = 0;
                }

                let cutout_overhangValue = pop_textfield_text === null ? cutoutOverhang : pop_textfield_text;

                let side_is_attached;
                if (cutout)
                    side_is_attached = get(area_design_specs, BASIC_SPECS_SECTIONS.SHAPE + ".CUTOUTS." + attach_tag);
                else side_is_attached = get(area_design_specs, BASIC_SPECS_SECTIONS.ATTACHMENTS + "." + attach_tag);

                if (pop_item.at_attachment !== undefined) {
                    side_is_attached = pop_item.at_attachment;
                }

                let side_has_gutter;
                if (cutout)
                    side_has_gutter = get(area_design_specs, BASIC_SPECS_SECTIONS.SHAPE + ".CUTOUTS." + gutter_tag);
                else side_has_gutter = area_design_specs?.[BASIC_SPECS_SECTIONS.GUTTERS_AND_DOWNPIPES]?.[gutter_tag];

                let this_PAAT;

                let paats = area_design_specs?.ATTACHMENTS?.PARTIAL_ATTACHMENTS;
                if (ref && paats) {
                    for (var mod of paats) {
                        if (mod.Ref.includes(attach_tag.replace("Attachment", ""))) {
                            this_PAAT = { ...mod };
                            break;
                        } else if (mod.Ref.includes(pop_item.ref2)) {
                            this_PAAT = { ...mod };
                            break;
                        }
                    }
                }
                if (gutter_tag.includes("_HasGutter")) {
                    let index = toNumber(gutter_tag.replace("_HasGutter", "").replace("_", ""));
                    this_PAAT = paats?.[index - 1];
                }

                if (this_PAAT) {
                    if (gutter_tag.includes("_HasGutter") || pop_item.is_attachment_ghost) {
                        side_has_gutter = this_PAAT.HasGutter;
                    }
                }

                let this_mods = getItemFromArray(
                    area_design_specs?.[BASIC_SPECS_SECTIONS.ATTACHMENTS]?.AttachmentModifications,
                    "Ref",
                    pop_item.ref2
                );

                // if (this_PAAT) {
                //     if (
                //         pop_item.is_attachment_ghost &&
                //         side_is_attached &&
                //         area_design_specs.SHAPE.DesignType === CONFIG.DESIGN_TYPES.FLAT
                //     )
                //         side_has_gutter = this_PAAT?.HasGutter;
                // }

                // let side_has_attachment_gutter = get(
                //     area_design_specs,
                //     BASIC_SPECS_SECTIONS.GUTTERS_AND_DOWNPIPES +
                //         (!gutter_tag.includes("Attachment") ? ".Attachment" : ".") +
                //         gutter_tag
                // );

                let show_attachment_options = true;
                if (cutout && cutoutType === "None") {
                    show_attachment_options = false;
                }

                pop_menu_items.push(
                    <Typography
                        key="mod-gutter-attach"
                        classes={{ root: classes.pop_header }}
                        variant="overline"
                        display="block"
                        gutterBottom
                    >
                        Modify Gutter/Attachment
                    </Typography>
                );

                pop_item.attach_tag = attach_tag;
                pop_item.gutter_tag = gutter_tag;

                if (
                    gutter_tag === "GutterF" ||
                    gutter_tag == "GutterB" ||
                    attach_tag === "AttachmentBottom" ||
                    attach_tag === "AttachmentTop"
                )
                    show_front_back_overhangs = true;

                if (show_attachment_options) {
                    let AttachmentType = "";
                    let FasciaType = "";
                    if (job?.DesignParameters.USE_ATTACHMENTS_2) {
                        let attach_item = pop_item;

                        //fix up item if attachment one in paper
                        let search = Paper.GetItems({ ref: attach_tag, ref2: pop_item?.ref2, areaIndex: areaIndex });
                        if (search.length == 0 && pop_item?.ref2?.startsWith("C")) {
                            // for cutouts
                            search = Paper.GetItems({ ref: pop_item.ref, ref2: pop_item?.ref2, areaIndex: areaIndex });
                        }
                        if (search.length == 0) search = Paper.GetItems({ ref: attach_tag, areaIndex: areaIndex });
                        if (search && search.length > 0) {
                            attach_item = search[0];
                        }

                        let attach_mod = area_design_specs?.ATTACHMENTS?.AttachmentModifications.filter(
                            (e) => e.Ref === attach_item["ref2"]
                        )[0];
                        if (attach_mod) {
                            AttachmentType = attach_mod?.AttachmentType ?? "";
                            FasciaType = attach_mod?.FasciaType ?? "";
                        }

                        if (side_is_attached || pop_item.is_attachment) {
                            pop_menu_items.push(
                                <MenuItem
                                    key="modify-attachment-3"
                                    classes={{ root: classes.menu_item }}
                                    onClick={() => this.toggleMod_attachment2_dialog(true, attach_item)}
                                    style={{ minWidth: "270px" }}
                                >
                                    Modify Attachment...{" "}
                                    <BSL_Button
                                        tight
                                        className={classes.mini_button}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            this.attachSide(
                                                areaIndex,
                                                attach_tag,
                                                gutter_tag,
                                                true,
                                                job,
                                                attach_item
                                            )(e);
                                        }}
                                    >
                                        Unattach
                                    </BSL_Button>
                                </MenuItem>
                            );
                        } else {
                            pop_menu_items.push(
                                <MenuItem
                                    key="attach-this-side-2"
                                    classes={{ root: classes.menu_item }}
                                    onClick={(e) => {
                                        let attach_item = pop_item;
                                        //fix up item if attachment one in paper
                                        let search = Paper.GetItems({ ref: attach_tag, areaIndex: areaIndex });
                                        if (search && search.length > 0) {
                                            attach_item = search[0];
                                        }
                                        this.toggleMod_attachment2_dialog(true, attach_item, () => {
                                            this.attachSide(
                                                areaIndex,
                                                attach_tag,
                                                gutter_tag,
                                                false,
                                                job,
                                                attach_item
                                            )(e);
                                        });
                                    }}
                                >
                                    Attach this side...
                                </MenuItem>
                            );
                        }
                    } else {
                        pop_menu_items.push(
                            <MenuItem
                                key="attach-this-side"
                                classes={{ root: classes.menu_item }}
                                onClick={(e) => {
                                    let attach_item = pop_item;
                                    if (!side_is_attached && job?.DesignParameters.USE_ATTACHMENTS_2) {
                                        //fix up item if attachment one in paper
                                        let search = Paper.GetItems({ ref: attach_tag, areaIndex: areaIndex });
                                        if (search && search.length > 0) {
                                            attach_item = search[0];
                                        }
                                    }
                                    if (
                                        !side_is_attached &&
                                        job?.DesignParameters.USE_ATTACHMENTS_2 &&
                                        attach_item.lengthQQ
                                    ) {
                                        this.toggleMod_attachment2_dialog(true, attach_item, () => {
                                            this.attachSide(
                                                areaIndex,
                                                attach_tag,
                                                gutter_tag,
                                                side_is_attached ? true : false,
                                                job,
                                                attach_item
                                            )(e);
                                        });
                                    } else {
                                        this.attachSide(
                                            areaIndex,
                                            attach_tag,
                                            gutter_tag,
                                            side_is_attached ? true : false
                                        )(e);
                                    }
                                }}
                            >
                                {side_is_attached ? "Unattach" : "Attach"} this side
                            </MenuItem>
                        );
                        if (side_is_attached)
                            pop_menu_items.push(
                                <MenuItem
                                    key="modify-attachment-2"
                                    classes={{ root: classes.menu_item }}
                                    onClick={() => this.toggleMod_attachment_dialog(true, pop_item)}
                                >
                                    Modify Attachment...
                                </MenuItem>
                            );
                    }

                    if (
                        side_is_attached &&
                        this_mods &&
                        this_mods.FasciaType === "Wall" &&
                        !pop_item.is_attachment_ghost
                    ) {
                        let options = [
                            {
                                Key: 1,
                                Display: "Wall Gutter",
                            },
                            {
                                Key: 2,
                                Display: "Box Gutter",
                            },
                        ];

                        if (
                            area_design_specs?.SHAPE?.DesignType === CONFIG.DESIGN_TYPES.GABLE_PORTAL &&
                            (this_mods.Ref.includes("Back") || this_mods.Ref.includes("Front"))
                        ) {
                            options.unshift({
                                Key: 0,
                                Display: "No Gutter",
                                disabled: true,
                                disabledTooltip: "Must have gutter on water shed side",
                            });
                        } else if (
                            area_design_specs?.SHAPE?.DesignType === CONFIG.DESIGN_TYPES.FLAT &&
                            (((this_mods.Ref.includes("Left") ||
                                this_mods.Ref.startsWith("CFL") ||
                                this_mods.Ref.startsWith("CBL")) &&
                                area_design_specs?.META?.LeftState?.IsWaterShed) ||
                                ((this_mods.Ref.includes("Right") ||
                                    this_mods.Ref.startsWith("CFR") ||
                                    this_mods.Ref.startsWith("CBR")) &&
                                    area_design_specs?.META?.RightState?.IsWaterShed) ||
                                ((this_mods.Ref.includes("Front") || this_mods.Ref.startsWith("CF")) &&
                                    area_design_specs?.META?.FrontState?.IsWaterShed) ||
                                ((this_mods.Ref.includes("Back") || this_mods.Ref.startsWith("CB")) &&
                                    area_design_specs?.META?.BackState?.IsWaterShed))
                        ) {
                            options.unshift({
                                Key: 0,
                                Display: "No Gutter",
                                disabled: true,
                                disabledTooltip: "Must have gutter on water shed side",
                            });
                        } else {
                            options.unshift({
                                Key: 0,
                                Display: "No Gutter",
                            });
                        }

                        pop_menu_items.push(
                            <MenuItem key="gutter-heading-8" classes={{ root: classes.menu_item }}>
                                Gutter :&nbsp;
                                <AreaSelectField
                                    value={side_has_gutter}
                                    dark
                                    items={options}
                                    onChange={(e) => {
                                        {
                                            if (e.target.value === 0) {
                                                this.setState({
                                                    show_pop: false,
                                                });
                                                this.props.updateAreaSpecificationModificationArray(
                                                    areaIndex,
                                                    "ATTACHMENTS.AttachmentModifications",
                                                    this_mods.Ref,
                                                    null,
                                                    area_design_specs?.SHAPE?.DesignType ===
                                                        CONFIG.DESIGN_TYPES.GABLE_PORTAL
                                                        ? {
                                                              ...this_mods,
                                                              FasciaType: "Wall",
                                                              AttachmentType: "Wall",
                                                              AttachmentVariation: "Masonry Wall With Beam",
                                                          }
                                                        : {
                                                              ...this_mods,
                                                              FasciaType: "Wall",
                                                              AttachmentType: "Wall with Receiver Channel",
                                                              AttachmentVariation: "Masonry Wall With Beam",
                                                          },
                                                    true
                                                );
                                            } else {
                                                if (this_mods && this_mods.gutter == 0) {
                                                    this.props.updateAreaSpecificationModificationArray(
                                                        areaIndex,
                                                        "ATTACHMENTS.AttachmentModifications",
                                                        this_mods.Ref,
                                                        null,
                                                        {
                                                            ...this_mods,
                                                            FasciaType: "Wall",
                                                            AttachmentType:
                                                                "Wall with Offset Brackets Supporting Gutter and Beam",
                                                            AttachmentVariation: "Brick Veneer",
                                                            gutter: 1,
                                                        },
                                                        true
                                                    );
                                                }
                                                this.updateGutter(
                                                    areaIndex,
                                                    gutter_tag.replace("Attachment", ""),
                                                    e.target.value
                                                );
                                            }
                                        }
                                    }}
                                    clip_overflow
                                />
                            </MenuItem>
                        );
                    } else if (pop_item?.is_attachment || side_is_attached) {
                        pop_menu_items.push(
                            <MenuItem key="gutter-heading-3" classes={{ root: classes.menu_item }}>
                                Gutter :&nbsp;
                                <AreaSelectField
                                    value={side_has_gutter}
                                    dark
                                    items={
                                        AttachmentType.includes("Flyover") ||
                                        FasciaType.includes("Riser") ||
                                        pop_item.is_attachment_ghost
                                            ? [
                                                  { Key: 0, Display: "No Gutter" },
                                                  { Key: 1, Display: "Normal Gutter" },
                                                  { Key: 2, Display: "Box Gutter" },
                                              ]
                                            : [
                                                  { Key: 0, Display: "No Gutter (House Gutter Only)" },
                                                  { Key: 1, Display: "Double Gutter" },
                                                  { Key: 2, Display: "Box Gutter" },
                                              ]
                                    }
                                    clip_overflow
                                    onChange={(e) => {
                                        if (this_PAAT && pop_item.is_attachment_ghost) {
                                            this.updatePAATParameter(
                                                areaIndex,
                                                this_PAAT.Ref,
                                                "HasGutter",
                                                e.target.value
                                            );
                                        } else {
                                            this.updateGutter(areaIndex, gutter_tag, e.target.value);
                                        }
                                    }}
                                />
                            </MenuItem>
                        );
                    } else if (!pop_item.is_attachment || pop_item.is_attachment_ghost) {
                        pop_menu_items.push(
                            <MenuItem key="gutter-heading-2" classes={{ root: classes.menu_item }}>
                                Gutter :&nbsp;
                                <AreaSelectField
                                    value={side_has_gutter}
                                    dark
                                    items={[
                                        { Key: 0, Display: "No Gutter" },
                                        { Key: 1, Display: "Normal Gutter" },
                                        { Key: 2, Display: "Box Gutter" },
                                    ]}
                                    clip_overflow
                                    onChange={(e) => {
                                        if (this_PAAT) {
                                            this.updatePAATParameter(
                                                areaIndex,
                                                this_PAAT.Ref,
                                                "HasGutter",
                                                e.target.value
                                            );
                                        } else {
                                            this.updateGutter(areaIndex, gutter_tag, e.target.value);
                                        }
                                    }}
                                />
                            </MenuItem>
                        );
                    }

                    if ((attach_tag === "AttachmentLeft" || attach_tag === "AttachmentRight") && is_flat) {
                        let beam_side = "Left";
                        if (attach_tag === "AttachmentRight") beam_side = "Right";
                        let side_beam_omitted =
                            area_design_specs &&
                            area_design_specs[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS]["Omit" + beam_side + "Beam"];

                        pop_menu_items.push(
                            <MenuItem key="return-beam" classes={{ root: classes.menu_item }}>
                                {beam_side === "Left" ? "First (Left)" : "Last (Right)"} Return Beam :&nbsp;
                                <AreaSelectField
                                    style={{ marginTop: "0px" }}
                                    selectStyle={{ color: "black", marginTop: "0px" }}
                                    value={toNumber(side_beam_omitted)}
                                    items={[
                                        { Key: 0, Display: "On" },
                                        { Key: 1, Display: "Off" },
                                        { Key: 2, Display: "If Required (eg; supports a purlin)" },
                                    ]}
                                    areaIndex={areaIndex}
                                    section={BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS}
                                    dataField={"Omit" + beam_side + "Beam"}
                                    clip_overflow
                                    refresh_svg
                                    onChange={(e) => {
                                        this.props.updateAreaSpecification(
                                            areaIndex,
                                            BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS,
                                            "Omit" + beam_side + "Beam",
                                            e.target.value
                                        );
                                    }}
                                />
                            </MenuItem>
                        );
                    }
                }
                if (cutout) {
                    let max_overhang_xy =
                        area_design_specs?.[BASIC_SPECS_SECTIONS.ROOF_SHEETING]?.RoofSheetData?.max_overhang_xy;

                    if (pop_item.ref2.endsWith(" Y") || pop_item.ref2.endsWith(" Y2")) {
                        max_overhang_xy =
                            area_design_specs?.[BASIC_SPECS_SECTIONS.ROOF_SHEETING]?.RoofSheetData?.max_side_overhang;
                    }

                    pop_menu_items.push(
                        <MenuItem key="cutout-type" classes={{ root: classes.menu_item }}>
                            Cutout Type :&nbsp;
                            <AreaSelectField
                                value={cutoutType}
                                dark
                                items={
                                    pop_item?.ref?.startsWith("BackMid") || pop_item?.ref2 === "CBM"
                                        ? ["None", "Box", "Bay"]
                                        : ["None", "Angle", "Step", "Custom"]
                                }
                                clip_overflow
                                onChange={(e) => {
                                    this.togglePop(false);
                                    this.props.updateAreaSpecification(
                                        areaIndex,
                                        BASIC_SPECS_SECTIONS.SHAPE + ".CUTOUTS",
                                        pop_item.ref.split("-")[0] + "-CutoutType",
                                        e.target.value
                                    );
                                }}
                            />
                        </MenuItem>
                    );

                    let cutoutBeamY = area_design_specs.SHAPE.CUTOUTS[pop_item.ref.split("-")[0] + "-HasBeamY"];

                    //toggle cutout "Y" beams
                    if (cutoutType !== "None") {
                        let label = "Cutout Side Beams";
                        let cutout_beam_ref = pop_item.ref2.split("-")[0] + "-HasBeamY";
                        if (cutoutType === "Custom") {
                            cutout_beam_ref = pop_item.attach_tag.replace("Attachment", "Beam");
                            cutoutBeamY = area_design_specs.SHAPE.CUTOUTS[cutout_beam_ref];
                            label = "Cutout Side Beam";
                        }
                        console.log("pop_item 2", pop_item, cutout_beam_ref, label, cutoutBeamY);

                        pop_menu_items.push(
                            <MenuItem key="cutout-side-beams" classes={{ root: classes.menu_item }}>
                                {label} :&nbsp;
                                <AreaSelectField
                                    style={{ marginTop: "0px" }}
                                    selectStyle={{ color: "black", marginTop: "0px" }}
                                    value={toNumber(cutoutBeamY)}
                                    items={[
                                        { Key: 0, Display: "Off" },
                                        { Key: 1, Display: "On" },
                                    ]}
                                    clip_overflow
                                    onChange={(e) => {
                                        this.togglePop(false);
                                        this.props.updateAreaSpecification(
                                            areaIndex,
                                            BASIC_SPECS_SECTIONS.SHAPE + ".CUTOUTS",
                                            cutout_beam_ref,
                                            e.target.value
                                        );
                                    }}
                                />
                            </MenuItem>
                        );
                    }

                    pop_menu_items.push(
                        <MenuItem key="cutout-overhang" classes={{ root: classes.menu_item }}>
                            Cutout Overhang :&nbsp;{" "}
                            <BSL_TextInput
                                value={cutout_overhangValue}
                                style={{ color: "black", width: "100px", margin: "0px" }}
                                tight
                                endAdornment="mm"
                                min={0}
                                max={max_overhang_xy}
                                tooltipDelay={500}
                                onFocus={(event) => {
                                    event.target.select();
                                }}
                                onBlur={(val) => {
                                    this.props.updateAreaSpecification(
                                        areaIndex,
                                        BASIC_SPECS_SECTIONS.SHAPE + ".CUTOUTS",
                                        cutoutOverhangRef,
                                        val
                                    );
                                    this.setState({ pop_textfield_text: null });
                                }}
                                onKeyPress={(e) => {
                                    if (e.key === "Enter") {
                                        this.togglePop(false);
                                        e.target.blur();
                                    }
                                }}
                                onChange={(val) => {
                                    this.setState({ pop_textfield_text: val });
                                }}
                                disabled={max_overhang_xy === 0}
                            />
                        </MenuItem>
                    );
                    if (cutoutType === "Custom") {
                        pop_menu_items.push(
                            <MenuItem key="num-cust-segs" classes={{ root: classes.menu_item }}>
                                Num Custom Segments :&nbsp;
                                <AreaSelectField
                                    style={{ marginTop: "0px" }}
                                    selectStyle={{ color: "black", marginTop: "0px" }}
                                    value={
                                        area_design_specs.SHAPE.CUTOUTS[
                                            pop_item.ref.split("-")[0] + "-CustomNumSegments"
                                        ]
                                    }
                                    items={[2, 3, 4, 5, 6]}
                                    areaIndex={areaIndex}
                                    section={BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS}
                                    clip_overflow
                                    refresh_svg
                                    onChange={this.updateData(
                                        areaIndex,
                                        BASIC_SPECS_SECTIONS.SHAPE + ".CUTOUTS",
                                        pop_item.ref.split("-")[0] + "-CustomNumSegments",
                                        true
                                    )}
                                />
                            </MenuItem>
                        );
                    }
                }

                pop_menu_items.push(<Divider key="divider-2" classes={{ root: classes.divider }} />);
            } else if (pop_item.is_downlight_flashing) {
                pop_menu_items.push(
                    <Typography
                        key="downlight_flashing-heading"
                        classes={{ root: classes.pop_header }}
                        variant="overline"
                        display="block"
                        gutterBottom
                    >
                        {window.LYSAGHT ? "Light Tray" : "Downlight Flashing"}
                    </Typography>
                );

                if (area_design_specs?.[BASIC_SPECS_SECTIONS.GABLE_PARAMETERS]?.GableFanBracket) {
                    const has_fan = area_design_specs?.Fans?.[pop_item.ref2]?.Type;
                    pop_menu_items.push(
                        <MenuItem
                            key="add-downlight_flashing-fan"
                            classes={{ root: classes.menu_item }}
                            onClick={() => {
                                this.togglePop(false);
                                this.handle_toggle_fan(pop_item, areaIndex, has_fan ? "" : "Standard");
                            }}
                        >
                            {has_fan ? "Remove" : "Add"} Fan{" "}
                            <span className={classes.super_text} style={{ color: "#444" }}>
                                * Bracket Supplied Only
                            </span>
                        </MenuItem>
                    );
                }

                pop_menu_items.push(
                    <MenuItem key="add-downlight_flashing-downlights" classes={{ root: classes.menu_item }}>
                        Downlights
                        <span className={classes.super_text} style={{ color: "#444" }}>
                            * Not Supplied
                        </span>{" "}
                        <BSL_Select
                            tight={true}
                            value={
                                area_design_specs?.Downlights?.[pop_item.ref2]?.Type
                                    ? area_design_specs?.Downlights?.[pop_item.ref2]?.Type
                                    : ""
                            }
                            onChange={(e) => {
                                this.togglePop(false);
                                this.handle_add_downlights(pop_item, areaIndex, e.target.value);
                            }}
                            items={[
                                { Key: "", Display: "Auto" },
                                { Key: "0WW", Display: "None" },
                                ...this.getDownlightOptions(areaIndex),
                            ]}
                        ></BSL_Select>
                    </MenuItem>
                );
            } else if (pop_item.is_downlight) {
                pop_menu_items.push(
                    <Typography
                        key="bracing-heading"
                        classes={{ root: classes.pop_header }}
                        variant="overline"
                        display="block"
                        gutterBottom
                    >
                        Downlight
                    </Typography>
                );
                let has_adjustment = area_design_specs?.Downlights?.[pop_item.ref]?.["Adjustment_" + pop_item.dl_index];
                if (!THREED_MODE || (THREED_MODE && THREED_MINI_MODE)) {
                    pop_menu_items.push(
                        <MenuItem
                            key="move_downlight"
                            classes={{ root: classes.menu_item }}
                            onClick={() => this.toggleMoveDownlight(pop_item)}
                            style={{ minWidth: has_adjustment ? "220px" : "180px" }}
                        >
                            Move Downlight...{" "}
                            {has_adjustment && (
                                <BSL_Button
                                    tight
                                    className={classes.mini_button}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        this.togglePop(false);
                                        this.removeDownlightAdjustment(pop_item, areaIndex);
                                    }}
                                >
                                    Reset
                                </BSL_Button>
                            )}
                        </MenuItem>
                    );
                }

                pop_menu_items.push(
                    <MenuItem
                        key="remove_downlight"
                        classes={{ root: classes.menu_item }}
                        onClick={() => this.toggleRemoveDownlight(pop_item, areaIndex)}
                        style={{ minWidth: has_adjustment ? "220px" : "180px" }}
                    >
                        Remove Downlight
                    </MenuItem>
                );
            } else if (pop_item.is_fan) {
                pop_menu_items.push(
                    <Typography
                        key="bracing-heading"
                        classes={{ root: classes.pop_header }}
                        variant="overline"
                        display="block"
                        gutterBottom
                    >
                        Fan{" "}
                        <span className={classes.super_text} style={{ color: "#444" }}>
                            * Bracket Supplied Only
                        </span>
                    </Typography>
                );
                let has_adjustment = area_design_specs?.Fans?.[pop_item.ref]?.["Adjustment_1"];
                let disabled = pop_item.ref.includes("downlight_flashing") || pop_item.ref.includes("Portal");
                if (!THREED_MODE || (THREED_MODE && THREED_MINI_MODE)) {
                    pop_menu_items.push(
                        <MenuItem
                            key="move_fan"
                            classes={{ root: classes.menu_item }}
                            onClick={() => this.toggleMoveFan(pop_item)}
                            style={{ minWidth: has_adjustment ? "220px" : "180px" }}
                            disabled={disabled}
                        >
                            Move Fan...
                            {disabled ? " (Cannot move this fan)" : " "}
                            {has_adjustment && !disabled && (
                                <BSL_Button
                                    tight
                                    className={classes.mini_button}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        this.togglePop(false);
                                        this.removeFanAdjustment(pop_item, areaIndex);
                                    }}
                                >
                                    Reset
                                </BSL_Button>
                            )}
                        </MenuItem>
                    );
                }

                pop_menu_items.push(
                    <MenuItem
                        key="remove_downlight"
                        classes={{ root: classes.menu_item }}
                        onClick={() => {
                            this.togglePop(false);
                            this.handle_toggle_fan(pop_item, areaIndex, "");
                        }}
                        style={{ minWidth: has_adjustment ? "220px" : "180px" }}
                    >
                        Remove Fan
                    </MenuItem>
                );
            }

            if (show_front_back_overhangs) {
                let OH_Front = area_design_specs.SHAPE.OH_Front;
                let OH_Back = area_design_specs.SHAPE.OH_Back;

                let OH_Front_text_display_value = OH_Front_text === null ? OH_Front : OH_Front_text;
                if (OH_Front_text_display_value !== "")
                    OH_Front_text_display_value = toNumber(OH_Front_text_display_value, false);

                let OH_Back_text_display_value = OH_Back_text === null ? OH_Back : OH_Back_text;
                if (OH_Back_text_display_value !== "")
                    OH_Back_text_display_value = toNumber(OH_Back_text_display_value, false);

                let range_front = {
                    min: 0,
                    max: 200,
                    default: 0,
                };

                let range_back = {
                    min: 0,
                    max: 200,
                    default: 0,
                };

                let design_option = config.design_options[DesignType];
                if (design_option?.overhang_back_range)
                    range_back = { ...range_back, ...design_option.overhang_back_range };
                if (design_option?.overhang_front_range)
                    range_front = { ...range_front, ...design_option.overhang_front_range };

                range_back = replaceVariables(area_design_specs, range_back);
                range_front = replaceVariables(area_design_specs, range_front);

                pop_menu_items.push(
                    <div key="overhang" style={{ display: "flex" }}>
                        <BSL_TextInput
                            label="Front Overhang"
                            tight
                            selectAll={true}
                            endAdornment="mm"
                            tooltipDelay={500}
                            min={range_front.min}
                            max={range_front.max}
                            value={OH_Front_text_display_value}
                            style={{ color: "black", width: "120px", paddingLeft: "10px" }}
                            onFocus={(event) => {
                                event.target.select();
                            }}
                            onBlur={(val) => {
                                this.togglePop(false);
                                this.setState({ OH_Front_text: val });
                                this.updateAreaSpecificationValue(
                                    areaIndex,
                                    BASIC_SPECS_SECTIONS.SHAPE,
                                    "OH_Front",
                                    Number(val),
                                    true,
                                    false
                                );
                            }}
                            onKeyPress={(e) => {
                                if (e.key === "Enter") {
                                    e.target.blur();
                                }
                            }}
                            onChange={(val) => {
                                this.setState({ OH_Front_text: val });
                            }}
                        />
                        <BSL_TextInput
                            label="Back Overhang"
                            tight
                            selectAll={true}
                            endAdornment="mm"
                            tooltipDelay={500}
                            min={range_back.min}
                            max={range_back.max}
                            value={OH_Back_text_display_value}
                            style={{ color: "black", width: "120px", paddingLeft: "10px" }}
                            InputProps={{
                                endAdornment: <InputAdornment position="end">mm</InputAdornment>,
                            }}
                            onFocus={(event) => {
                                event.target.select();
                            }}
                            onBlur={(val) => {
                                this.togglePop(false);
                                this.setState({ OH_Back_text: val });
                                this.updateAreaSpecificationValue(
                                    areaIndex,
                                    BASIC_SPECS_SECTIONS.SHAPE,
                                    "OH_Back",
                                    Number(val),
                                    true,
                                    false
                                );
                            }}
                            onKeyPress={(e) => {
                                if (e.key === "Enter") {
                                    e.target.blur();
                                }
                            }}
                            onChange={(val) => {
                                this.setState({ OH_Back_text: val });
                            }}
                        />
                    </div>
                );
            }

            if (pop_menu_items_details.length > 0) {
                pop_menu_items.push(
                    <Typography
                        key="details"
                        classes={{ root: classes.pop_specs_header }}
                        variant="overline"
                        display="block"
                        gutterBottom
                    >
                        DETAILS
                    </Typography>
                );
                pop_menu_items.push(pop_menu_items_details);
            }
        }

        //

        if (paper?.project) paper.project._needsUpdate = true;
        if (paper?.project) paper.project.view.update();

        return (
            <>
                {SELECT_POINT &&
                    SELECT_POINT !== "MoveLabels" &&
                    SELECT_POINT !== "MoveItems" &&
                    SELECT_POINT !== "SelectElement" &&
                    !show_pop && <Crosshairs />}
                <PaperDesigner.DesignerTools />
                <PaperDesigner.ViewTools />
                <PaperDesigner.ThreeDScreenshot />
                <Message
                    open={app?.designer?.SHOW_MESSAGE}
                    message={app?.designer?.MESSAGE?.message ? app?.designer?.MESSAGE?.message : app?.designer?.MESSAGE}
                    type={app?.designer?.MESSAGE?.type ? app?.designer?.MESSAGE?.type : "error"}
                    onClose={this.handleClose}
                />

                {!carportMode && (
                    <BabylonSceneCanvas
                        modelFileName={modelFileName}
                        togglePop={this.togglePop}
                        background={BACKGROUND_MODE}
                    />
                )}
                <PaperDesigner.UpdateComponent />
                <div className={classes.qq2dCanvasContainer + (this.props.visible ? "" : " invisible")}>
                    <canvas
                        id="qqCanvas"
                        className={classes.qq2dCanvas}
                        resize="true"
                        style={{
                            backgroundImage: SHOW_GRAPH_BG
                                ? "linear-gradient(white 2px, transparent 2px), linear-gradient(90deg, white 2px, transparent 2px), linear-gradient(rgba(255,255,255,.3) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,.3) 1px, transparent 1px)"
                                : "none",
                        }}
                    ></canvas>
                    <Popover
                        open={show_pop && pop_menu_items.length > 0}
                        onClose={() => this.togglePop(false)}
                        anchorReference="anchorPosition"
                        anchorPosition={{
                            top: pop_location.y ? pop_location.y : 0,
                            left: pop_location.x ? pop_location.x : 0,
                        }}
                        anchorOrigin={{
                            vertical: "bottom",
                            horizontal: "right",
                        }}
                        transformOrigin={{
                            vertical: "top",
                            horizontal: pop_alignment,
                        }}
                        classes={{ root: classes.popover }}
                        style={
                            {
                                // display: show_pop === "Hide" ? "none" : "block",
                            }
                        }
                    >
                        {pop_menu_items}
                    </Popover>
                    {this.state.mod_attachment_dialog && (
                        <SpecModifyAttachmentDialog
                            onClose={() => this.toggleMod_attachment_dialog(false, null)}
                            open={this.state.mod_attachment_dialog}
                            item={this.state.mod_attachment_item}
                        />
                    )}
                    {this.state.mod_attachment2_dialog && (
                        <SpecModifyAttachmentDialog2
                            onCancel={() => this.toggleMod_attachment2_dialog(false, null)}
                            onSave={() => {
                                if (this.state.mod_attachment2_saveAction) this.state.mod_attachment2_saveAction();
                                this.toggleMod_attachment2_dialog(false, null);
                            }}
                            open={this.state.mod_attachment2_dialog}
                            item={this.state.mod_attachment_item}
                            attach_tag={this.state.mod_attachment_item.attach_tag}
                        />
                    )}
                    {this.state.mod_beam_dialog && (
                        <SpecModifyBeamDialog
                            onClose={() => this.toggleMod_beam_dialog(false, null)}
                            open={this.state.mod_beam_dialog}
                            item={this.state.mod_beam_item}
                        />
                    )}
                    {this.state.mod_beam_posts_dialog && (
                        <SpecModifyBeamPostsDialog
                            onClose={() => this.toggleMod_beam_posts_dialog(false, null)}
                            open={this.state.mod_beam_posts_dialog}
                            item={this.state.mod_beam_posts_item}
                        />
                    )}
                    {this.state.mod_post_dialog && (
                        <SpecModifyPostDialog
                            onClose={() => this.toggleMod_post_dialog(false, null)}
                            open={this.state.mod_post_dialog}
                            item={this.state.mod_post_item}
                        />
                    )}
                    {this.state.mod_post_dialog && (
                        <SpecModifyPostDialog
                            onClose={() => this.toggleMod_post_dialog(false, null)}
                            open={this.state.mod_post_dialog}
                            item={this.state.mod_post_item}
                        />
                    )}
                    {this.state.mod_downpipe_dialog && (
                        <SpecModifyDownpipeDialog
                            onClose={() => this.toggleMod_downpipe_dialog(false, null)}
                            open={this.state.mod_downpipe_dialog}
                            item={this.state.mod_downpipe_item}
                        />
                    )}

                    {this.state.mod_extend_beam && this.state.mod_item && (
                        <SpecExtendBeams
                            onClose={() => this.toggleExtendBeam(null)}
                            open={this.state.mod_extend_beam}
                            pop_item={this.state.mod_item}
                        />
                    )}

                    {this.state.mod_move_downlight && this.state.mod_item && (
                        <SpecMoveDownlight
                            onClose={() => this.toggleMoveDownlight(null)}
                            open={this.state.mod_move_downlight}
                            pop_item={this.state.mod_item}
                        />
                    )}

                    {this.state.mod_move_fan && this.state.mod_item && (
                        <SpecMoveFan
                            onClose={() => this.toggleMoveFan(null)}
                            open={this.state.mod_move_fan}
                            pop_item={this.state.mod_item}
                        />
                    )}

                    {this.state.mod_move_splice && this.state.mod_item && (
                        <SpecMoveSplice
                            onClose={() => this.toggleMoveSplice(null)}
                            open={this.state.mod_move_splice}
                            pop_item={this.state.mod_item}
                        />
                    )}

                    {pop_item?.is_note && edit_item && show_pop && (
                        <SpecNotesDialog
                            areaIndex={areaIndex}
                            edit_note={edit_item}
                            onClose={() => {
                                this.togglePop(false);
                            }}
                        />
                    )}
                    {pop_item && (pop_item.is_slat || pop_item.sel_type === "slat_label") && edit_item && show_pop && (
                        <SpecSlatsTool
                            areaIndex={areaIndex}
                            edit_item={edit_item}
                            onClose={() => {
                                this.togglePop(false);
                            }}
                        />
                    )}

                    {this.state.edit_extra_beam_dialog && pop_item && (
                        <SpecExtraBeamDialog
                            areaIndex={areaIndex}
                            edit_item={pop_item}
                            showButtons={false}
                            onClose={() => {
                                this.toggleEdit_extra_beam_dialog(false);
                            }}
                        />
                    )}
                </div>
            </>
        );
    }
    // ALL 2D CANVAS RELATED STUFF

    LoadSVG(quote_number, svg_filename, zoom_all = false, clear_all = false) {
        let this_svg_load_path = quote_number + "/" + svg_filename;
        if (window.last_svg_load_attempt === this_svg_load_path) return; //already try/loaded
        window.svg = null;

        window.last_svg_load_attempt = quote_number + "/" + svg_filename;

        let url_base = API_BASE() + "svg/" + this_svg_load_path;

        paper.project.importSVG(url_base, {
            onLoad: (new_item, svg_raw) => {
                if (!new_item) return;
                new_item.svg_filename = this_svg_load_path;
                new_item.scale(1);
                if (clear_all && paper.project.activeLayer.children.length > 1) {
                    paper.project.activeLayer.removeChildren(0, paper.project.activeLayer.children.length - 1);
                }

                window.svg = new_item;
                Paper.FormatSVGToJob();
                Paper.UpdateAllSVGMaterials();
                Paper.GetMetaData();
                if (zoom_all) Paper.zoomAll();
            },
            onError: (message, status) => {
                if (clear_all) Paper.ClearAll();
            },
        });
    }

    UpdateSVGsIfRequired(svg_filename) {
        if (!svg_filename) return;

        if (window.svg === null || !window.svg) {
            this.LoadSVG("local", svg_filename, true, true);
        } else if (window.svg.svg_filename === "local/" + svg_filename) {
            Paper.UpdateAllSVGMaterials();
            return; //same file name; ignore
        } else {
            this.LoadSVG("local", svg_filename, false, true);
        }
    }

    InitialisePaper(id) {
        // Get a reference to the canvas object
        var canvas = window.document.getElementById(id);
        // Create an empty project and a view for the canvas:
        paper.setup(canvas);
        paper.project.options.handleSize = 6;
        paper.settings.hitTolerance = 6;
        paper.view.zoom = 1;
        paper.view.scale = 25;
        paper.view.scale = 25;
        paper.view.viewSize = new paper.Size(1920, 1200);

        window.paper = paper;
        window.paper_canvas = canvas;
        window.paper_settings = _this;

        paper.view.onMouseDown = (e) => {
            window.dragging = false;
            _this.downPoint = e.point;
            _this.downPointScreen = new paper.Point(e.event.x, e.event.y);
            _this.downButton = e.event.button;

            let SELECT_POINT = this.props.app.designer.designer2D[APP.SELECT_POINT];
            if (SELECT_POINT === "MoveLabels") {
                let _hitOptions = (_hitOptions = {
                    tolerance: 100,
                    fill: true,
                    stroke: true,
                    tolerance: 6,
                    match: (res) => {
                        return res?.item ? Object.getPrototypeOf(res.item)?._class === "PointText" : false;
                    },
                });

                var hitResult = paper.project.activeLayer.hitTest(e.point, _hitOptions); // isPointInPath
                if (hitResult?.item) {
                    _this.last_hover = hitResult?.item;
                } else {
                    _this.last_hover = null;
                }
            } else if (SELECT_POINT === "MoveItems") {
                let _hitOptions = (_hitOptions = {
                    tolerance: 100,
                    fill: true,
                    stroke: true,
                    tolerance: 6,
                    match: (res) => {
                        return res?.item ? res.item.pickable : false;
                    },
                });

                var hitResult = paper.project.activeLayer.hitTest(e.point, _hitOptions); // isPointInPath
                if (hitResult?.item) {
                    _this.last_hover = hitResult?.item;

                    if (SELECT_POINT === "MoveItems" && _this.last_hover?.parent?.typeQQ === _this.last_hover?.typeQQ) {
                        _this.last_hover = _this.last_hover?.parent;
                    }

                    if (_this.last_hover.orig_point == null) {
                        _this.last_hover.orig_point = _this.last_hover.position;
                    }
                } else {
                    _this.last_hover = null;
                }
            } else if (SELECT_POINT === "SelectElement") {
                let _hitOptions = (_hitOptions = {
                    tolerance: 100,
                    fill: true,
                    stroke: true,
                    tolerance: 6,
                    match: (res) => {
                        return res?.item ? res.item.pickable : false;
                    },
                });

                var hitResult = paper.project.activeLayer.hitTest(e.point, _hitOptions); // isPointInPath

                if (hitResult?.item) {
                    _this.last_hover = hitResult?.item;
                    _this.selected_item = { ...hitResult?.item };
                    _this.selected_element = { ...hitResult?.item };
                    _this.selected_element.click_point = e.point;
                } else {
                    _this.last_hover = null;
                }
            }
        };

        const addMovedLabels = (move_labels, parent_item) => {
            if (parent_item.children && parent_item.children.length > 0) {
                parent_item.children.forEach(function (item) {
                    if (item.label_pos_ref && Object.getPrototypeOf(item)?._class === "PointText" && item.orig_point) {
                        let distance = item.orig_point.getDistance(item.point);

                        if (distance > 10 || item.has_adjusted_position) {
                            let x_offset = item.point.x - item.orig_point.x;
                            let y_offset = item.point.y - item.orig_point.y;

                            let pnt = getPointForRef(
                                item?.has_adjusted_position ? item.has_adjusted_position : item.label_pos_ref
                            );
                            pnt.x += x_offset;
                            pnt.y -= y_offset;

                            move_labels.push({
                                AreaIndex: item?.areaIndex,
                                Text: item?.content_original ? item?.content_original : item.content,
                                Position: item.label_pos_ref,
                                AdjustedPosition: "(" + pnt.x.toFixed(2) + "/" + pnt.y.toFixed(2) + "/0.00)",
                            });
                        }
                    }

                    if (item.children && item.children.length > 0) {
                        move_labels = addMovedLabels(move_labels, item);
                    }
                });
            }
            return move_labels;
        };

        const addMovedItems = (move_labels, parent_item) => {
            return [];
        };

        const saveMoveLabels = () => {
            let move_labels = addMovedLabels([], paper.project.activeLayer);
            this.props.update2DDesigner(APP.SELECTED_POINT, move_labels);
            setTimeout(() => {
                this.props.update2DDesigner(APP.SELECT_POINT, false);
            }, 250);
        };

        const saveMoveItems = () => {
            let moved_items = addMovedItems([], paper.project.activeLayer);
            this.props.update2DDesigner(APP.SELECTED_POINT, moved_items);
            setTimeout(() => {
                this.props.update2DDesigner(APP.SELECT_POINT, false);
            }, 250);
        };

        paper.view.onKeyUp = (e) => {
            let SELECT_POINT = this.props.app.designer.designer2D[APP.SELECT_POINT];
            if (SELECT_POINT && e.key === "escape") {
                if (SELECT_POINT !== "MoveLabels" && SELECT_POINT !== "MoveItems" && SELECT_POINT !== "SelectElement") {
                    this.props.update2DDesigner(APP.SELECTED_POINT, false);
                    this.props.update2DDesigner(APP.SELECT_POINT, false);
                }
                var rubberband = paper?.project?.activeLayer?.rubberband;

                if (rubberband) {
                    rubberband.removeSegments();
                    if (current) current.remove();
                    if (arrow) arrow = null;
                    var rubberband_label = paper?.project?.activeLayer?.rubberband_label;
                    if (rubberband_label) rubberband_label.visible = false;
                    rubberband = null;
                }
                if (SELECT_POINT === "MoveLabels") saveMoveLabels();
                else if (SELECT_POINT === "MoveItems") saveMoveItems();
                return;
            }
        };

        paper.view.onMouseUp = (e) => {
            if (e?.target?.name === "warning_icon") return;

            const UNLOCKED = this.props.app.designer[APP.UNLOCKED];
            const orderStatus = (this.props?.job?.OrderStatus || "").toUpperCase();
            const locked =
                (orderStatus === "PENDING" || orderStatus === "ACCEPTED" || this.props?.job?.App?.Locked) && !UNLOCKED;

            var hitResult = paper.project.activeLayer.hitTest(e.point, hitOptions);
            let SELECT_POINT = this.props.app.designer.designer2D[APP.SELECT_POINT];
            let SELECT_POINT_ALLOW_HIT_SELTYPE = this.props.app.designer.designer2D[APP.SELECT_POINT_ALLOW_HIT_SELTYPE];
            if (typeof SELECT_POINT_ALLOW_HIT_SELTYPE === "string")
                SELECT_POINT_ALLOW_HIT_SELTYPE = [SELECT_POINT_ALLOW_HIT_SELTYPE];

            if (locked) {
                this.props.showDesignerMessage("Job is locked and cannot be modified.");
                return;
            }

            if (SELECT_POINT === "Custom") {
                return;
            } else if (SELECT_POINT === "SelectElement" && _this.selected_element) {
                this.props.update2DDesigner(APP.SELECTED_POINT, _this.selected_element);
            } else if (SELECT_POINT === "MoveLabels") {
                if (e?.event?.button === 2) {
                    let rubberband = paper?.project?.activeLayer?.rubberband;
                    if (rubberband) {
                        rubberband.removeSegments();
                        if (current) current.remove();
                        if (arrow) arrow = null;

                        if (rubberband_label) rubberband_label.visible = false;
                        rubberband = null;
                    }
                    paper.project.activeLayer.rubberband = null;

                    saveMoveLabels();
                }
                if (_this.last_hover) _this.last_hover.orig_point_offset = null;
                window.dragging = false;
                return;
            } else if (SELECT_POINT === "MoveItems") {
                if (e?.event?.button === 2) {
                    let rubberband = paper?.project?.activeLayer?.rubberband;
                    if (rubberband) {
                        rubberband.removeSegments();
                        if (current) current.remove();
                        if (arrow) arrow = null;

                        if (rubberband_label) rubberband_label.visible = false;
                        rubberband = null;
                    }
                    paper.project.activeLayer.rubberband = null;

                    saveMoveItems();
                }
                if (_this.last_hover) _this.last_hover.orig_point_offset = null;
                window.dragging = false;
                return;
            } else if (
                !window.dragging &&
                SELECT_POINT &&
                SELECT_POINT_ALLOW_HIT_SELTYPE &&
                hitResult &&
                hitResult.item &&
                SELECT_POINT_ALLOW_HIT_SELTYPE.includes(hitResult.item.sel_type)
            ) {
                this.togglePop(true, e.event.x, e.event.y, hitResult.item);
            } else if (!window.dragging && SELECT_POINT) {
                var rubberband = paper?.project?.activeLayer?.rubberband;
                var rubberband_label = paper?.project?.activeLayer?.rubberband_label;

                if (e?.event?.button === 2) {
                    this.props.update2DDesigner(APP.SELECT_POINT, false);
                    this.props.update2DDesigner(APP.SELECTED_POINT, false);
                    if (rubberband) {
                        rubberband.removeSegments();
                        if (current) current.remove();
                        if (arrow) arrow = null;

                        if (rubberband_label) rubberband_label.visible = false;
                    }
                    return;
                }

                let x = e.point.x;
                let y = e.point.y;
                if (window.paper_origin) {
                    x = x - window.paper_origin.x;
                    y = -(y - window.paper_origin.y);
                }

                if (toNumber(SELECT_POINT) <= 1) {
                    this.props.update2DDesigner(APP.SELECTED_POINT, { x: x, y: y });
                } else {
                    if (rubberband && rubberband.segments.length > 0) {
                        rubberband.add(e.point);
                        if (SELECT_POINT.includes && SELECT_POINT.includes("Arrow")) arrow = new Arrow(e.point);
                    } else {
                        paper.project.activeLayer.rubberband = new paper.Path(e.point, e.point);
                        var rubberband = paper.project.activeLayer.rubberband;
                        rubberband.name = "rubberband";
                        rubberband.strokeColor = "blue";
                        rubberband.strokeWidth = 4;
                        rubberband.dashArray = [3, 3];
                        rubberband.visible = true;
                        rubberband.bringToFront();

                        paper.project.activeLayer.rubberband_label = new paper.PointText(e.point);
                        var rubberband_label = paper.project.activeLayer.rubberband_label;
                        rubberband_label.name = "rubberband label";
                        rubberband_label.justification = "center";
                        rubberband_label.justification = "center";
                        rubberband_label.fillColor = "#555555";
                        rubberband_label.content = "0mm";

                        if (SELECT_POINT.includes && SELECT_POINT.includes("Arrow")) arrow = new Arrow(e.point);
                    }

                    if (rubberband.segments.length > toNumber(SELECT_POINT)) {
                        let points = [];
                        for (let segment of rubberband.segments) {
                            let x = segment.point.x;
                            let y = segment.point.y;
                            if (window.paper_origin) {
                                x = x - window.paper_origin.x;
                                y = -(y - window.paper_origin.y);
                            }

                            points.push({ x: x, y: y });
                        }
                        if (points.length > toNumber(SELECT_POINT)) points.pop();

                        if (arrow) arrow = null;
                        this.props.update2DDesigner(APP.SELECTED_POINT, points);
                    }
                }
            } else if (!window.dragging && !hitResult) {
                const hitOptions2 = {
                    // Trigger hit only on 'fill' part of the path with 0 tolerance
                    segments: false,
                    stroke: true,
                    fill: true,
                    tolerance: 100,
                    match: (res) => {
                        return res.item.areaIndex !== undefined && res.item.areaIndex > -1;
                    },
                };

                var hitResult2 = paper.project.activeLayer.hitTest(e.point, hitOptions2); // isPointInPath

                if (hitResult2) {
                } else {
                    hitResult2 = paper.project.activeLayer.hitTest(e.point, {
                        ...hitOptions2,
                        tolerance: 1000,
                    }); // isPointInPath
                    if (hitResult2) {
                    }
                }

                if (hitResult2) {
                } else {
                    hitResult2 = paper.project.activeLayer.hitTest(e.point, {
                        ...hitOptions2,
                        tolerance: 2000,
                    }); // isPointInPath
                    if (hitResult2) {
                    }
                }

                if (hitResult2 && hitResult2.item.areaIndex !== undefined && hitResult2.item.areaIndex > -1) {
                    this.togglePop(true, e.event.x, e.event.y, {
                        is_point: true,
                        ref: "point",
                        point: e.point,
                        areaIndex: hitResult2.item.areaIndex,
                        areaNumber: hitResult2.item.areaIndex + 1,
                    });
                }
            } else if (!window.dragging && hitResult && hitResult.item) {
                let item = hitResult.item;

                if (hitResult?.item?.typeQQ?.includes && hitResult?.item?.typeQQ.includes("beam")) {
                    const hitOptionsBeams = {
                        // Trigger hit only on 'fill' part of the path with 0 tolerance
                        segments: false,
                        stroke: false,
                        fill: true,
                        tolerance: 6,
                        match: (res) => {
                            return res?.item?.ref && res?.item?.typeQQ.includes("beam");
                        },
                    };
                    var hitResultAllBeams = paper.project.activeLayer.hitTestAll(e.point, hitOptionsBeams); // isPointInPath
                    if (hitResultAllBeams.length > 1) {
                        item = { ...item };
                        item.allHitItems = hitResultAllBeams;
                    }
                }

                paper.project.deselectAll();
                if (item.ref) {
                    _this.selected_item = item;
                    item.selected = true;
                }
                let areaIndex = item.areaIndex ? Number(item.areaIndex) : 0;
                item.click_point = e.point;
                this.togglePop(true, e.event.x, e.event.y, item);

                if (item.is_roofsheet) {
                } else if (item.typeQQ && item.typeQQ === "sheet_label") {
                } else if (item.is_beam) {
                } else if (item.is_gutter || (item.typeQQ && item.typeQQ === "gutter_label")) {
                } else if (item.typeQQ && item.typeQQ === "area_label") {
                    let new_postion = item.position.add(
                        new paper.Point(-(item.bounds.width / 2) + 300, -(item.bounds.height / 2) + 700)
                    );
                    var steps = 12;
                    let diff = paper.view.center.subtract(new_postion);
                    let shift = new paper.Point(diff.x / steps, diff.y / steps);
                    let shift_half = new paper.Point(diff.x / steps / 2, diff.y / steps / 2);
                    function move() {
                        setTimeout(function () {
                            if (steps < steps / 3) {
                                paper.view.center = paper.view.center.subtract(shift_half);
                                steps -= 0.5;
                            } else {
                                paper.view.center = paper.view.center.subtract(shift);
                                steps--;
                            }
                            if (steps > 0) move();
                        }, 1);
                    }
                    move();
                }
            } else {
                paper.project.deselectAll();
            }
            paper.view.element.style.setProperty("cursor", "crosshair");
            window.dragging = false;
        };

        var offset;
        var offsetSpeed;
        var offset_run = false;
        var offset_running = false;
        var offset_direction = "top";

        paper.view.onMouseMove = (e) => {
            let SELECT_POINT = this.props.app.designer.designer2D[APP.SELECT_POINT];
            let rubberband_to_point = e.point;
            if (SELECT_POINT && e.point) {
                var rubberband = paper.project?.activeLayer?.rubberband;
                var rubberband_label = paper.project?.activeLayer?.rubberband_label;

                if (rubberband && rubberband.segments.length > 0) {
                    rubberband.segments[rubberband.segments.length - 1].point = e.point;

                    let from_point = rubberband.segments[rubberband.segments.length - 2].point;
                    if (from_point) {
                        var vector_mouse = rubberband_to_point.subtract(from_point);
                        var new_vector = new paper.Point(0, 0);
                        var vector_last_line = new paper.Point(0, 0);

                        new_vector.length = vector_mouse.length;
                        var angle_relative_to_last_line = vector_mouse.angle - vector_last_line.angle;
                        var mod = Math.abs(angle_relative_to_last_line % 45);
                        var snap_tolerance = 3;
                        var snapped = false;
                        if (!e.modifiers.control) {
                            if (
                                (mod < snap_tolerance && mod > -snap_tolerance) ||
                                (mod > 45 - snap_tolerance && mod < 45 + snap_tolerance)
                            ) {
                                var angle = Math.round(angle_relative_to_last_line / 45) * 45 + vector_last_line.angle;

                                new_vector.angle = angle;
                                rubberband_to_point = from_point.add(new_vector);
                                snapped = true;
                            }
                        }

                        rubberband.segments[rubberband.segments.length - 1].point = rubberband_to_point;
                        var vector1 = rubberband_to_point.subtract(rubberband.segments[0].point);
                        var actual_angle_relative_to_last_line = vector1.angle - vector_last_line.angle;

                        if (rubberband_label) {
                            rubberband_label.point = e.point.add(
                                new paper.Point(90 / paper.view.zoom, -20 / paper.view.zoom)
                            );
                            rubberband_label.content =
                                Math.round(vector_mouse.length) +
                                "mm @" +
                                actual_angle_relative_to_last_line.toFixed(1) +
                                " degs\n" +
                                (snapped ? " *press ctrl to unsnap*" : "");
                            rubberband_label.fontSize = 12 / paper.view.zoom;
                        }

                        var scroll_tolerance = 100;
                        offsetSpeed = 2 / paper.view.zoom;
                        if (e.event.y < scroll_tolerance) {
                            offset_direction = "top";
                            offset_run = true;
                            if (e.event.x < scroll_tolerance * 2) {
                                offset_direction = "top-left";
                            } else if (e.event.x > paper.view.viewSize.width - scroll_tolerance * 2) {
                                offset_direction = "top-right";
                            }

                            if (e.event.y < (scroll_tolerance * 2) / 3) offsetSpeed = offsetSpeed * 2;
                            if (e.event.y < scroll_tolerance / 3) offsetSpeed = offsetSpeed * 2;
                            if (e.event.y < scroll_tolerance / 10) offsetSpeed = offsetSpeed * 2;
                        } else if (e.event.y > paper.view.viewSize.height - scroll_tolerance) {
                            offset_direction = "bottom";
                            offset_run = true;
                            if (e.event.x < scroll_tolerance * 2) {
                                offset_direction = "bottom-left";
                            } else if (e.event.x > paper.view.viewSize.width - scroll_tolerance * 2) {
                                offset_direction = "bottom-right";
                            }
                            if (e.event.y > paper.view.viewSize.height - (scroll_tolerance * 2) / 3)
                                offsetSpeed = offsetSpeed * 2;
                            if (e.event.y > paper.view.viewSize.height - scroll_tolerance / 3)
                                offsetSpeed = offsetSpeed * 2;
                            if (e.event.y > paper.view.viewSize.height - scroll_tolerance / 10)
                                offsetSpeed = offsetSpeed * 2;
                        } else if (e.event.x < scroll_tolerance) {
                            offset_direction = "left";
                            offset_run = true;
                            if (e.event.x < (scroll_tolerance * 2) / 3) offsetSpeed = offsetSpeed * 2;
                            if (e.event.x < scroll_tolerance / 3) offsetSpeed = offsetSpeed * 2;
                            if (e.event.x < scroll_tolerance / 10) offsetSpeed = offsetSpeed * 2;
                        } else if (e.event.x > paper.view.viewSize.width - scroll_tolerance) {
                            offset_direction = "right";
                            offset_run = true;
                            if (e.event.x > paper.view.viewSize.width - (scroll_tolerance * 2) / 3)
                                offsetSpeed = offsetSpeed * 2;
                            if (e.event.x > paper.view.viewSize.width - scroll_tolerance / 3)
                                offsetSpeed = offsetSpeed * 2;
                            if (e.event.x > paper.view.viewSize.width - scroll_tolerance / 10)
                                offsetSpeed = offsetSpeed * 2;
                        } else {
                            offset_run = false;
                        }

                        if (offset_run && !offset_running) {
                            let offset_up = () => {
                                offset = new paper.Point(0, -offsetSpeed);
                                if (offset_direction === "top-left")
                                    offset = new paper.Point(-offsetSpeed, -offsetSpeed);
                                if (offset_direction === "top-right")
                                    offset = new paper.Point(offsetSpeed, -offsetSpeed);
                                if (offset_direction === "bottom") offset = new paper.Point(0, offsetSpeed);
                                if (offset_direction === "bottom-left")
                                    offset = new paper.Point(-offsetSpeed, offsetSpeed);
                                if (offset_direction === "bottom-right")
                                    offset = new paper.Point(offsetSpeed, offsetSpeed);
                                if (offset_direction === "left") offset = new paper.Point(-offsetSpeed, 0);
                                if (offset_direction === "right") offset = new paper.Point(offsetSpeed, 0);
                                paper.view.center = paper.view.center.add(offset);

                                // offset rubberband
                                if (rubberband?.segments?.[1])
                                    rubberband.segments[1].point = rubberband.segments[1].point.add(offset);
                                offset_grid(offset);
                                paper.view.draw();

                                if (offset_run)
                                    setTimeout(function () {
                                        offset_up();
                                    }, 20);
                                else offset_running = false;
                            };
                            offset_running = true;
                            offset_up();
                        }
                    }
                }

                if (current) current.remove();
                if (arrow && SELECT_POINT.includes && SELECT_POINT.includes("Arrow"))
                    current = arrow.draw(rubberband_to_point);
            }
        };

        var bg_pos1 = new paper.Point(-50, -50);
        var bg_pos2 = new paper.Point(-50, -50);
        var orig_bg_zoom1 = 100;
        var orig_zoom = 1;
        var last_rounded = 100;

        function offset_grid(offset = new paper.Point(-0, -0)) {
            var change_ratio = (paper.view.zoom / orig_zoom) * 1;
            var rounded = orig_bg_zoom1 * change_ratio;
            var rounded_sm = rounded / 5;
            if (document.getElementById("qqCanvas")?.style)
                document.getElementById("qqCanvas").style.backgroundSize =
                    rounded +
                    "px " +
                    rounded +
                    "px, " +
                    rounded +
                    "px " +
                    rounded +
                    "px, " +
                    rounded_sm +
                    "px " +
                    rounded_sm +
                    "px, " +
                    rounded_sm +
                    "px " +
                    rounded_sm +
                    "px";

            if (rounded !== last_rounded) {
                offset = offset.add(new paper.Point(-(rounded - last_rounded) / 2, -(rounded - last_rounded) / 2));
            }

            if (offset) {
                offset.x = offset.x * change_ratio;
                offset.y = offset.y * change_ratio;
                bg_pos1 = bg_pos1.subtract(offset);
                bg_pos2 = bg_pos2.subtract(offset);
                document.getElementById("qqCanvas").style.backgroundPosition =
                    bg_pos1.x +
                    "px " +
                    bg_pos1.y +
                    "px, " +
                    bg_pos1.x +
                    "px " +
                    bg_pos1.y +
                    "px, " +
                    bg_pos2.x +
                    "px " +
                    bg_pos2.y +
                    "px, " +
                    bg_pos2.x +
                    "px " +
                    bg_pos2.y +
                    "px";
            }
            last_rounded = rounded;
        }

        var qqCanvas = document.getElementById("qqCanvas");
        if (qqCanvas)
            qqCanvas.addEventListener(
                "wheel",
                function (e) {
                    var delta = e.deltaY;
                    var zoom = paper.view.zoom * (1 - delta / 4500);

                    if (zoom > 7) zoom = 7;
                    if (zoom < 0.03) zoom = 0.03;
                    paper.view.zoom = zoom;

                    offset_grid();
                    e.stopPropagation();
                },
                { passive: true }
            );
        if (qqCanvas)
            qqCanvas.addEventListener("contextmenu", function (e) {
                e.preventDefault();
            });

        paper.view.onMouseDrag = function (e) {
            let SELECT_POINT = window?.app?.designer?.designer2D?.SELECT_POINT;

            var distance_dragged = _this.downPoint ? _this.downPoint.getDistance(e.point) : 0;
            var distance_screen_dragged = _this.downPointScreen.getDistance(new paper.Point(e.event.x, e.event.y));

            paper.view.element.style.setProperty("cursor", "all-scroll");

            if ((SELECT_POINT === "MoveLabels" || SELECT_POINT === "MoveItems") && _this.last_hover) {
                if (_this.last_hover && !_this.last_hover.orig_point_offset) {
                    _this.last_hover.orig_point_offset = _this.downPoint.subtract(_this.last_hover.position);
                }
                if (distance_screen_dragged > 5 || window.dragging) {
                    window.dragging = true;
                    if (_this.last_hover) {
                        _this.last_hover.position = e.point.subtract(_this.last_hover.orig_point_offset);
                        _this.last_hover.moved = true;
                    }
                }
            } else if (
                (distance_screen_dragged > 20 || (e.event.type === "touchmove" && distance_dragged)) &&
                !window.dragging
            ) {
                window.dragging = true;
            } else if (
                (_this.downButton === 0 ||
                    _this.downButton === 1 ||
                    _this.downButton === 2 ||
                    e.event.type === "touchmove") &&
                window.dragging
            ) {
                _this.dragging = true;
                var offset = _this.downPoint.subtract(e.point);
                paper.view.center = paper.view.center.add(offset);
                offset_grid(offset);
            }
        };

        var tool = new paper.Tool(); // Again manually. Life is much easier with script type="text/paperscript"
        tool.onMouseMove = function (event) {
            let SELECT_POINT = window?.app?.designer?.designer2D?.SELECT_POINT;

            let _hitOptions = hitOptions;
            if (SELECT_POINT === "MoveLabels") {
                _hitOptions = {
                    tolerance: 100,
                    fill: true,
                    stroke: true,
                    tolerance: 6,
                    match: (res) => {
                        return res?.item ? Object.getPrototypeOf(res.item)?._class === "PointText" : false;
                    },
                };
            } else if (SELECT_POINT === "SelectElement" || SELECT_POINT === "MoveItems") {
                _hitOptions = {
                    tolerance: 100,
                    fill: true,
                    stroke: true,
                    tolerance: 10,
                    match: (res) => {
                        return res?.item ? res.item.pickable : false;
                    },
                };
            }

            var hitResult = paper.project.activeLayer.hitTest(event.point, _hitOptions); // isPointInPath

            //
            if (
                !hitResult &&
                SELECT_POINT !== "MoveLabels" &&
                SELECT_POINT !== "MoveItems" &&
                SELECT_POINT !== "SelectElement"
            ) {
                const hitOptions2 = {
                    // Trigger hit only on 'fill' part of the path with 0 tolerance
                    segments: false,
                    stroke: true,
                    fill: true,
                    tolerance: 100,
                    match: (res) => {
                        return res.item.areaIndex !== undefined && res.item.areaIndex > -1;
                    },
                };

                hitResult = paper.project.activeLayer.hitTest(event.point, hitOptions2); // isPointInPath
                if (!hitResult) {
                    hitResult = paper.project.activeLayer.hitTest(event.point, {
                        ...hitOptions2,
                        tolerance: 1000,
                    }); // isPointInPath
                }
            }

            if (window.THREED_MODE && !window.THREED_MINI_MODE) return;
            if (SELECT_POINT === "MoveLabels" || SELECT_POINT === "MoveItems" || SELECT_POINT === "SelectElement") {
                if (hitResult && hitResult.item) {
                    paper.view.element.style.setProperty("cursor", "pointer");
                } else {
                    paper.view.element.style.setProperty("cursor", "crosshair");
                }
            } else if (SELECT_POINT) {
                let SELECT_POINT_ALLOW_HIT_SELTYPE =
                    window?.app?.designer?.designer2D?.[APP.SELECT_POINT_ALLOW_HIT_SELTYPE];
                if (typeof SELECT_POINT_ALLOW_HIT_SELTYPE === "string")
                    SELECT_POINT_ALLOW_HIT_SELTYPE = [SELECT_POINT_ALLOW_HIT_SELTYPE];

                if (
                    SELECT_POINT_ALLOW_HIT_SELTYPE &&
                    hitResult &&
                    hitResult.item &&
                    SELECT_POINT_ALLOW_HIT_SELTYPE.includes(hitResult.item.sel_type)
                ) {
                    paper.view.element.style.setProperty("cursor", "pointer");
                } else {
                    paper.view.element.style.setProperty("cursor", "crosshair");
                    hitResult = null;
                }
            } else {
                if (!window.dragging) paper.view.element.style.setProperty("cursor", "crosshair");
                if (window.dragging) paper.view.element.style.setProperty("cursor", "all-scroll");
            }
            var x = event.point.x;
            var y = event.point.y;

            if (_this.selected_item && SELECT_POINT !== "SelectElement") return;

            if (_this.last_hover && (!hitResult || hitResult.item !== _this.last_hover) && !window.dragging) {
                _this.last_hover.shadowColor = null;
                _this.last_hover.shadowBlur = 0;
                if (_this.last_hover.fillColor)
                    _this.last_hover.fillColor.alpha = _this.last_hover.fillColorAlpha_o
                        ? _this.last_hover.fillColorAlpha_o
                        : 1;
                if (_this.last_hover.strokeColor && _this.last_hover.strokeColor_hold) {
                    _this.last_hover.strokeColor.red = _this.last_hover.strokeColor_hold.red;
                    _this.last_hover.strokeColor.green = _this.last_hover.strokeColor_hold.green;
                    _this.last_hover.strokeColor.blue = _this.last_hover.strokeColor_hold.blue;
                }
                _this.last_hover = null;
                if (_this.last_hover_matches) {
                    _this.last_hover_matches.forEach(function (item_match) {
                        item_match.shadowColor = null;
                        item_match.shadowBlur = 0;
                        if (item_match.fillColor)
                            item_match.fillColor.alpha = item_match.fillColorAlpha_o ? item_match.fillColorAlpha_o : 1;
                        if (item_match.strokeColor && item_match.strokeColor_hold) {
                            item_match.strokeColor.red = item_match.strokeColor_hold.red;
                            item_match.strokeColor.green = item_match.strokeColor_hold.green;
                            item_match.strokeColor.blue = item_match.strokeColor_hold.blue;
                        }
                    });
                }
            }

            if (hitResult && hitResult.item !== _this.last_hover && !window.dragging) {
                let name = GetName(hitResult.item);
                if (
                    (name && hitResult.item.ref && hitResult.item.ref.length > 0) ||
                    SELECT_POINT === "MoveLabels" ||
                    SELECT_POINT === "MoveItems" ||
                    SELECT_POINT === "SelectElement"
                ) {
                    paper.view.element.style.setProperty("cursor", "pointer");
                    var item = hitResult.item;

                    if (item.strokeColor) {
                        if (item.strokeColor_hold === undefined)
                            item.strokeColor_hold = {
                                red: item.strokeColor.red,
                                green: item.strokeColor.green,
                                blue: item.strokeColor.blue,
                            };

                        item.strokeColor.red = item.strokeColor.red * 1.5;
                        item.strokeColor.green = item.strokeColor.green * 1.5;
                        item.strokeColor.blue = item.strokeColor.blue * 1.5;
                    }
                    if (item.fillColor) {
                        if (item.fillColorAlpha_o === undefined) item.fillColorAlpha_o = item.fillColor.alpha;

                        item.fillColor.alpha = item.fillColor.alpha * 0.75;
                    }
                    item.shadowColor = "green";
                    item.shadowBlur = 30;
                    item.shadowOffset = new paper.Point(0, 0);
                    _this.last_hover = item;

                    if (SELECT_POINT === "MoveItems" && _this.last_hover?.parent?.typeQQ === _this.last_hover?.typeQQ) {
                        _this.last_hover = _this.last_hover?.parent;
                    }
                    if (item.orig_point == null) {
                        item.orig_point = item.position;
                    }

                    if (hitResult?.item?.ref4) {
                        //to highlight all matching beams that are spliced
                        _this.last_hover_matches = paper.project.getItems({ ref4: hitResult.item.ref4 });
                        _this.last_hover_matches.forEach(function (item_match) {
                            if (item_match.fillColor && item_match.fillColorAlpha_o === undefined)
                                item_match.fillColorAlpha_o = item_match.fillColor.alpha;
                            if (item_match?.fillColor?.alpha)
                                item_match.fillColor.alpha = item_match.fillColor.alpha * 0.75;
                            item_match.shadowColor = "green";
                            item_match.shadowBlur = 30;
                            item_match.shadowOffset = new paper.Point(0, 0);
                        });
                    }
                }
            } else if (hitResult && hitResult.item === _this.last_hover) {
                if (!window.dragging) paper.view.element.style.setProperty("cursor", "pointer");
            } else {
                if (!window.dragging) paper.view.element.style.setProperty("cursor", "crosshair");
                if (window.dragging) paper.view.element.style.setProperty("cursor", "all-scroll");
            }
        };

        function GetName(item) {
            if (item) {
                if (item.name) return item.name;
                if (item.parent && item.parent.name && !item.parent.name.startsWith("area")) return item.parent.name;
                if (item.parent.parent && item.parent.parent.name && !item.parent.parent.name.startsWith("area"))
                    return item.parent.parent.name;
            }
            return null;
        }

        var qqCanvas = document.getElementById("qqCanvas");
        if (qqCanvas)
            qqCanvas.addEventListener(
                "wheel",
                function (e) {
                    var delta = e.deltaY;
                    var zoom = paper.view.zoom * (1 - delta / 4500);
                    if (zoom > 4.5) zoom = 4;
                    if (zoom < 0.005) zoom = 0.015;
                    paper.view.zoom = zoom;

                    offset_grid();
                    e.stopPropagation();
                },
                { passive: true }
            );
        if (qqCanvas)
            qqCanvas.addEventListener("contextmenu", function (e) {
                e.preventDefault();
            });
    }

    Contains(value, values_to_check) {
        if (typeof values_to_check === "string") {
            return value.includes(values_to_check);
        }
        if (Array.isArray(values_to_check)) {
            for (let val of values_to_check) {
                if (value.includes(val)) return true;
            }
        }
        return false;
    }

    UpdateSkylights(popItem) {
        let skylights = Paper.GetSkylights();

        if (popItem.babylon) {
            const section = popItem.ref.split("/")[0];
            const offSet = popItem.ref.split("/")[1];
            const index = popItem?.ref2 ? popItem.ref2.split("/")[1] : -1;

            if (popItem.is_skylight) {
                skylights[popItem.areaIndex].push({
                    Section: section,
                    Offset: offSet,
                    Index: index,
                });
            } else {
                skylights[popItem.areaIndex] = skylights[popItem.areaIndex].filter((s) => s.index === index);
            }
        }

        for (const area in skylights) {
            this.props.updateAreaSpecification(Number(area), "SKYLIGHTS", null, skylights[area]);
        }

        updateLayout2D();
        Paper.UpdateSkylights2D();
    }

    UpdateItemsInDrawing(
        name_string_to_match,
        secondard_parameter_to_match = null,
        section,
        parameter,
        default_value = ""
    ) {
        if (window.svg) {
            let values_in_areas = this.GetSpecAllAreas(section, parameter, default_value);

            if (parameter === "RoofSheetColour")
                values_in_areas.forEach(function (value, index, array) {
                    array[index] = GetHTMLColour(value)[1];
                });

            for (let key in window.svg.children) {
                if (key.startsWith(name_string_to_match)) {
                    let item = window.svg.children[key];

                    if (key.includes("area:1")) item.fillColor = new paper.Color(values_in_areas[0]);
                    if (key.includes("area:2")) item.fillColor = new paper.Color(values_in_areas[1]);
                }
            }
        }
    }

    GetSpec(areaIndex, Section, Parameter, default_value) {
        if (!window.job) return default_value;
        if (window.job) {
            if (
                window.job.AreaSpecifications &&
                window.job.AreaSpecifications[areaIndex] &&
                window.job.AreaSpecifications[areaIndex][Section] &&
                window.job.AreaSpecifications[areaIndex][Section][Parameter]
            ) {
                return window.job.AreaSpecifications[areaIndex][Section][Parameter];
            }
        }
        return default_value;
    }
    GetSpecAllAreas(Section, Parameter, default_value) {
        var values = [];
        if (!window.job) return values;
        if (window.job) {
            for (var area of window.job.AreaSpecifications) {
                if (area[Section] && area[Section][Parameter]) {
                    values.push(area[Section][Parameter]);
                } else {
                    values.push(default_value);
                }
            }
        }
        return values;
    }
}

QQ2DCanvas.propTypes = {
    classes: PropTypes.object.isRequired,
};

var existingNote;
var arrow;
var current;

function Arrow(mouseDownPoint) {
    this.start = mouseDownPoint;
    this.headLength = 120;
    this.tailLength = 45;
    this.headAngle = 25;
    this.tailAngle = 92;
}

Arrow.prototype.draw = function (point) {
    var end = this.start;
    var arrowVec = point.subtract(end);

    // parameterize {headLength: 20, tailLength: 6, headAngle: 35, tailAngle: 110}
    // construct the arrow
    var arrowHead = arrowVec.normalize(this.headLength);
    var arrowTail = arrowHead.normalize(this.tailLength);

    var p3 = end; // arrow point

    var p2 = end.add(arrowHead.rotate(-this.headAngle)); // leading arrow edge angle
    var p4 = end.add(arrowHead.rotate(this.headAngle)); // ditto, other side

    var p1 = p2.add(arrowTail.rotate(this.tailAngle)); // trailing arrow edge angle
    var p5 = p4.add(arrowTail.rotate(-this.tailAngle)); // ditto

    // specify all but the last segment, closed does that
    this.path = new paper.Path(point, p1, p2, p3, p4, p5);
    this.path.closed = true;

    this.path.strokeWidth = 1;
    this.path.strokColor = "#B200B2";
    this.path.fillColor = "#B200B2";

    return this.path;
};

export function ClearScratch() {
    if (current) current.remove();
    if (arrow) arrow = null;

    var rubberband = paper?.project?.activeLayer?.rubberband;
    if (rubberband) rubberband.removeSegments();
    var rubberband_label = paper?.project?.activeLayer?.rubberband_label;
    if (rubberband_label) rubberband_label.visible = false;
}

export const QQ2DCanvasBase = QQ2DCanvas; // Export the unwrapped version for jest test
export default connect(mapStateToProps, importedActions)(withStyles(styles)(QQ2DCanvas));
